<template>
  <div class="main-content">
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <!-- Heading -->
                <h2 class="mb-2">Budget Realization</h2>

                <!-- Text -->
                <p class="text-muted mb-md-0">Realization of budget expenditure</p>
                <div>
                  <p class="mb-md-0">&nbsp;</p>
                  <p class="mb-md-0">Budget Plan Title: {{ this.activePlan?.title }}</p>
                  <p class="mb-md-0">
                    Department:
                    {{ this.activePlan?.fund_center?.department_code }} -
                    {{ this.activePlan?.fund_center?.department_name }}
                  </p>
                  <p class="mb-md-0">Year: {{ this.activePlan?.year }}</p>
                  <p class="mb-md-0">Version: {{ this.activePlan?.version }}</p>
                </div>
              </div>
              <div class="col-md-auto"></div>
            </div>
          </div>
        </div>
        <!-- Body -->
      </div>
    </div>
    <!-- / .header -->

    <div class="container-fluid">
      <div class="card">
        <div class="card-header">Find Budget</div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-6" :style="isOpex !== true ? 'display: none' : ''">
              <label>Transaction Type :</label>
              <v-select
                class=""
                multiple
                v-model="transaction"
                :options="list_box_opex_realization"
                :reduce="(e) => e.id"
                label="account"
                :disabled="isOpex !== true ? true : false"
                @input="selectTT($event)"
              >
                <template slot="option" slot-scope="option">
                  {{ option.account }}
                </template>

                <template slot="selected-option" slot-scope="option">
                  {{ option.account }}
                </template></v-select
              >
            </div>
            <div class="col-lg-5">
              <label>GL :</label>
              <v-select class="" v-if="isOpex == true" :options="budgetOpex" multiple v-model="glOpex" :reduce="(e) => e.gl_code"> </v-select>
              <v-select
                v-if="isOpex == false"
                v-model="glCapex"
                :options="list_box_capex_realization"
                :reduce="(e) => e.gl_code"
                multiple
                label="account"
              ></v-select>
            </div>
            <div class="col-auto">
              <b-button variant="primary" class="float-end mt-4" @click="searchBudget">Search</b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <b-tabs content-class="mt-3" pills fill>
            <b-tab title="OPEX" @click="tabOpex">
              <div style="overflow: auto">
                <table class="table table-sm table-bordered table-nowrap mt-5 mb-5" v-if="isLoading == false">
                  <thead>
                    <tr>
                      <th scope="col">No</th>
                      <th scope="col">GL</th>
                      <th scope="col">Budget Item</th>
                      <th scope="col">Fund</th>
                      <th scope="col">Fund Center</th>
                      <th scope="col">Total Budget</th>
                      <th scope="col">PO Value (Rp.)</th>
                      <th scope="col">BRS In</th>
                      <th scope="col">BRs Out</th>
                      <th scope="col">Remaining Budget</th>
                      <!-- <th scope="col">Contract Name</th> -->
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody v-for="(item, index) in listOpex" :key="index">
                    <tr v-if="item.hasOwnProperty('error')">
                      <td colspan="9" class="text-center">{{ item.error }}</td>
                    </tr>
                    <tr v-if="item.hasOwnProperty('id')">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.opex_gl.gl_code }}</td>
                      <td>{{ item.budget_item.budget_item }}</td>
                      <td>{{ item.fund.fund }}</td>
                      <td>{{ item.fund.fundCenter.fund_center }}</td>
                      <td>Rp. {{ convertNumber(item.summary.totalBudget) }}</td>
                      <td>Rp. {{ convertNumber(item.summary.totalPoValue) }}</td>
                      <td>
                        Rp.
                        {{ convertNumber(item.summary.totalRemainBudgetRelocate) }}
                      </td>
                      <td>
                        Rp.
                        {{ convertNumber(item.summary.totalActualRelocateValue) }}
                      </td>
                      <td>
                        Rp.
                        {{ convertNumber(item.summary.totalRemainingBudget) }}
                      </td>
                      <!-- <td>{{ '88897621 - Contract Name 1' }}</td> -->
                      <td class="text-center">
                        <div>
                          <b-dropdown id="dropdown-dropleft" dropleft variant="primary" class="m-2">
                            <!--b-dropdown-item v-if="isUpdate" class="hovering" @click="sharePlan(item.id, 'plan_item_item_opex')">
															share
														</b-dropdown-item-->
                            <b-dropdown-item class="hovering" @click="reviewBudget(item, item.budget_item.budget_item, 'opex')">
                              View Detail
                            </b-dropdown-item>
                            <b-dropdown-item v-if="isUpdate" class="hovering" @click="detailBudget(item, item.budget_item.budget_item, 'opex')">
                              Budget Actual
                            </b-dropdown-item>
                            <b-dropdown-item class="hovering" @click="historicalLog()"> Historical Log </b-dropdown-item>
                            <b-dropdown-item v-if="isUpdate" class="hovering" @click="relocationBudget(item, item.budget_item.budget_item, 'opex')">
                              Budget Relocation
                            </b-dropdown-item>
                          </b-dropdown>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <b-skeleton-table v-if="isLoading == true" :rows="1" :columns="8" class="mt-5 mb-5" :table-props="{ bordered: true, striped: true }">
                </b-skeleton-table>
              </div>
            </b-tab>
            <b-tab title="CAPEX" @click="tabCapex">
              <div style="overflow: auto">
                <table class="table table-sm table-bordered table-nowrap mt-5 mb-5" v-if="isLoading == false">
                  <thead>
                    <tr>
                      <th scope="col">No</th>
                      <th scope="col">GL</th>
                      <th scope="col">Budget Item</th>
                      <th scope="col">Fund</th>
                      <th scope="col">Fund Center</th>
                      <th scope="col">Total Budget</th>
                      <th scope="col">PO Value (Rp.)</th>
                      <th scope="col">BRS In</th>
                      <th scope="col">BRs Out</th>
                      <th scope="col">Remaining Budget</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody v-for="(dat, index) in listCapex" :key="index">
                    <tr v-if="dat.hasOwnProperty('error')">
                      <td colspan="9" class="text-center">{{ dat.error }}</td>
                    </tr>
                    <tr v-if="dat.hasOwnProperty('id')">
                      <td>{{ index + 1 }}</td>
                      <td>{{ dat.capex_gl.gl_code }}</td>
                      <td>
                        {{ dat.account.account }}
                      </td>
                      <td>{{ dat.fund.fund }}</td>
                      <td>{{ dat.fund.fundCenter.fund_center }}</td>
                      <td>Rp. {{ convertNumber(dat.summary.totalBudget) }}</td>
                      <td>Rp. {{ convertNumber(dat.summary.totalPoValue) }}</td>
                      <td>
                        Rp.
                        {{ convertNumber(dat.summary.totalRemainBudgetRelocate) }}
                      </td>
                      <td>
                        Rp.
                        {{ convertNumber(dat.summary.totalActualRelocateValue) }}
                      </td>
                      <td>
                        Rp.
                        {{ convertNumber(dat.summary.totalRemainingBudget) }}
                      </td>
                      <td class="text-center">
                        <div>
                          <b-dropdown id="dropdown-dropleft" dropleft variant="primary" class="m-2">
                            <b-dropdown-item v-if="isUpdate" class="hovering" @click="sharePlan(dat.id, 'plan_item_capex')"> share </b-dropdown-item>
                            <b-dropdown-item class="hovering" @click="reviewBudget(dat, dat.account.account, 'capex')"> View </b-dropdown-item>
                            <b-dropdown-item v-if="isUpdate" class="hovering" @click="detailBudget(dat, dat.account.account, 'capex')">
                              Budget Actual
                            </b-dropdown-item>
                            <b-dropdown-item v-if="isUpdate" class="hovering" @click="relocationBudget(dat, dat.account.account, 'capex')">
                              Budget Relocation
                            </b-dropdown-item>
                          </b-dropdown>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <b-skeleton-table v-if="isLoading == true" :rows="1" :columns="8" class="mt-5 mb-5" :table-props="{ bordered: true, striped: true }">
                </b-skeleton-table>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <!-- :title="listBudget.budget_item.budget_item" -->
    <b-modal id="modalBudget" hide-footer @hide="onHide" dialog-class="full-width-modal">
      <!-- {{ listBudget }} -->
      <template #modal-header>
        <div>
          <h3 class="modal-title">{{ titleBudget }}</h3>
          <div>
            <p class="mb-md-0">&nbsp;</p>
            <p class="mb-md-0">Budget Plan Title: {{ activePlan?.title }}</p>
            <p class="mb-md-0">
              Department: {{ activePlan?.fund_center?.department_code }} -
              {{ activePlan?.fund_center?.department_name }}
            </p>
            <p class="mb-md-0">Year: {{ activePlan?.year }}</p>
            <p class="mb-md-0">Version: {{ activePlan?.version }}</p>
          </div>
        </div>
        <button type="button" class="close" @click="$bvModal.hide('modalBudget')">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="card">
        <div class="card-body row row-cols-1 row-cols-sm-2 row-cols-md-4 g-5">
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-layers"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetItemInfo?.totalExpense || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-book-open"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO Open</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetItemInfo?.expenseOpen || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-book"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO Closed</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetItemInfo?.expenseClose || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-cpu"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total Budget Task</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetItemInfo?.totalTask || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-clipboard"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total Contract</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetItemInfo?.totalContract || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-clipboard"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO Linked to Contract</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetItemInfo?.totalPoLinkedContract || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total Budget</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ `${convertNumber(selectedRow?.summary?.totalBudget) || 0}` }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO Value</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ `${convertNumber(selectedRow?.summary?.totalPoValue) || 0}` }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total Payment</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ `${convertNumber(budgetItemInfo?.totalDpp) || 0}` }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total BRS In</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ `${convertNumber(selectedRow?.summary?.totalRemainBudgetRelocate) || 0}` }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total BRS Out</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ `${convertNumber(selectedRow?.summary?.totalActualRelocateValue) || 0}` }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total Remaining Budget</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ `${convertNumber(selectedRow?.summary?.totalRemainingBudget) || 0}` }}</span>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>Budget Task</label>
        <b-form-select
          v-if="listBudget"
          v-model="selectedTask"
          value-field="id"
          text-field="name"
          :options="listBudget"
          @input="changeTask('yes', listBudget)"
        ></b-form-select>
      </div>
      <div class="card" v-if="selectedTask && loadingSave == false">
        <div class="card-header">
          <div class="card-title mb-3 font-weight-bold">Detail Budget Task</div>
        </div>
        <div class="card-body row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-5">
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-edit"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Budget Task</h4>
                <small class="text-body-secondary">
                  <span>{{ this.selectingPO[0]?.name }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-layers"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetTaskInfo?.totalExpense || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-book-open"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO Open</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetTaskInfo?.expenseOpen || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-book"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO Closed</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetTaskInfo?.expenseClose || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-link"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO Linked to Contract</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetTaskInfo?.linkedContract || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total Budget</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ convertNumber(this.selectingPO[0]?.total) }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO Value</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ convertNumber(this.selectingPO[0]?.tempPoValue) }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total payment</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ convertNumber(this.budgetTaskInfo.totalDpp) }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Brs In</h4>
                <small class="text-body-secondary">
                  Rp.
                  {{ convertNumber(this.selectingPO[0]?.remainingBudgetRelocate) }}
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Brs Out</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ convertNumber(this.selectingPO[0]?.actualRelocate) }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Remaining Budget</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ convertNumber(this.selectingPO[0]?.remaining_budget) }}</span>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card" v-if="selectedTask && loadingSave == false">
        <div class="card-header">
          <div class="card-title mb-3 font-weight-bold">Contract</div>
        </div>
        <div class="card-body">
          <div class="mb-3">
            <b-button variant="primary" size="sm" class="mr-3" @click="openUcontractPage">
              <span class="fe fe-plus-circle"></span>
              New Contract
            </b-button>
            <b-button v-b-modal.modal-link-to-contract variant="info" size="sm">
              <span class="fe fe-share-2"></span>
              Link To Contract
            </b-button>
          </div>
          <div style="overflow: auto">
            <table class="table table-sm table-bordered table-nowrap">
              <thead>
                <tr>
                  <th>Contract Name</th>
                  <th>Total PO</th>
                  <th>Total Contract Duration Detail</th>
                  <th>Total TOP</th>
                  <th>Contract Duration</th>
                  <th>Contract Value</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!selectingPO[0]?.contract_budget || selectingPO[0]?.contract_budget.length === 0">
                  <td colspan="7" class="text-center">No Data</td>
                </tr>
                <template v-else>
                  <tr v-for="(item, indx) in selectingPO[0]?.contract_budget" :key="indx">
                    <td>{{ item.contract.name }}</td>
                    <td>Rp. {{ convertNumber(item?.contract?.total_po) }}</td>
                    <td>
                      {{ item?.contract?.total_contract_duration_detail }}
                    </td>
                    <td>{{ convertNumber(item?.contract?.total_top) }} %</td>
                    <td>{{ item?.contract?.total_duration }} Month</td>
                    <td>Rp. {{ convertNumber(item?.contract?.contract_value) }}</td>
                    <td class="text-center">
                      <b-button
                        v-b-modal.modal-detail-contract
                        @click="selectedContract = item"
                        class="mr-2"
                        size="sm"
                        variant="info"
                        v-b-popover.hover.top="'View'"
                      >
                        <span class="fe fe-eye"></span>
                      </b-button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="mb-3" v-if="selectedTask && loadingSave == false">
        <div class="row justify-content-end">
          <div class="col-12 col-sm-6 col-md-3 col-lg-2">
            <b-button @click="openCreatePo()" variant="primary" size="sm" class="col-12">
              <span class="fe fe-plus-circle"></span>
              New Expenses
            </b-button>
          </div>
        </div>
        <div class="card mt-3">
          <div class="card-body">
            <strong class="mb-3">Filter Expense</strong>
            <div class="row row-cols-1 row-cols-md-3 g-2">
              <div class="col">
                <label
                  >Search PO
                  <span
                    class="fe fe-alert-circle"
                    v-b-popover.hover.top="
                      'Search by ( PR Number, PO Number, PO Name ), Can Search Multiple Data by adding separator , (example: 1111111111,2222222222)'
                    "
                  ></span>
                </label>
                <input type="text" class="form-control" v-model="searchQuery" />
              </div>
              <div class="col">
                <label>Filter Project Tag </label>
                <v-select
                  v-model="filterTag"
                  :options="listProjectTags"
                  label="name"
                  :reduce="(option) => option.id"
                  :clearable="true"
                  :searchable="true"
                ></v-select>
              </div>
              <div class="col">
                <label>Filter Contract </label>
                <v-select
                  v-model="filterContract"
                  :options="listFilterContract"
                  :reduce="(option) => option.id"
                  :clearable="true"
                  :searchable="true"
                  label="name"
                >
                </v-select>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <label>Total PO</label>
                <vue-numeric class="form-control" currency="Rp. " separator="," v-model="filterTotalPO" disabled />
              </div>
              <div class="col-12 col-md-6">
                <label>Total DPP</label>
                <vue-numeric class="form-control" currency="Rp. " separator="," v-model="filterTotalDPP" disabled />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="selectedIds.length > 0"
          class="alert alert-warning alert-dismissible fade show d-flex justify-content-between align-items-center"
          role="alert"
        >
          <strong>{{ selectedIds.length }} rows selected</strong>
          <button type="button" class="btn btn-primary btn-sm" v-b-modal.modal-email @click="emailForm">Send to Email</button>
        </div>
      </div>
      <b-skeleton-table v-if="selectedTask && loadingSave == true" :rows="1" :columns="3" :table-props="{ bordered: true, striped: true }" />
      <b-skeleton-table v-if="selectedTask && loadingSave == true" :rows="1" :columns="5" :table-props="{ bordered: true, striped: true }" />
      <b-skeleton-table v-if="selectedTask && loadingSave == true" :rows="0" :columns="1" :table-props="{ bordered: true, striped: true }" />
      <div id="poScroll" style="overflow: auto; max-height: 400px" v-if="selectedTask && loadingSave == false">
        <table class="table table-sm table-bordered table-nowrap table-pr-po" style="table-layout: fixed; word-wrap: break-word">
          <thead>
            <tr>
              <th class="sticky-header-po" style="width: 50px" scope="col">
                <input type="checkbox" :checked="allSelected" @change="toggleAllIds" />
              </th>
              <th class="sticky-header-po" style="width: 200px" scope="col">Action</th>
              <th class="sticky-header-po" style="width: 100px" scope="col">Status PO</th>
              <th class="sticky-header-po" style="width: 150px" scope="col">Status Email</th>
              <th class="sticky-header-po" style="width: 220px" scope="col">Contract Name</th>
              <th class="sticky-header-po" style="width: 220px" scope="col">Contract Detail</th>
              <th class="sticky-header-po" style="width: 220px" scope="col">PO Value (Rp.)</th>
              <th class="sticky-header-po" style="width: 220px" scope="col">Total DPP</th>
              <th class="sticky-header-po" style="width: 220px; cursor: pointer" @click="sortingPRNumber" scope="col">
                PR Number
                <span v-if="sortPRNumber == 'none'" class="fe fe-more-vertical" style="float: right"></span
                ><span v-if="sortPRNumber == 'asc'" class="fe fe-chevron-down" style="float: right"></span
                ><span v-if="sortPRNumber == 'desc'" class="fe fe-chevron-up" style="float: right"></span>
              </th>
              <th class="sticky-header-po" style="width: 220px; cursor: pointer" @click="sortingPRDate" scope="col">
                PR Date
                <span v-if="sortPRDate == 'none'" class="fe fe-more-vertical" style="float: right"></span
                ><span v-if="sortPRDate == 'asc'" class="fe fe-chevron-down" style="float: right"></span
                ><span v-if="sortPRDate == 'desc'" class="fe fe-chevron-up" style="float: right"></span>
              </th>
              <th class="sticky-header-po" style="width: 220px; cursor: pointer" @click="sortingPONumber" scope="col">
                PO Number
                <span v-if="sortPONumber == 'none'" class="fe fe-more-vertical" style="float: right"></span
                ><span v-if="sortPONumber == 'asc'" class="fe fe-chevron-down" style="float: right"></span
                ><span v-if="sortPONumber == 'desc'" class="fe fe-chevron-up" style="float: right"></span>
              </th>
              <th class="sticky-header-po" style="width: 220px; cursor: pointer" @click="sortingPOName" scope="col">
                PR Name
                <span v-if="sortPOName == 'none'" class="fe fe-more-vertical" style="float: right"></span
                ><span v-if="sortPOName == 'asc'" class="fe fe-chevron-down" style="float: right"></span
                ><span v-if="sortPOName == 'desc'" class="fe fe-chevron-up" style="float: right"></span>
              </th>
              <th class="sticky-header-po" style="width: 220px; cursor: pointer" @click="sortingPODate" scope="col">
                PO Date
                <span v-if="sortPODate == 'none'" class="fe fe-more-vertical" style="float: right"></span
                ><span v-if="sortPODate == 'asc'" class="fe fe-chevron-down" style="float: right"></span
                ><span v-if="sortPODate == 'desc'" class="fe fe-chevron-up" style="float: right"></span>
              </th>
              <th class="sticky-header-po" style="width: 220px" scope="col">IM Numer</th>
              <th class="sticky-header-po" style="width: 140px" scope="col">Items</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!paginatedItems || paginatedItems.length === 0">
              <td colspan="15" class="text-center">No Data</td>
            </tr>
            <template v-else>
              <tr v-for="(item, indx) in paginatedItems" :key="indx">
                <!-- <td>{{ item.name }}</td>
                <td>Rp. {{ convertNumber(item.total) }}</td> -->
                <td>
                  <input type="checkbox" v-model="selectedIds" :value="item.id" />
                </td>
                <td class="text-center field-action">
                  <b-button
                    v-if="item.hasOwnProperty('is_closed') && item.is_closed == false"
                    @click="closePO(item.id)"
                    class="mr-2"
                    size="sm"
                    variant="primary"
                    v-b-popover.hover.top="'Close PO'"
                  >
                    <span class="fe fe-x-circle"></span>
                  </b-button>
                  <b-button
                    class="mr-2"
                    size="sm"
                    variant="danger"
                    v-b-popover.hover.top="
                      'PR/PO tidak bisa dihapus karena masih ada minimal 1 payment didalamnya, Silahkah hapus payment untuk menghapus PR/PO'
                    "
                    v-if="Number(item.totalDpp) > 0"
                  >
                    <span class="fe fe-help-circle"></span>
                  </b-button>
                  <b-button
                    @click="deleteRow(item, indx)"
                    class="mr-2"
                    size="sm"
                    variant="danger"
                    v-b-popover.hover.top="'Delete PO'"
                    v-if="Number(item.totalDpp) == 0"
                  >
                    <span class="fe fe-trash-2"></span>
                  </b-button>
                  <b-button @click="openEditPo(item, indx)" class="mr-2" size="sm" variant="warning" v-b-popover.hover.top="'Edit PO'">
                    <span class="fe fe-edit-2"></span>
                  </b-button>
                  <!-- <b-button
                    v-b-modal.modal-detail-contract-po-pr
                    class="mr-2" size="sm" variant="info" v-b-popover.hover.top="'View'">
                    <span class="fe fe-eye"></span>
                  </b-button> -->
                  <!-- <b-button
                    v-b-modal.modal-new-contract-form
                    class="mr-2" size="sm" variant="success" v-b-popover.hover.top="'Add Contract'">
                    <span class="fe fe-plus-circle"></span>
                  </b-button> -->
                </td>
                <td class="text-center">
                  <div v-if="item.hasOwnProperty('is_closed')">
                    <span v-if="item.is_closed == false" class="badge bg-success-soft">OPEN</span>
                    <span v-else class="badge bg-danger-soft">CLOSED</span>
                  </div>
                  <div v-else>-</div>
                </td>
                <td class="text-center">
                  <div v-if="item.hasOwnProperty('is_closed')">
                    <span class="badge bg-warning ml-2">Email Sent ({{ item.counted_email }})</span>
                  </div>
                  <div v-else>-</div>
                </td>
                <td class="text-center">
                  <!-- 88897621 - Contract Name 1 -->
                  {{ item.contract_name }}
                </td>
                <td class="text-center">
                  {{ item.contract_detail_name }}
                </td>
                <td>
                  Rp. {{ convertNumber(item.po_value) }}
                  <!-- <vue-numeric :disabled="item.is_closed == true" v-model="item.po_value" class="form-control"
                    currency="Rp. " separator="," /> -->
                </td>
                <td>Rp. {{ convertNumber(item.totalDpp) }}</td>
                <!-- <td>Rp. {{ convertNumber(item.remaining_budget) }}</td> -->
                <td>
                  {{ item.pr_subject }}
                  <!-- <input :disabled="item.is_closed == true" v-model="item.pr_subject" maxlength='10'
                    @keypress="isNumberInput($event)" type="text" class="form-control" v-validate="'min:10'"
                    :name="`${indx+1} PR Number`"> -->
                  <span class="text-sm text-danger" v-show="errors.has(`${indx + 1} PR Number`)">PR Number in this line is less than 10 digits</span>
                </td>
                <td>
                  {{ item.pr_date }}
                  <!-- <date-picker :disabled="item.is_closed == true" v-model="item.pr_date" class="w-100 border-0"
                    valueType="format" /> -->
                </td>
                <td>
                  {{ item.po_subject }}
                  <!-- <input :disabled="item.is_closed == true" v-model="item.po_subject" maxlength='10'
                    @keypress="isNumberInput($event)" type="text" class="form-control" v-validate="'min:10'"
                    :name="`${indx+1} PO Number`"> -->
                  <span class="text-sm text-danger" v-show="errors.has(`${indx + 1} PO Number`)">PO Number in this line is less than 10 digits</span>
                </td>
                <td>
                  {{ item.po_name }}
                  <!-- <input :disabled="item.is_closed == true" v-model="item.po_name" type="text" class="form-control"> -->
                </td>
                <td>
                  {{ item.po_date }}
                  <!-- <date-picker :disabled="item.is_closed == true" v-model="item.po_date" class="w-100 border-0"
                    valueType="format" /> -->
                </td>
                <td>
                  {{ item.im_number ? `${item.im_number?.im_number} - ${item.im_number?.name}` : '-' }}
                  <!-- <date-picker :disabled="item.is_closed == true" v-model="item.po_date" class="w-100 border-0"
                    valueType="format" /> -->
                </td>
                <td>
                  <b-button
                    variant="primary"
                    size="sm"
                    @click="newItem(item, item.code_actual_budget, indx, item.is_closed, false, item.po_value, item.id)"
                  >
                    Detail Payment
                  </b-button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <!-- <nav aria-label="Page navigation example" class="mt-3" v-if="selectedTask && loadingSave == false">
        <ul class="pagination justify-content-center">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <a class="page-link" href="#" @click="prevPage" tabindex="-1">Previous</a>
          </li>
          
          <li v-for="page in totalPages" :key="page" class="page-item" :class="{ active: currentPage === page }">
            <a class="page-link" href="#" @click="goToPage(page)">
              {{ page }}
            </a>
          </li>
          
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <a class="page-link" href="#" @click="nextPage">Next</a>
          </li>
        </ul>
      </nav> -->
      <nav aria-label="Page navigation example" class="mt-3" v-if="selectedTask && loadingSave == false">
        <ul class="pagination justify-content-end">
          <!-- Previous Button -->
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <a class="page-link" href="#" @click="prevPage" tabindex="-1">Previous</a>
          </li>

          <!-- First Page -->
          <li v-if="currentPage > 3" class="page-item">
            <a class="page-link" href="#" @click="goToPage(1)">1</a>
          </li>

          <!-- Ellipsis before the current page range -->
          <li v-if="currentPage > 4" class="page-item disabled">
            <span class="page-link">...</span>
          </li>

          <!-- Page Numbers -->
          <li v-for="page in pageRange" :key="page" class="page-item" :class="{ active: currentPage === page }">
            <a class="page-link" href="#" @click="goToPage(page)">
              {{ page }}
            </a>
          </li>

          <!-- Ellipsis after the current page range -->
          <li v-if="currentPage < totalPages - 3" class="page-item disabled">
            <span class="page-link">...</span>
          </li>

          <!-- Last Page -->
          <li v-if="currentPage < totalPages - 2" class="page-item">
            <a class="page-link" href="#" @click="goToPage(totalPages)">{{ totalPages }}</a>
          </li>

          <!-- Next Button -->
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <a class="page-link" href="#" @click="nextPage">Next</a>
          </li>
        </ul>
      </nav>

      <!-- <div class="card shadow-none mt-3 border-secondary" v-if="selectedTask && loadingSave == false" style="
                      border-style: dashed;
                      background: none;
                      cursor: pointer;
                    " @click.prevent="addBudgetTask()">
        <div class="card-body">
          <div class="d-flex text-secondary w-100" style="align-items: center; justify-content: center">
            New Expenses
          </div>
        </div>
      </div> -->
      <!-- <div>
        <b-button variant="primary" v-if="selectedTask && loadingSave == false" class="float-end" @click="afterValue">
          Save</b-button>
      </div> -->
    </b-modal>
    <b-modal size="xl" id="modalReview" :title="titleBudget" hide-footer @hide="onHide" dialog-class="full-width-modal">
      <!-- {{ listBudget }} -->
      <div class="card">
        <div class="card-body row row-cols-1 row-cols-sm-2 row-cols-md-4 g-5">
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-layers"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetItemInfo?.totalExpense || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-book-open"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO Open</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetItemInfo?.expenseOpen || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-book"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO Closed</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetItemInfo?.expenseClose || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-cpu"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total Budget Task</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetItemInfo?.totalTask || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-clipboard"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total Contract</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetItemInfo?.totalContract || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-clipboard"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO Linked to Contract</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetItemInfo?.totalPoLinkedContract || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total Budget</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ `${convertNumber(selectedRow?.summary?.totalBudget) || 0}` }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO Value</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ `${convertNumber(selectedRow?.summary?.totalPoValue) || 0}` }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total Payment</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ `${convertNumber(budgetItemInfo?.totalDpp) || 0}` }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total BRS In</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ `${convertNumber(selectedRow?.summary?.totalRemainBudgetRelocate) || 0}` }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total BRS Out</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ `${convertNumber(selectedRow?.summary?.totalActualRelocateValue) || 0}` }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total Remaining Budget</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ `${convertNumber(selectedRow?.summary?.totalRemainingBudget) || 0}` }}</span>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>Budget Task</label>
        <b-form-select
          v-if="listBudget"
          v-model="selectedTask"
          value-field="id"
          text-field="name"
          :options="listBudget"
          @input="changeTask('no', listBudget)"
        ></b-form-select>
      </div>
      <div class="card" v-if="selectedTask && loadingSave == false">
        <div class="card-header">
          <div class="card-title mb-3 font-weight-bold">Detail Budget Task</div>
        </div>
        <div class="card-body row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-5">
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-edit"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Budget Task</h4>
                <small class="text-body-secondary">
                  <span>{{ this.selectingPO[0]?.name }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-layers"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetTaskInfo?.totalExpense || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-book-open"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO Open</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetTaskInfo?.expenseOpen || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-book"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO Closed</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetTaskInfo?.expenseClose || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-link"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO Linked to Contract</h4>
                <small class="text-body-secondary">
                  <span>{{ budgetTaskInfo?.linkedContract || 0 }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total Budget</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ convertNumber(this.selectingPO[0]?.total) }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total PO Value</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ convertNumber(this.selectingPO[0]?.tempPoValue) }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Total Payment</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ convertNumber(this.budgetTaskInfo?.totalDpp) }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Brs In</h4>
                <small class="text-body-secondary">
                  Rp.
                  {{ convertNumber(this.selectingPO[0]?.remainingBudgetRelocate) }}
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Brs Out</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ convertNumber(this.selectingPO[0]?.actualRelocate) }}</span>
                </small>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row align-items-center">
              <div class="col-auto">
                <div class="avatar avatar-sm">
                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                    <i class="fe fe-dollar-sign"></i>
                  </div>
                </div>
              </div>
              <div class="col ms-n2">
                <h4 class="mb-1 font-weight-bold">Remaining Budget</h4>
                <small class="text-body-secondary">
                  <span>Rp. {{ convertNumber(this.selectingPO[0]?.remaining_budget) }}</span>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card" v-if="selectedTask && loadingSave == false">
        <div class="card-header">
          <div class="card-title mb-3 font-weight-bold">Contract</div>
        </div>
        <div class="card-body">
          <div style="overflow: auto">
            <table class="table table-sm table-bordered table-nowrap">
              <thead>
                <tr>
                  <th>Contract Name</th>
                  <th>Total PO</th>
                  <th>Total Contract Duration Detail</th>
                  <th>Total TOP</th>
                  <th>Contract Duration</th>
                  <th>Contract Value</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!selectingPO[0]?.contract_budget || selectingPO[0]?.contract_budget.length === 0">
                  <td colspan="7" class="text-center">No Data</td>
                </tr>
                <template v-else>
                  <tr v-for="(item, indx) in selectingPO[0]?.contract_budget" :key="indx">
                    <td>{{ item.contract.name }}</td>
                    <td>Rp. {{ convertNumber(item?.contract?.total_po) }}</td>
                    <td>
                      {{ item?.contract?.total_contract_duration_detail }}
                    </td>
                    <td>{{ convertNumber(item?.contract?.total_top) }} %</td>
                    <td>{{ item?.contract?.total_duration }} Month</td>
                    <td>Rp. {{ convertNumber(item?.contract?.contract_value) }}</td>
                    <td class="text-center">
                      <b-button
                        v-b-modal.modal-detail-contract
                        @click="selectedContract = item"
                        class="mr-2"
                        size="sm"
                        variant="info"
                        v-b-popover.hover.top="'View'"
                      >
                        <span class="fe fe-eye"></span>
                      </b-button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <b-skeleton-table v-if="selectedTask && loadingSave == true" :rows="1" :columns="3" :table-props="{ bordered: true, striped: true }" />
      <b-skeleton-table v-if="selectedTask && loadingSave == true" :rows="1" :columns="5" :table-props="{ bordered: true, striped: true }" />
      <b-skeleton-table v-if="selectedTask && loadingSave == true" :rows="0" :columns="1" :table-props="{ bordered: true, striped: true }" />
      <div v-if="selectedTask">
        <b-tabs content-class="mt-3" pills>
          <div style="overflow: auto; max-height: 570px">
            <b-tab title="Actual Expenses">
              <table class="table table-sm table-bordered table-nowrap" style="table-layout: fixed; word-wrap: break-word">
                <thead>
                  <tr>
                    <th class="sticky-header-po" style="width: 130px" scope="col">Status</th>
                    <th class="sticky-header-po" style="width: 220px" scope="col">PO Value (Rp.)</th>
                    <th class="sticky-header-po" style="width: 220px" scope="col">Total DPP</th>
                    <th class="sticky-header-po" style="width: 270px" scope="col">PR Number</th>
                    <th class="sticky-header-po" style="width: 220px" scope="col">PR Date</th>
                    <th class="sticky-header-po" style="width: 270px" scope="col">PO Number</th>
                    <th class="sticky-header-po" style="width: 700px" scope="col">PO Name</th>
                    <th class="sticky-header-po" style="width: 220px" scope="col">PO Date</th>
                    <th class="sticky-header-po" style="width: 140px" scope="col">Items</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, indx) in this.selectingPO[0]?.actual_budget" :key="indx">
                    <!-- <td>{{ item.name }}</td>
              <td>Rp. {{ convertNumber(item.total) }}</td> -->
                    <td class="text-center">
                      <span v-if="item.is_closed == false" class="badge bg-success-soft">OPEN</span>
                      <span v-else class="badge bg-danger-soft">CLOSED</span>
                    </td>
                    <td>Rp. {{ convertNumber(item.po_value) }}</td>
                    <td>Rp. {{ convertNumber(item.totalDpp) }}</td>
                    <!-- <td>Rp. {{ convertNumber(item.remaining_budget) }}</td> -->
                    <td>{{ item.pr_subject }}</td>
                    <td>
                      {{ convertMonth(item.pr_date) }}
                    </td>
                    <td>{{ item.po_subject }}</td>
                    <td>{{ item.po_name }}</td>
                    <td>
                      {{ convertMonth(item.po_date) }}
                    </td>
                    <td class="text-center">
                      <b-button
                        variant="primary"
                        size="sm"
                        @click="newItem(item, item.code_actual_budget, indx, item.is_closed, true, item.po_value, item.id)"
                      >
                        Detail Payment
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
          </div>
          <b-tab title="Relocation Budget">
            <b-tabs content-class="mt-3" pills fill>
              <b-tab title="Int to Ext">
                <div style="overflow: auto">
                  <table class="table table-sm table-bordered table-nowrap table-relocate" style="table-layout: fixed; word-wrap: break-word">
                    <thead>
                      <tr>
                        <th style="width: 220px" scope="col">Department Sender</th>
                        <th style="width: 220px" scope="col">Department Recipient</th>
                        <th style="width: 220px" scope="col">Type</th>
                        <th style="width: 400px" scope="col">New GL Number</th>
                        <th style="width: 200px" scope="col">New Fund Number</th>
                        <th style="width: 400px" scope="col">New Budget Task</th>
                        <th style="width: 340px" scope="col">Delivery Date</th>
                        <th style="width: 300px" scope="col">Relocation Value</th>
                        <th style="width: 300px" scope="col">IM Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, indx) in intExt" :key="indx">
                        <td>
                          <div v-if="item?.department_from">
                            {{ item?.department_from ? item?.department_from?.code : '-' }}
                            -
                            {{ item?.department_from ? item?.department_from.name : '-' }}
                          </div>
                          <div v-else>-</div>
                        </td>
                        <td>
                          <div v-if="item?.department_to">
                            {{ item?.department_to ? item?.department_to?.code : '-' }}
                            -
                            {{ item?.department_to ? item?.department_to?.name : '-' }}
                          </div>
                          <div v-else>-</div>
                        </td>
                        <td>
                          {{ item?.opex_gl_id != null ? 'OPEX' : 'CAPEX' }}
                        </td>
                        <td>
                          <div v-if="item?.opex_gl_id || item?.capex_gl_id">
                            {{
                              item?.opex_gl_id != null
                                ? `${item?.opex_gl?.gl_code} - ${item?.opex_gl?.budgetItem?.budget_item}`
                                : `${item?.capex_gl?.gl_code} - ${item?.capex_gl?.account?.account}`
                            }}
                          </div>
                          <div v-else>-</div>
                        </td>
                        <td>
                          {{ item?.fund ? item?.fund?.fund : '-' }}
                        </td>
                        <td>
                          {{ item?.budget_to ? item?.budget_to?.name : item.budget_task ? item.budget_task : '-' }}
                        </td>
                        <td>
                          {{ convertMonth(item.delivery_date) }}
                        </td>
                        <td>Rp. {{ convertNumber(item.relocate_value) }}</td>
                        <td>
                          <a :href="item?.im_number?.attachments[0]?.url" v-if="item?.im_number" target="_blank">{{ item?.im_number?.im_number }}</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>
              <b-tab title="Int to Int">
                <div style="overflow: auto">
                  <table class="table table-sm table-bordered table-nowrap table-relocate" style="table-layout: fixed; word-wrap: break-word">
                    <thead>
                      <tr>
                        <th style="width: 220px" scope="col">Department From</th>
                        <th style="width: 220px" scope="col">Department To</th>
                        <th style="width: 220px" scope="col">Relocate Type</th>
                        <th style="width: 220px" scope="col">Type</th>
                        <th style="width: 400px" scope="col">New GL Number</th>
                        <th style="width: 200px" scope="col">New Fund Number</th>
                        <th style="width: 400px" scope="col">New Budget Task</th>
                        <th style="width: 300px" scope="col">Delivery Date</th>
                        <th style="width: 300px" scope="col">Relocation Value</th>
                        <th style="width: 300px" scope="col">IM Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, indx) in intInt" :key="indx">
                        <template v-if="item.hasOwnProperty('id')">
                          <td>
                            {{ item?.department_from ? item?.department_from?.code : '-' }}
                            -
                            {{ item?.department_from ? item?.department_from?.name : '-' }}
                          </td>
                          <td>
                            {{ item?.department_to ? item?.department_to?.code : '-' }}
                            -
                            {{ item?.department_to ? item?.department_to?.name : '-' }}
                          </td>
                          <td>
                            {{ item.hasOwnProperty('relocate_type') ? relocateds(item?.relocate_type) : '-' }}
                          </td>
                          <td>
                            <div v-if="item?.relocate_type === 'INT-INT-TO'">
                              {{ item?.budget_task_to?.opex_gl != null ? 'OPEX' : 'CAPEX' }}
                              ->
                              {{ item?.budget_task_from?.opex_gl != null ? 'OPEX' : 'CAPEX' }}
                            </div>
                            <div v-else>
                              {{ item?.budget_task_from?.opex_gl != null ? 'OPEX' : 'CAPEX' }}
                              ->
                              {{ item?.budget_task_to?.opex_gl != null ? 'OPEX' : 'CAPEX' }}
                            </div>
                          </td>
                          <td>
                            <div v-if="item?.relocate_type === 'INT-INT-TO'">
                              <span v-if="item?.opex_gl_id || item?.capex_gl_id">
                                {{
                                  item?.opex_gl_id != null
                                    ? `${item?.opex_gl?.gl_code} - ${item?.opex_gl?.budgetItem?.budget_item} -> `
                                    : `${item?.capex_gl?.gl_code} - ${item?.capex_gl?.account?.account} -> `
                                }}
                              </span>
                              <span v-else> - </span>
                              {{ selectingPO[0]?.opex?.opex_gl?.gl_code ? selectingPO[0]?.opex?.opex_gl?.gl_code : '' }}
                              {{ selectingPO[0]?.capex?.capex_gl?.gl_code ? selectingPO[0]?.capex?.capex_gl?.gl_code : '' }}
                              -
                              {{
                                selectingPO[0]?.opex?.opex_gl?.budgetItem?.budget_item ? selectingPO[0]?.opex?.opex_gl?.budgetItem?.budget_item : ''
                              }}
                              {{ selectingPO[0]?.capex?.capex_gl?.account?.account ? selectingPO[0]?.capex?.capex_gl?.account?.account : '' }}
                            </div>
                            <div v-else>
                              {{ selectingPO[0]?.opex?.opex_gl?.gl_code ? selectingPO[0]?.opex?.opex_gl?.gl_code : '' }}
                              {{ selectingPO[0]?.capex?.capex_gl?.gl_code ? selectingPO[0]?.capex?.capex_gl?.gl_code : '' }}
                              -
                              {{
                                selectingPO[0]?.opex?.opex_gl?.budgetItem?.budget_item
                                  ? selectingPO[0]?.opex?.opex_gl?.budgetItem?.budget_item + ' ->'
                                  : ''
                              }}
                              {{ selectingPO[0]?.capex?.capex_gl?.account?.account ? selectingPO[0]?.capex?.capex_gl?.account?.account + ' ->' : '' }}

                              <span v-if="item?.opex_gl_id || item?.capex_gl_id">
                                {{
                                  item?.opex_gl_id != null
                                    ? `${item?.opex_gl?.gl_code} - ${item?.opex_gl?.budgetItem?.budget_item}`
                                    : `${item?.capex_gl?.gl_code} - ${item?.capex_gl?.account?.account}`
                                }}
                              </span>
                              <span v-else> - </span>
                            </div>
                          </td>
                          <td>
                            <div v-if="item?.relocate_type === 'INT-INT-TO'">
                              {{ item?.fund ? item?.fund?.fund : '-' }} ->
                              {{ selectingPO[0]?.opex ? selectingPO[0]?.opex?.fund?.fund : '' }}
                              {{ selectingPO[0]?.capex ? selectingPO[0]?.capex?.fund?.fund : '' }}
                            </div>
                            <div v-else>
                              {{ selectingPO[0]?.opex ? selectingPO[0]?.opex?.fund?.fund : '' }}
                              {{ selectingPO[0]?.capex ? selectingPO[0]?.capex?.fund?.fund : '' }}
                              -> {{ item?.fund ? item?.fund?.fund : '-' }}
                            </div>
                          </td>
                          <td>
                            <div v-if="item?.relocate_type === 'INT-INT-TO'">
                              {{ item?.budget_to ? item?.budget_to?.name : item.budget_task ? item.budget_task : '-' }}
                              -> {{ selectingPO[0]?.name }}
                            </div>
                            <div v-else>
                              {{ selectingPO[0]?.name }} ->
                              {{ item?.budget_to ? item?.budget_to?.name : item.budget_task ? item.budget_task : '-' }}
                            </div>
                          </td>
                          <td v-if="item?.relocate_type === 'INT-INT-FROM'">
                            {{ item?.delivery_date ? convertMonth(item?.delivery_date) : '-' }}
                            <!-- <date-picker v-model="item.delivery_date" class="w-100 border-0" valueType="format" :disabled="item.relocate_type == 'INT-INT-TO'" /> -->
                          </td>
                          <td v-if="item?.relocate_type === 'INT-INT-TO'">
                            {{ item?.delivery_date ? convertMonth(item?.delivery_date) : '-' }}
                          </td>
                          <td v-if="item?.relocate_type === 'INT-INT-FROM'">
                            Rp.
                            {{ item?.relocate_value ? convertNumber(item?.relocate_value) : '-' }}
                            <!-- <vue-numeric v-model="item.relocate_value" class="form-control" currency="Rp. " separator="," :disabled="item.relocate_type == 'INT-INT-TO'" /> -->
                          </td>
                          <td v-if="item?.relocate_type === 'INT-INT-TO'">
                            Rp.
                            {{ item?.relocate_value ? convertNumber(item?.relocate_value) : '-' }}
                          </td>
                          <td v-if="item.relocate_type === 'INT-INT-FROM'">
                            {{ item?.im_number ? `${item?.im_number.im_number} - ${item?.im_number.name}` : '-' }}
                            <!-- <v-select v-model="item.im_number_id" :options="listIM" :reduce="(e) => e.id" label="label" :disabled="item.relocate_type == 'INT-INT-TO'">
                          </v-select> -->
                          </td>
                          <td v-if="item?.relocate_type === 'INT-INT-TO'">
                            {{ item?.im_number ? `${item?.im_number?.im_number} - ${item?.im_number?.name}` : '-' }}
                          </td>
                        </template>
                        <template v-else>
                          <td class="text-center">
                            <span class="fe fe-x-circle text-danger" style="cursor: pointer" @click="removeRow(indx)"></span>
                          </td>
                          <td>
                            {{ item.department_from ? item.department_from.code : '-' }}
                            -
                            {{ item.department_from ? item.department_from.name : '-' }}
                          </td>
                          <td>
                            {{ item.department_to ? item.department_to.code : '-' }}
                            -
                            {{ item.department_to ? item.department_to.name : '-' }}
                          </td>
                          <td>
                            {{ item.hasOwnProperty('relocate_type') ? item.relocate_type : '-' }}
                          </td>
                          <td>
                            <v-select :options="typeOf()" v-model="item.type" @input="changeGL($event, indx, item.fund_center_id)"></v-select>
                          </td>
                          <td>
                            <v-select
                              :options="item.options"
                              v-model="item.opex_gl_id"
                              label="label"
                              :reduce="(e) => e.id"
                              @input="selectedFund($event, indx, item.type)"
                              :name="`${indx + 1} GL Number`"
                              v-validate="'required'"
                              v-if="item.type == 'OPEX'"
                            >
                            </v-select>
                            <v-select
                              :options="item.options"
                              v-model="item.capex_gl_id"
                              label="label"
                              :reduce="(e) => e.id"
                              @input="selectedFund($event, indx, item.type)"
                              :name="`${indx + 1} GL Number`"
                              v-validate="'required'"
                              v-if="item.type == 'CAPEX'"
                            >
                            </v-select>
                            <span class="text-sm text-danger" v-show="errors.has(`${indx + 1} GL Number`)"
                              >GL Number in this line must be filled</span
                            >
                          </td>
                          <td>
                            {{ item.fund ? item.fund : '-' }}
                          </td>
                          <td>
                            <v-select
                              :loading="loadingTask"
                              :options="item.listTask"
                              v-model="item.budget_task"
                              label="name"
                              :reduce="(e) => e.code"
                              :name="`${indx + 1} Budget Task`"
                              v-validate="'required'"
                            >
                            </v-select>
                            <span class="text-sm text-danger" v-show="errors.has(`${indx + 1} Budget Task`)"
                              >Budget Task in this line must be filled</span
                            >
                          </td>
                          <td>
                            <div style="display: flex; flex-direction: column; align-items: flex-start; width: 100%">
                              <date-picker
                                v-model="item.delivery_date"
                                class="w-100 border-0"
                                valueType="format"
                                :name="`${indx + 1} Delivery Date`"
                                v-validate="'required'"
                              />
                              <span class="text-sm text-danger" v-show="errors.has(`${indx + 1} Delivery Date`)"
                                >Delivery Date in this line must be filled</span
                              >
                            </div>
                          </td>
                          <td>
                            <vue-numeric
                              v-model="item.relocate_value"
                              class="form-control"
                              currency="Rp. "
                              separator=","
                              :name="`${indx + 1} Relocate Value`"
                              v-validate="'required'"
                            />
                            <span class="text-sm text-danger" v-show="errors.has(`${indx + 1} Relocate Value`)"
                              >Relocate Value in this line must be filled</span
                            >
                          </td>
                          <td>
                            <v-select
                              v-model="item.im_number_id"
                              :options="listIM"
                              :reduce="(e) => e.id"
                              label="label"
                              :name="`${indx + 1} IM Number`"
                              v-validate="'required'"
                            >
                            </v-select>
                            <span class="text-sm text-danger" v-show="errors.has(`${indx + 1} IM Number`)"
                              >IM Number in this line must be filled</span
                            >
                          </td>
                        </template>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>
              <b-tab title="Ext to Int">
                <div style="overflow: auto">
                  <table class="table table-sm table-bordered table-nowrap table-relocate" style="table-layout: fixed; word-wrap: break-word">
                    <thead>
                      <tr>
                        <th style="width: 220px" scope="col">Department From</th>
                        <th style="width: 220px" scope="col">Department To</th>
                        <th style="width: 220px" scope="col">Type</th>
                        <th style="width: 400px" scope="col">Origin GL Number</th>
                        <th style="width: 200px" scope="col">Origin Fund Number</th>
                        <th style="width: 400px" scope="col">Budget Task</th>
                        <th style="width: 220px" scope="col">Delivery Date</th>
                        <th style="width: 300px" scope="col">Relocation Value</th>
                        <th style="width: 300px" scope="col">IM Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, indx) in extInt" :key="indx">
                        <td>
                          <div v-if="item.relocate_type === 'INT-EKS'">
                            <span v-if="item?.budget_task_from">
                              {{
                                item?.budget_task_from?.fund?.fundCenter?.department_code
                                  ? item?.budget_task_from?.fund?.fundCenter?.department_code
                                  : '-'
                              }}
                              -
                              {{
                                item?.budget_task_from?.fund?.fundCenter?.department_name
                                  ? item?.budget_task_from?.fund?.fundCenter?.department_name
                                  : '-'
                              }}
                            </span>
                            <span v-else> - </span>
                          </div>
                          <div v-else>
                            {{
                              item?.budget_to_in?.fund_center?.department_code
                                ? item?.budget_to_in?.fund_center?.department_code
                                : item?.department_from?.code
                            }}
                            -
                            {{
                              item?.budget_to_in?.fund_center?.department_name
                                ? item?.budget_to_in?.fund_center?.department_name
                                : item?.department_from?.name
                            }}
                          </div>
                        </td>
                        <td>
                          <div v-if="item.relocate_type === 'INT-EKS'">
                            <span v-if="item?.budget_task_to">
                              {{
                                item?.budget_task_to?.fund?.fundCenter?.department_code
                                  ? item?.budget_task_to?.fund?.fundCenter?.department_code
                                  : '-'
                              }}
                              -
                              {{
                                item?.budget_task_to?.fund?.fundCenter?.department_name
                                  ? item?.budget_task_to?.fund?.fundCenter?.department_name
                                  : '-'
                              }}
                            </span>
                            <span v-else> - </span>
                          </div>
                          <div v-else>
                            {{
                              item?.budget_from_in?.fund_center?.department_code
                                ? item?.budget_from_in?.fund_center?.department_code
                                : item?.department_to?.code
                            }}
                            -
                            {{
                              item?.budget_from_in?.fund_center?.department_name
                                ? item?.budget_from_in?.fund_center?.department_name
                                : item?.department_to?.name
                            }}
                          </div>
                        </td>
                        <td>
                          <div v-if="item.relocate_type === 'INT-EKS'">
                            {{ item?.budget_task_from?.opex_gl != null ? 'OPEX' : 'CAPEX' }}
                          </div>
                          <div v-else>
                            {{ item.opex_gl_id != null ? 'OPEX' : 'CAPEX' }}
                          </div>
                        </td>
                        <td>
                          <div v-if="item.relocate_type === 'INT-EKS'">
                            <span v-if="item?.budget_task_from?.opex_gl">
                              {{
                                item?.budget_task_from?.opex_gl?.budgetItem?.budget_item
                                  ? item?.budget_task_from?.opex_gl?.budgetItem?.budget_item
                                  : '-'
                              }}
                            </span>
                            <span v-else>
                              {{ item?.budget_task_from?.capex_gl?.account?.account ? item?.budget_task_from?.capex_gl?.account?.account : '-' }}
                            </span>
                          </div>
                          <div v-else>
                            <span v-if="item.opex_gl_id !== null">
                              {{ item?.opex_gl?.gl_code ? item?.opex_gl?.gl_code : '-' }}
                              -
                              {{ item?.opex_gl?.budgetItem ? item?.opex_gl?.budgetItem?.budget_item : '-' }}
                            </span>
                            <span v-else>
                              {{ item?.capex_gl?.gl_code ? item?.capex_gl?.gl_code : '-' }}
                              -
                              {{ item?.capex_gl?.account ? item?.capex_gl?.account?.account : '-' }}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div v-if="item.relocate_type === 'INT-EKS'">
                            {{ item?.budget_task_from?.fund?.fund ? item?.budget_task_from?.fund?.fund : '-' }}
                          </div>
                          <div v-else>
                            {{ item?.fund ? item?.fund?.fund : '-' }}
                          </div>
                        </td>
                        <td>
                          <div v-if="item.relocate_type === 'INT-EKS'">
                            {{ item?.budget_from_in?.name ? item?.budget_from_in?.name : item.budget_task ? item.budget_task : '-' }}
                          </div>
                          <div v-else>
                            {{
                              item?.budget_from_in?.name
                                ? item?.budget_from_in?.name
                                : item?.budget_to?.name
                                ? item?.budget_to?.name
                                : item.budget_task
                                ? item.budget_task
                                : '-'
                            }}
                          </div>
                        </td>
                        <td>
                          {{ item.delivery_date ? convertMonth(item.delivery_date) : '-' }}
                        </td>
                        <td>Rp. {{ item?.relocate_value ? convertNumber(item.relocate_value) : 0 }}</td>
                        <td>
                          Rp.
                          {{ item?.relocate_value ? convertNumber(item.relocate_value) : 0 }}
                        </td>
                        <td>
                          <a :href="item.im_number.attachments[0]?.url" v-if="item.im_number" target="_blank">{{ item?.im_number?.im_number }}</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>
            </b-tabs>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
    <b-modal size="xl" id="modalRelocation" :title="titleBudget" hide-footer @hide="onHide" dialog-class="full-width-modal">
      <!-- {{ listBudget }} -->
      <div class="form-group">
        <label>Budget Task</label>
        <b-form-select
          v-if="listBudget"
          v-model="selectedTask"
          value-field="id"
          text-field="name"
          :options="listBudget"
          @input="changeTask('yes', listBudget, 'realization')"
        ></b-form-select>
      </div>
      <div class="container-fluid" v-if="selectedTask && loadingSave == false">
        <div class="row mb-4">
          <div class="col-sm">
            <p class="font-weight-bold mb-0">Budget Task</p>
            <p>{{ this.selectingPO[0]?.name }}</p>
          </div>
          <div class="col-sm">
            <p class="font-weight-bold mb-0">Total Budget</p>
            <p>Rp. {{ convertNumber(this.selectingPO[0]?.total) }}</p>
          </div>
          <div class="col-sm">
            <p class="font-weight-bold mb-0">Total PO Value</p>
            <p>Rp. {{ convertNumber(this.selectingPO[0]?.tempPoValue) }}</p>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-sm">
            <p class="font-weight-bold mb-0">Brs In</p>
            <p>
              <span v-if="isOpex === true">
                Rp.
                {{ convertNumber(this.selectingPO[0]?.remainingBudgetRelocate) }}
              </span>
              <span v-if="isOpex === false">
                Rp.
                {{ convertNumber(this.selectingPO[0]?.remainingBudgetRelocate) }}
              </span>
            </p>
          </div>
          <div class="col-sm">
            <p class="font-weight-bold mb-0">Brs Out</p>
            <p>Rp. {{ convertNumber(this.selectingPO[0]?.actualRelocate) }}</p>
          </div>
          <div class="col-sm">
            <p class="font-weight-bold mb-0">Remaining Budget</p>
            <p>Rp. {{ convertNumber(this.selectingPO[0]?.remaining_budget) }}</p>
          </div>
        </div>
      </div>
      <b-skeleton-table v-if="selectedTask && loadingSave == true" :rows="1" :columns="3" :table-props="{ bordered: true, striped: true }" />
      <b-skeleton-table v-if="selectedTask && loadingSave == true" :rows="1" :columns="5" :table-props="{ bordered: true, striped: true }" />
      <b-skeleton-table v-if="selectedTask && loadingSave == true" :rows="0" :columns="1" :table-props="{ bordered: true, striped: true }" />
      <b-tabs content-class="mt-3" v-if="selectedTask && loadingSave == false" pills fill card>
        <b-tab title="Int to Ext" :active="tabNow === 'intExt'" @click="checkTabs('intExt')">
          <div class="row gx-3 mb-3">
            <div class="col-12 col-lg-6 ms-auto">
              <div class="row g-2">
                <!-- Filter by Delivery Date -->
                <div class="col-12 col-md-5 mb-2 mb-md-0">
                  <label class="form-label small mb-1">Filter by Delivery Date</label>
                  <date-picker
                    v-model="filterIntToExt.delivery_date"
                    range
                    value-format="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    placeholder="Filter Delivery Date"
                    div
                    value-type="format"
                    size="sm"
                    :clearable="false"
                    class="w-100"
                  ></date-picker>
                </div>
                <!-- Search Field -->
                <div class="col-12 col-md-5 mb-2 mb-md-0">
                  <label class="form-label small mb-1 d-flex align-items-center">
                    Search
                    <span
                      v-b-popover.hover.top="
                        'Search in entire column on typing. You can search by department, type, GL number, fund number, budget task, IM number, etc.'
                      "
                      variant="secondary"
                      style="cursor: pointer; margin-left: 4px"
                    >
                      <i class="fe fe-help-circle text-danger" style="cursor: help; font-size: 14px"></i>
                    </span>
                  </label>
                  <b-form-input v-model="filterIntToExt.search" placeholder="Search..." @input="filterIntToExt.currentPage = 1"></b-form-input>
                </div>

                <!-- Reset Button -->
                <div class="col-12 col-md-2 d-flex align-items-end">
                  <b-button variant="primary" size="sm" @click="resetFilterRelocate('IntToExt')" class="w-100"> Reset </b-button>
                </div>
              </div>
            </div>
          </div>
          <div style="overflow: auto; height: 450px; max-height: 450px">
            <table class="table table-sm table-bordered table-nowrap table-relocate auto-table">
              <thead>
                <tr>
                  <th scope="col">Action</th>
                  <th scope="col">Department</th>
                  <th scope="col">Type</th>
                  <th scope="col">GL Number</th>
                  <th scope="col">Fund Number</th>
                  <th scope="col">Budget Task</th>
                  <th scope="col">Delivery Date</th>
                  <th scope="col">Relocation Value</th>
                  <th scope="col">IM Number</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!intExt || paginatedIntToExt.length === 0">
                  <td colspan="10" class="text-center">No Data</td>
                </tr>

                <tr v-for="(item, indx) in paginatedIntToExt" :key="indx">
                  <td class="text-center field-action" @click="openModalDetailBRS('Detail BRS Int to Ext', item)" style="cursor: pointer">
                    <b-button
                      @click="openModalDetailBRS('Detail BRS Int to Ext', item)"
                      class="mr-2"
                      size="sm"
                      variant="info"
                      v-b-popover.hover.right="'View Detail'"
                    >
                      <span class="fe fe-eye"></span>
                    </b-button>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Int to Ext', item)" style="cursor: pointer">
                    <div class="no-wrap">
                      {{ `${item?.department_code_from} - ${item?.department_name_from}` }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ `${item?.department_code_to} - ${item?.department_name_to}` }}
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Int to Ext', item)" style="cursor: pointer">
                    <div class="no-wrap">
                      {{ item?.type_from }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ item?.type_to }}
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Int to Ext', item)" style="cursor: pointer">
                    <div class="no-wrap">
                      {{ `${item?.gl_code_from} - ${item?.budget_item_from}` }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ `${item?.gl_code_to} - ${item?.budget_item_to}` }}
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Int to Ext', item)" style="cursor: pointer">
                    <div class="no-wrap">
                      {{ item?.fund_from }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ item?.fund_to }}
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Int to Ext', item)" style="cursor: pointer">
                    <div class="no-wrap">
                      {{ item?.budget_task_from }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ item?.budget_task_to }}
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Int to Ext', item)" style="cursor: pointer">
                    <div class="no-wrap">
                      {{ item?.delivery_date ? convertMonth(item?.delivery_date) : '-' }}
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Int to Ext', item)" style="cursor: pointer">
                    <div class="no-wrap">Rp. {{ item?.relocate_value ? convertNumber(item?.relocate_value) : 0 }}</div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Int to Ext', item)" style="cursor: pointer">{{ item?.im_number }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-end mt-2">
            <CustomPagination
              :current-page="filterIntToExt.currentPage"
              :per-page="filterIntToExt.perPage"
              :total-row="mappedIntToExt.length"
              @page-change="handlePageChangeIntToExt"
            />
          </div>
        </b-tab>
        <b-tab title="Int to Int" :active="tabNow === 'intInt'" @click="checkTabs('intInt')">
          <div class="row gx-3 mb-3">
            <div class="col-12 col-lg-6 ms-auto">
              <div class="row g-2">
                <!-- Filter by Delivery Date -->
                <div class="col-12 col-md-5 mb-2 mb-md-0">
                  <label class="form-label small mb-1">Filter by Delivery Date</label>
                  <date-picker
                    v-model="filterIntToInt.delivery_date"
                    range
                    value-format="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    placeholder="Filter Delivery Date"
                    div
                    value-type="format"
                    size="sm"
                    :clearable="false"
                    class="w-100"
                  ></date-picker>
                </div>
                <!-- Search Field -->
                <div class="col-12 col-md-5 mb-2 mb-md-0">
                  <label class="form-label small mb-1 d-flex align-items-center">
                    Search
                    <span
                      v-b-popover.hover.top="
                        'Search in entire column on typing. You can search by department, type, GL number, fund number, budget task, IM number, etc.'
                      "
                      variant="secondary"
                      style="cursor: pointer; margin-left: 4px"
                    >
                      <i class="fe fe-help-circle text-danger" style="cursor: help; font-size: 14px"></i>
                    </span>
                  </label>
                  <b-form-input v-model="filterIntToInt.search" placeholder="Search..." @input="filterIntToInt.currentPage = 1"></b-form-input>
                </div>

                <!-- Reset Button -->
                <div class="col-12 col-md-2 d-flex align-items-end">
                  <b-button variant="primary" size="sm" @click="resetFilterRelocate('IntToInt')" class="w-100"> Reset </b-button>
                </div>
              </div>
            </div>
          </div>
          <div style="overflow: auto; height: 450px; max-height: 450px">
            <table class="table table-sm table-bordered table-nowrap table-relocate auto-table">
              <thead>
                <tr>
                  <th scope="col">Action</th>
                  <th scope="col">Department</th>
                  <th scope="col">Relocate Type</th>
                  <th scope="col">Type</th>
                  <th scope="col">GL Number</th>
                  <th scope="col">Fund Number</th>
                  <th scope="col">Budget Task</th>
                  <th scope="col">Delivery Date</th>
                  <th scope="col">Relocation Value</th>
                  <th scope="col">IM Number</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!intInt || paginatedIntToInt.length === 0">
                  <td colspan="11" class="text-center">No Data</td>
                </tr>

                <tr v-for="(item, indx) in paginatedIntToInt" :key="indx">
                  <td class="text-center field-action" @click="openModalDetailBRS('Detail BRS Int to Int', item)" style="cursor: pointer">
                    <b-button
                      @click="openModalDetailBRS('Detail BRS Int to Int', item)"
                      class="mr-2"
                      size="sm"
                      variant="info"
                      v-b-popover.hover.right="'View Detail'"
                    >
                      <span class="fe fe-eye"></span>
                    </b-button>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Int to Int', item)" style="cursor: pointer">
                    <div class="no-wrap">
                      {{ `${item?.department_code_from} - ${item?.department_name_from}` }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ `${item?.department_code_to} - ${item?.department_name_to}` }}
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Int to Int', item)" style="cursor: pointer">
                    {{ item.hasOwnProperty('relocate_type') ? relocateds(item?.relocate_type) : '-' }}
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Int to Int', item)" style="cursor: pointer">
                    <div v-if="item?.relocate_type === 'INT-INT-TO'" class="no-wrap">
                      {{ item?.type_to }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ item?.type_from }}
                    </div>
                    <div v-else class="no-wrap">
                      {{ item?.type_from }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ item?.type_to }}
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Int to Int', item)" style="cursor: pointer">
                    <div v-if="item?.relocate_type === 'INT-INT-TO'" class="no-wrap">
                      {{ `${item?.gl_code_to} - ${item?.budget_item_to}` }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ `${item?.gl_code_from} - ${item?.budget_item_from}` }}
                    </div>
                    <div v-else class="no-wrap">
                      {{ `${item?.gl_code_from} - ${item?.budget_item_from}` }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ `${item?.gl_code_to} - ${item?.budget_item_to}` }}
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Int to Int', item)" style="cursor: pointer">
                    <div v-if="item?.relocate_type === 'INT-INT-TO'" class="no-wrap">
                      {{ item?.fund_to }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ item?.fund_from }}
                    </div>
                    <div v-else class="no-wrap">
                      {{ item?.fund_from }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ item?.fund_to }}
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Int to Int', item)" style="cursor: pointer">
                    <div v-if="item?.relocate_type === 'INT-INT-TO'" class="no-wrap">
                      {{ item?.budget_task_to }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ item?.budget_task_from }}
                    </div>
                    <div v-else class="no-wrap">
                      {{ item?.budget_task_from }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ item?.budget_task_to }}
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Int to Int', item)" style="cursor: pointer">
                    <div class="no-wrap">
                      {{ item?.delivery_date ? convertMonth(item?.delivery_date) : '-' }}
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Int to Int', item)" style="cursor: pointer">
                    <div class="no-wrap">Rp. {{ item?.relocate_value ? convertNumber(item?.relocate_value) : 0 }}</div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Int to Int', item)" style="cursor: pointer">{{ item?.im_number }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-end mt-2">
            <CustomPagination
              :current-page="filterIntToInt.currentPage"
              :per-page="filterIntToInt.perPage"
              :total-row="mappedIntToInt.length"
              @page-change="handlePageChangeIntToInt"
            />
          </div>
        </b-tab>
        <b-tab title="Ext to Int" :active="tabNow === 'extInt'" @click="checkTabs('extInt')">
          <div class="row gx-3 mb-3">
            <div class="col-12 col-lg-6 ms-auto">
              <div class="row g-2">
                <!-- Filter by Delivery Date -->
                <div class="col-12 col-md-5 mb-2 mb-md-0">
                  <label class="form-label small mb-1">Filter by Delivery Date</label>
                  <date-picker
                    v-model="filterExtToInt.delivery_date"
                    range
                    value-format="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    placeholder="Filter Delivery Date"
                    div
                    value-type="format"
                    size="sm"
                    :clearable="false"
                    class="w-100"
                  ></date-picker>
                </div>
                <!-- Search Field -->
                <div class="col-12 col-md-5 mb-2 mb-md-0">
                  <label class="form-label small mb-1 d-flex align-items-center">
                    Search
                    <span
                      v-b-popover.hover.top="
                        'Search in entire column on typing. You can search by department, type, GL number, fund number, budget task, IM number, etc.'
                      "
                      variant="secondary"
                      style="cursor: pointer; margin-left: 4px"
                    >
                      <i class="fe fe-help-circle text-danger" style="cursor: help; font-size: 14px"></i>
                    </span>
                  </label>
                  <b-form-input v-model="filterExtToInt.search" placeholder="Search..." @input="filterExtToInt.currentPage = 1"></b-form-input>
                </div>

                <!-- Reset Button -->
                <div class="col-12 col-md-2 d-flex align-items-end">
                  <b-button variant="primary" size="sm" @click="resetFilterRelocate('ExtToInt')" class="w-100"> Reset </b-button>
                </div>
              </div>
            </div>
          </div>

          <div style="overflow: auto; height: 450px; max-height: 450px">
            <table class="table table-sm table-bordered table-nowrap table-relocate auto-table">
              <thead>
                <tr>
                  <th scope="col">Action</th>
                  <th scope="col">Department</th>
                  <th scope="col">Type</th>
                  <th scope="col">GL Number</th>
                  <th scope="col">Fund Number</th>
                  <th scope="col">Budget Task</th>
                  <th scope="col">Delivery Date</th>
                  <th scope="col">Relocation Value</th>
                  <th scope="col">IM Number</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!extInt || paginatedExtToInt.length === 0">
                  <td colspan="10" class="text-center">No Data</td>
                </tr>

                <tr v-for="(item, indx) in paginatedExtToInt" :key="indx">
                  <td class="text-center field-action" @click="openModalDetailBRS('Detail BRS Ext to Int', item)" style="cursor: pointer">
                    <b-button
                      @click="openModalDetailBRS('Detail BRS Ext to Int', item)"
                      class="mr-2"
                      size="sm"
                      variant="info"
                      v-b-popover.hover.right="'View Detail'"
                    >
                      <span class="fe fe-eye"></span>
                    </b-button>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Ext to Int', item)" style="cursor: pointer">
                    <div class="no-wrap">
                      {{ `${item?.department_code_from} - ${item?.department_name_from}` }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ `${item?.department_code_to} - ${item?.department_name_to}` }}
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Ext to Int', item)" style="cursor: pointer">
                    <div class="no-wrap">
                      {{ item?.type_from }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ item?.type_to }}
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Ext to Int', item)" style="cursor: pointer">
                    <div class="no-wrap">
                      <div class="no-wrap">
                        {{ `${item?.gl_code_from} - ${item?.budget_item_from}` }}
                        <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                        {{ `${item?.gl_code_to} - ${item?.budget_item_to}` }}
                      </div>
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Ext to Int', item)" style="cursor: pointer">
                    <div class="no-wrap">
                      {{ item?.fund_from }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ item?.fund_to }}
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Ext to Int', item)" style="cursor: pointer">
                    <div class="no-wrap">
                      {{ item?.budget_task_from }}
                      <i class="fe fe-arrow-right text-primary text-bold mx-2"></i>
                      {{ item?.budget_task_to }}
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Ext to Int', item)" style="cursor: pointer">
                    <div class="no-wrap">
                      {{ item?.delivery_date ? convertMonth(item?.delivery_date) : '-' }}
                    </div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Ext to Int', item)" style="cursor: pointer">
                    <div class="no-wrap">Rp. {{ item?.relocate_value ? convertNumber(item?.relocate_value) : 0 }}</div>
                  </td>
                  <td @click="openModalDetailBRS('Detail BRS Ext to Int', item)" style="cursor: pointer">{{ item?.im_number }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-end mt-2">
            <CustomPagination
              :current-page="filterExtToInt.currentPage"
              :per-page="filterExtToInt.perPage"
              :total-row="mappedExtToInt.length"
              @page-change="handlePageChangeExtToInt"
            />
          </div>
        </b-tab>
      </b-tabs>
    </b-modal>
    <b-modal size="xl" id="modalBudgetItem" :title="titleBudget" hide-footer @hide="hideDetail" dialog-class="full-width-modal">
      <div v-if="isReview == false">
        <div class="container-fluid" v-if="selectedTask && selectedBudgetItem && loadingSave == false">
          <div class="row mb-4">
            <div class="col-sm">
              <p class="font-weight-bold mb-0">PR Name</p>
              <p>{{ selectedBudgetItem.po_name }}</p>
            </div>
            <div class="col-sm">
              <p class="font-weight-bold mb-0">PR Number</p>
              <p>{{ selectedBudgetItem.pr_subject }}</p>
            </div>
            <div class="col-sm">
              <p class="font-weight-bold mb-0">PO Number</p>
              <p>{{ selectedBudgetItem.po_subject }}</p>
            </div>
            <div class="col-sm">
              <p class="font-weight-bold mb-0">Contract Detail</p>
              <p>{{ selectedBudgetItem.contract_detail_name }}</p>
            </div>
          </div>
        </div>
        <div style="margin-bottom: 12px">
          <b-button
            v-b-modal.modal-form-detail-payment
            @click="
              isEditDetailPayment = false;
              fetchContractItem();
              resetFormDetailPayment();
            "
            variant="primary"
            size="sm"
            class="col-2"
          >
            <span class="fe fe-plus-circle"></span>
            New Detail Payment
          </b-button>
        </div>
        <b-skeleton-table v-if="selectedTask && loadingSave == true" :rows="1" :columns="3" :table-props="{ bordered: true, striped: true }" />
        <div style="overflow: auto; max-height: 570px" v-if="selectedTask && loadingSave == false">
          <table class="table table-sm table-bordered table-nowrap" style="table-layout: fixed; word-wrap: break-word">
            <thead>
              <tr>
                <!-- <th style="width: 350px;" scope="col">Budget Task</th>
              <th style="width: 350px;" scope="col">Total Budget</th> -->

                <th class="sticky-header-po" style="width: 100px" scope="col">Action</th>
                <th class="sticky-header-po" style="width: 270px" scope="col">Contract Item</th>
                <th class="sticky-header-po" style="width: 270px" scope="col">Term</th>
                <th class="sticky-header-po" style="width: 270px" scope="col">BAST Number</th>
                <th class="sticky-header-po" style="width: 220px" scope="col">BAST Date</th>
                <th class="sticky-header-po" style="width: 270px" scope="col">Vendor Name</th>
                <th class="sticky-header-po" style="width: 270px" scope="col">SES/GR Number</th>
                <th class="sticky-header-po" style="width: 270px" scope="col">INV Number</th>
                <th class="sticky-header-po" style="width: 220px" scope="col">DPP</th>
                <th class="sticky-header-po" style="width: 220px" scope="col">VAT</th>
                <th class="sticky-header-po" style="width: 220px" scope="col">AFTER TAX</th>
                <th class="sticky-header-po" style="width: 220px" scope="col">WHT</th>
                <th class="sticky-header-po" style="width: 220px" scope="col">NET VALUE</th>
                <th class="sticky-header-po" style="width: 220px" scope="col">FA FORM DATE</th>
                <th class="sticky-header-po" style="width: 220px" scope="col">DOC TO FA DATE</th>
                <th class="sticky-header-po" style="width: 220px" scope="col">PAYMENT DATE</th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in actualItem" :key="index">
              <tr>
                <!-- <td>{{ item.name }}</td>
              <td>Rp. {{ convertNumber(item.total) }}</td> -->
                <td class="text-center">
                  <b-button
                    @click="deleteRowDetail(item, indx)"
                    class="mr-2"
                    size="sm"
                    variant="danger"
                    v-b-popover.hover.bottom="'Delete Detail Payment'"
                  >
                    <span class="fe fe-trash-2"></span>
                  </b-button>
                  <b-button
                    v-b-popover.hover.top="'Edit Detail Payment'"
                    @click="openDetailPaymentModal(item)"
                    class="mr-2"
                    size="sm"
                    variant="warning"
                  >
                    <span class="fe fe-edit-2"></span>
                  </b-button>
                </td>
                <td>
                  {{ item.contract_item || '-' }}
                  {{ ' ' }}
                  <span
                    v-if="!item.contract_item_exist"
                    v-b-popover.hover.top="'Contract Item not exist'"
                    class="fe fe-flag text-danger"
                    style="cursor: pointer"
                  ></span>
                </td>
                <td>
                  {{ item.term || '-' }}
                  {{ ' ' }}
                  <span
                    v-if="!item.term_exist"
                    v-b-popover.hover.top="'Term not exist'"
                    class="fe fe-flag text-danger"
                    style="cursor: pointer"
                  ></span>
                </td>
                <td>
                  {{ item.bast_subject }}
                  <!-- <input :disabled="statuss == true" v-model="item.bast_sub" type="text" class="form-control"> -->
                </td>
                <td>
                  {{ item.bast_date }}
                  <!-- <date-picker :disabled="statuss == true" v-model="item.bast_dat" class="w-100 border-0"
                    valueType="format" /> -->
                </td>
                <td style="text-wrap: auto">
                  {{ item.vendor_name }}
                  <!-- <v-select :disabled="statuss == true" v-model="item.vendor_n" :options="filteredVendors"
                    :searchable="true" :filterable="false" placeholder="Type to search vendors..."
                    no-options-text="No vendors found." @search="searchVendors" @input="searchSES(index, $event)">
                  </v-select> -->
                </td>
                <!-- <td><input :disabled="statuss == true" v-model="item.ses_gr_n" type="text" class="form-control"></td> -->
                <td>
                  {{ item.ses_gr_no_subject }}
                  <!-- <v-select :options="item.listSes" :disabled="statuss == true || !item.vendor_n" v-model="item.ses_gr_n"
                    label="grses_number" :reduce="(e) => e.grses_number" @input="inputDatesAmount('opex', $event, index)">
                  </v-select> -->
                </td>
                <td>
                  {{ item.inv_subject }}
                  <!-- <input :disabled="statuss == true" v-model="item.inv_subj" type="text" class="form-control"> -->
                </td>
                <td>
                  Rp. {{ item ? convertNumber(item.dpp) : 0 }}
                  <!-- <vue-numeric :disabled="statuss == true" v-model="item.dpp" class="form-control" currency="Rp. "
                    @blur="dppCalculation(item.dpp, item.wht, item.vat, index, 'dpp')" separator=","
                    v-bind:max="po_val" /> -->
                </td>
                <td>
                  Rp. {{ item ? convertNumber(item.vat) : 0 }}
                  <!-- <vue-numeric :disabled="statuss == true" v-model="item.vat" class="form-control" currency="Rp. "
                    @blur="dppCalculation(item.dpp, item.wht, item.vat, index, 'vat')" separator="," /> -->
                </td>
                <td>Rp. {{ item ? convertNumber(item.after_tax) : 0 }}</td>
                <td>
                  Rp. {{ item ? convertNumber(item.wht) : 0 }}
                  <!-- <vue-numeric v-model="item.wht" class="form-control" currency="Rp. " separator=","
                    @blur="dppCalculation(item.dpp, item.wht, item.vat, index, 'wht')"
                    :disabled="statuss == true && item.dpp > 0" /> -->
                </td>
                <td>Rp. {{ item ? convertNumber(item.net_value) : 0 }}</td>
                <td>
                  {{ item.fa_form }}
                  <!-- <date-picker :disabled="statuss == true" v-model="item.fa_form" class="w-100 border-0"
                    valueType="format" /> -->
                </td>
                <td>
                  {{ item.doc_to_fa }}
                  <!-- <date-picker :disabled="statuss == true" v-model="item.doc_to_f" class="w-100 border-0"
                    valueType="format" /> -->
                </td>
                <td>
                  {{ item.payment_date }}
                  <!-- <date-picker :disabled="statuss == true" v-model="item.payment_" class="w-100 border-0"
                    valueType="format" /> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- <div class="card shadow-none mt-3 border-secondary" v-if="loadingSave == false && statuss == false" style="
                      border-style: dashed;
                      background: none;
                      cursor: pointer;
                    " @click.prevent="pushNewItem()">
          <div class="card-body">
            <div class="d-flex text-secondary w-100" style="align-items: center; justify-content: center">
              New Expenses
            </div>
          </div>
        </div> -->
        <!-- <div>
          <b-button variant="primary" :disabled="statuss == true" v-if="selectedTask && loadingSave == false"
            class="mt-2 float-end" @click="saveActualItem">
            Save</b-button>
        </div> -->
      </div>
      <div v-if="isReview == true">
        <div style="overflow: auto" v-if="selectedTask">
          <table class="table table-sm table-bordered table-nowrap" style="table-layout: fixed; word-wrap: break-word">
            <thead>
              <tr>
                <!-- <th style="width: 350px;" scope="col">Budget Task</th>
              <th style="width: 350px;" scope="col">Total Budget</th> -->

                <!-- <th style="width: 100px;" scope="col">Action</th> -->
                <th class="sticky-header-po" style="width: 270px" scope="col">Contract Item</th>
                <th class="sticky-header-po" style="width: 270px" scope="col">Term</th>
                <th style="width: 270px" scope="col">BAST Number</th>
                <th style="width: 220px" scope="col">BAST Date</th>
                <th style="width: 270px" scope="col">Vendor Name</th>
                <th style="width: 270px" scope="col">SES/GR Number</th>
                <th style="width: 270px" scope="col">INV Number</th>
                <th style="width: 220px" scope="col">DPP</th>
                <th style="width: 220px" scope="col">VAT</th>
                <th style="width: 220px" scope="col">AFTER TAX</th>
                <th style="width: 220px" scope="col">WHT</th>
                <th style="width: 220px" scope="col">NET VALUE</th>
                <th style="width: 220px" scope="col">FA FORM DATE</th>
                <th style="width: 220px" scope="col">DOC TO FA DATE</th>
                <th style="width: 220px" scope="col">PAYMENT DATE</th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in actualItem" :key="index">
              <tr>
                <!-- <td>{{ item.name }}</td>
              <td>Rp. {{ convertNumber(item.total) }}</td> -->
                <!-- <td class="text-center"> -->
                <!-- <span class="fe fe-x-circle text-danger" style="cursor: pointer;" @click="deleteRow(item, indx)"></span> -->
                <!-- </td> -->
                <td>{{ item.contract_item || '-' }}</td>
                <td>{{ item.term || '-' }}</td>
                <td>{{ item.bast_subject }}</td>
                <td>
                  {{ convertMonth(item.bast_date) }}
                </td>
                <td>{{ item.vendor_name }}</td>
                <td>{{ item.ses_gr_no_subject }}</td>
                <td>{{ item.inv_subject }}</td>
                <td>Rp. {{ convertNumber(item.dpp) }}</td>
                <td>Rp. {{ item ? convertNumber(item.vat) : 0 }}</td>
                <td>Rp. {{ item ? convertNumber(item.after_ta) : 0 }}</td>
                <td>Rp. {{ item ? convertNumber(item.wht) : 0 }}</td>
                <td>Rp. {{ item ? convertNumber(item.net_valu) : 0 }}</td>
                <td>
                  {{ convertMonth(item.fa_form_date) }}
                </td>
                <td>
                  {{ convertMonth(item.doc_to_fa_date) }}
                </td>
                <td>
                  {{ convertMonth(item.payment_date) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
    <b-modal size="xl" id="modal-share" centered title="Share Plan" hide-footer>
      <div class="d-flex justify-content-end mb-3 mt-3 mr-3">
        <label class="align-self-center mb-0 mr-3">Search User</label>
        <b-form-input class="w-auto" v-model="body.search" placeholder="Type Here..."> </b-form-input>
      </div>
      <table class="table table-sm table-bordered table-striped table-hover p-0" v-if="listViewer">
        <thead class="table-light">
          <tr>
            <td>Name</td>
            <td>Division</td>
            <td>Department</td>
            <td style="width: 150px" class="text-center">Share</td>
          </tr>
        </thead>
        <tbody v-for="(item, index) in filteredItems(listViewer)" :key="index">
          <tr>
            <td>{{ item ? item.fullname : '-' }}</td>
            <td>{{ item.divisi ? item.divisi : '-' }}</td>
            <td>{{ item.department ? item.department : '-' }}</td>
            <td class="text-center">
              <b-button v-if="item.shared" variant="danger" size="sm" block @click="unshares(item.shared.id)"
                ><span class="fe fe-share-2"></span> Unshare</b-button
              >
              <b-button v-else variant="info" size="sm" block @click="shares(item.id)"><span class="fe fe-share-2"></span> Share</b-button>
              <!-- <div class="form-check">
                <input class="form-check-input" type="checkbox" id="checklistTwo" @input="shares(item.id)">
              </div> -->
            </td>
          </tr>
        </tbody>
      </table>
      <b-skeleton-table v-else :rows="1" :columns="8" :table-props="{ bordered: true, striped: true }"> </b-skeleton-table>
    </b-modal>
    <b-modal id="modal-email" title="Send Email Form" hide-footer>
      <div class="form-group col-12">
        <label>Email To:</label>
        <input-tag v-model="bodyEmail.to" style="border-radius: 6px"></input-tag>
      </div>
      <div class="form-group col-12">
        <label>Email CC:</label>
        <input-tag v-model="bodyEmail.cc" style="border-radius: 6px"></input-tag>
      </div>
      <div class="form-group">
        <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" @click="sendEmail" v-if="isLoading == false">Send</button>
        <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button" disabled v-else>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Loading...
        </button>
      </div>
    </b-modal>
    <b-modal id="modal-link-to-contract" size="lg" title="New contract Form" @hide="selectedLinkContract = null">
      <!-- GL & Budget Task -->
      <div class="row">
        <div class="col-md-6" v-if="selectedTask && loadingSave == false">
          <strong>GL</strong>
          <p>
            {{ this.opexSelected }} - {{ this.ttItemSelected }} -
            {{ this.titleBudget }}
          </p>
          <!-- detailBudget() => item.opex_gl.gl_code; item.budget_item.item; title; -->
        </div>
        <div class="col-md-6" v-if="selectedTask && loadingSave == false">
          <strong>Budget Task</strong>
          <p>{{ this.selectingPO[0]?.name }}</p>
        </div>
      </div>
      <!-- Contract Name -->
      <div class="form-row">
        <div class="form-group col-md-12">
          <label>Contract Name</label>
          <v-select
            v-model="selectedLinkContract"
            :reduce="(option) => option.id"
            :options="listContract"
            label="label"
            placeholder="Select Contract"
          ></v-select>
        </div>
      </div>
      <template #modal-footer>
        <b-button
          variant="outline-primary"
          @click="
            $bvModal.hide('modal-link-to-contract');
            selectedLinkContract = null;
          "
        >
          Cancel
        </b-button>
        <b-button v-if="isLoading == false" variant="primary" @click="submitLinkToContract">
          <!-- @click="submitFormExpanses" -->
          Save
        </b-button>
        <b-button v-else type="button" variant="primary" disabled>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Loading...
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-form-po" size="lg" scrollable :title="isEditPo ? 'Edit PO Form' : 'New PO Form'">
      <div class="card p-4">
        <label class="font-weight-bold">PR Section</label>
        <div class="row row-cols-1 row-cols-md-2">
          <div class="col" v-if="selectedTask && loadingSave == false">
            <strong>GL</strong>
            <p>{{ this.opexSelected }} - {{ this.titleBudget }}</p>
          </div>
          <div class="col" v-if="selectedTask && loadingSave == false">
            <strong>Budget Task</strong>
            <p>{{ selectingPO[0]?.name }}</p>
          </div>
        </div>

        <!-- PR Name & PR Number -->
        <div class="row row-cols-1 row-cols-md-2">
          <div class="form-group col">
            <label>PR Name <span class="text-danger">*</span></label>
            <input
              name="prName"
              v-model="formExpanses.prName"
              type="text"
              class="form-control"
              placeholder="Input PR Name"
              required
              v-validate="'required|max:1000'"
            />
            <span class="text-sm text-danger" v-show="errors.has('prName')"> PR Name is required and must not exceed 1000 characters </span>
          </div>
          <div class="form-group col">
            <label>PR Number <span class="text-danger">*</span></label>
            <input
              name="prNumber"
              v-model="formExpanses.prNumber"
              type="number"
              class="form-control"
              placeholder="Input PR Number"
              required
              v-validate="'required|numeric|max:10|min:10'"
              @input="limitTenCharacters('prNumber')"
            />
            <span class="text-sm text-danger" v-show="errors.has('prNumber')"> PR Number must be exact 10 digits </span>
          </div>
          <div class="form-group col">
            <label>PR Date <span class="text-danger">*</span></label>
            <input name="prDate" v-model="formExpanses.prDate" type="date" class="form-control" required v-validate="'required'" />
            <span class="text-sm text-danger" v-show="errors.has('prDate')"> PR Date is required </span>
          </div>
          <div class="form-group col">
            <label>PR Value <span class="text-danger">*</span></label>
            <RupiahInput
              v-model="formExpanses.prValue"
              name="prValue"
              placeholder="Input PR Value"
              required
              v-validate="'required|numeric|min:1|max:100|max_value:999999999999999'"
            />
            <FieldError name="prValue" label="PR Value" :errorBags="errors" />
          </div>
        </div>
      </div>
      <!-- PO Number & PO Date -->
      <div class="card p-4">
        <label class="font-weight-bold">PO Section</label>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label>PO Number</label>
            <input
              name="poNumber"
              v-model="formExpanses.poNumber"
              type="number"
              class="form-control"
              placeholder="Input PO Number"
              v-validate="'numeric|max:10|min:10'"
              @input="limitTenCharacters('poNumber')"
            />
            <span class="text-sm text-danger" v-if="errors.has('poNumber')"> PO Number must be a exact 10 digits </span>
          </div>
          <div class="form-group col-md-6">
            <label>PO Date</label>
            <input name="poDate" v-model="formExpanses.poDate" type="date" class="form-control" />
            <span class="text-sm text-danger" v-show="errors.has('poDate')"> PO Date is required </span>
          </div>

          <div class="form-group col-md-6">
            <label>PO Value (Rp.)</label>
            <RupiahInput
              v-model="formExpanses.poValue"
              name="poValue"
              placeholder="Input PO Value"
              @input="handleInputPoValue"
              v-validate="'numeric|max:100|max_value:999999999999999'"
            />
            <FieldError name="poValue" label="PO Value" :errorBags="errors" />
            <FieldError name="poValueLimit" label="PO Value" :errorBags="errors" />
            <span class="text-sm text-danger" v-if="!this.isValidPOValue"> PO Value cannot be greater than the Remaining Budget </span>
          </div>
        </div>
      </div>

      <!-- Contract Name & Contract Detail -->
      <div class="card p-4">
        <label class="font-weight-bold">Contract Section</label>
        <div class="form-row">
          <!-- Contract Name -->
          <div class="form-group col-md-6">
            <label>Contract Name</label>
            <v-select
              name="contractId"
              v-model="formExpanses.contractId"
              :options="listPlanBudgetContract"
              label="contract_name"
              :reduce="(option) => option.id"
              placeholder="Select Contract Name"
              @input="fetchPlanBudgetContractDetail"
              clearable
            />
            <span class="text-sm text-danger" v-show="errors.has('contractId')"> Contract Name is required </span>
          </div>

          <!-- Contract Detail -->
          <div class="form-group col-md-6">
            <label>Contract Detail</label>
            <v-select
              name="contractDetail"
              v-model="formExpanses.contractDetail"
              :options="listPlanBudgetContractDetail"
              :reduce="(option) => option.contract_detail_name"
              label="contract_detail_name"
              placeholder="Select Contract Detail"
              clearable
            />
            <span class="text-sm text-danger" v-show="errors.has('contractDetail')"> Contract Detail is required </span>
          </div>
        </div>
      </div>
      <!--  Project Tag and IM -->
      <div class="card p-4">
        <label class="font-weight-bold">Project Tag Section</label>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label>Project Tag</label>
            <v-select
              name="name"
              v-model="formExpanses.projectTagId"
              :options="listProjectTags"
              label="name"
              :reduce="(option) => option.id"
              placeholder="Select Project Tag"
              clearable
            />
            <span class="text-sm text-danger" v-show="errors.has('projectTagId')"> Project Tag is required </span>
          </div>
        </div>
      </div>

      <div class="card p-4">
        <label class="font-weight-bold">IM Section</label>
        <div class="row row-cols-1 row-cols-lg-2">
          <div class="col mt-3">
            <label>Internal Memo Category</label>
            <v-select
              v-model="formExpanses.imCategory"
              :options="PoImTypeOptions"
              name="im_category"
              v-validate="withIm ? 'required' : ''"
              @input="selectIMPOCategory"
            ></v-select>
            <FieldError name="im_category" label="IM Category" :errorBags="errors" />
          </div>
          <div class="col mt-3">
            <label>Internal Memo</label>
            <v-select
              v-model="formExpanses.imNumberId"
              :options="listIMPO"
              :reduce="(e) => Number(e.id)"
              label="label"
              name="im_number_id"
              v-validate="withIm ? 'required' : ''"
            ></v-select>
            <FieldError name="im_number_id" label="IM Number" :errorBags="errors" />
          </div>
        </div>
        <b-collapse id="collapse-im" :visible="selectedIMPO ? true : false">
          <div class="card p-3 mt-3" v-if="selectedIMPO">
            <div class="row row-cols-1 row-cols-md-3 gx-3 gy-5 mt-2 mb-2">
              <!-- if type BRS -->
              <div class="col" v-if="selectedIMPO?.budget_task_from_detail?.department_name">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Departmen From</h4>
                    <small class="text-body-secondary"
                      ><span> {{ selectedIMPO?.budget_task_from_detail?.department_name }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col" v-if="selectedIMPO?.budget_task_from_detail?.plan_title">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Plan Title From</h4>
                    <small class="text-body-secondary"
                      ><span>
                        {{
                          `${selectedIMPO?.budget_task_from_detail?.plan_title} version ${selectedIMPO?.budget_task_from_detail?.plan_version}`
                        }}</span
                      >
                    </small>
                  </div>
                </div>
              </div>
              <div class="col" v-if="selectedIMPO?.budget_task_from_detail?.fund_name">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Fund From</h4>
                    <small class="text-body-secondary"
                      ><span>
                        {{ `${selectedIMPO?.budget_task_from_detail?.budget_type} | ${selectedIMPO?.budget_task_from_detail?.fund_name}` }}</span
                      >
                    </small>
                  </div>
                </div>
              </div>
              <div class="col" v-if="selectedIMPO?.budget_task_from_detail?.gl_code">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">GL From</h4>
                    <small class="text-body-secondary">
                      <span>
                        {{ `${selectedIMPO?.budget_task_from_detail?.gl_code} | ${selectedIMPO?.budget_task_from_detail?.account_name}` }}
                      </span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col" v-if="selectedIMPO?.budget_task_from_detail?.name">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Budget Task From</h4>
                    <small class="text-body-secondary"
                      ><span> {{ selectedIMPO?.budget_task_from_detail?.name }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col" v-if="selectedIMPO?.budget_task_to_detail?.department_name">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Departmen To</h4>
                    <small class="text-body-secondary"
                      ><span> {{ selectedIMPO?.budget_task_to_detail?.department_name }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col" v-if="selectedIMPO?.budget_task_to_detail?.plan_title">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Plan Title To</h4>
                    <small class="text-body-secondary"
                      ><span>
                        {{ `${selectedIMPO?.budget_task_to_detail?.plan_title} version ${selectedIMPO?.budget_task_to_detail?.plan_version}` }}</span
                      >
                    </small>
                  </div>
                </div>
              </div>
              <div class="col" v-if="selectedIMPO?.budget_task_to_detail?.fund_name">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Fund To</h4>
                    <small class="text-body-secondary"
                      ><span> {{ `${selectedIMPO?.budget_task_to_detail?.budget_type} | ${selectedIMPO?.budget_task_to_detail?.fund_name}` }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col" v-if="selectedIMPO?.budget_task_to_detail?.gl_code">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">GL To</h4>
                    <small class="text-body-secondary">
                      <span>
                        {{ `${selectedIMPO?.budget_task_to_detail?.gl_code} | ${selectedIMPO?.budget_task_to_detail?.account_name}` }}
                      </span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col" v-if="selectedIMPO?.budget_task_to_detail?.name">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Budget Task To</h4>
                    <small class="text-body-secondary"
                      ><span> {{ selectedIMPO?.budget_task_to_detail?.name }}</span>
                    </small>
                  </div>
                </div>
              </div>

              <!-- if type PK -->
              <div class="col" v-if="selectedIMPO?.taskDetail?.plan_title">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Plan Title From</h4>
                    <small class="text-body-secondary"
                      ><span> {{ `${selectedIMPO?.taskDetail?.plan_title} version ${selectedIMPO?.taskDetail?.plan_version}` }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col" v-if="selectedIMPO?.taskDetail?.fund_name">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Fund</h4>
                    <small class="text-body-secondary"
                      ><span> {{ `${selectedIMPO?.taskDetail?.budget_type} | ${selectedIMPO?.taskDetail?.fund_name}` }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col" v-if="selectedIMPO?.taskDetail?.gl_code">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">GL</h4>
                    <small class="text-body-secondary">
                      <span>
                        {{ `${selectedIMPO?.taskDetail?.gl_code} | ${selectedIMPO?.taskDetail?.account_name}` }}
                      </span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col" v-if="selectedIMPO?.taskDetail?.name">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Budget Task</h4>
                    <small class="text-body-secondary"
                      ><span> {{ selectedIMPO?.taskDetail?.name }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col" v-if="selectedIMPO?.month">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-calendar"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Budget Task Month</h4>
                    <small class="text-body-secondary"
                      ><span> {{ getMonthName(selectedIMPO?.month) }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col" v-if="selectedIMPO?.relocate_value">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Relocation Value</h4>
                    <small class="text-body-secondary"
                      ><span>Rp. {{ convertNumber(selectedIMPO?.relocate_value) }}</span>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>

      <!-- Footer -->
      <template #modal-footer>
        <b-button variant="outline-primary" @click="$bvModal.hide('modal-form-po')"> Cancel </b-button>
        <b-button v-if="isLoadingExpanses == false" @click="submitFormPo" variant="primary">
          {{ isEditPo ? 'Update' : 'Save' }}
        </b-button>
        <b-button v-else type="button" variant="primary" disabled>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Loading...
        </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-detail-contract" size="xl" title="Detail Contract" hide-footer dialog-class="full-width-modal">
      <div v-if="selectedContract" class="container">
        <!-- {{ JSON.stringify(selectedContract) }} -->
        <!-- GL & Budget Task -->
        <div class="row mb-3">
          <div class="col-md-3">
            <strong>GL</strong>
            <p>
              {{ selectedContract.contract.list_budget_gl.find((item) => item.budget_task_id === selectingPO[0]?.id)?.budget_gl }}
            </p>
          </div>
          <div class="col-md-3">
            <strong>Budget Task</strong>
            <p>{{ selectingPO[0]?.name }}</p>
          </div>
          <div class="col-md-3">
            <strong>Contract Name</strong>
            <p>
              {{ selectedContract.contract.no }} -
              {{ selectedContract.contract.name }}
            </p>
          </div>
          <div class="col-md-3">
            <strong>Type of Contract</strong>
            <p>{{ selectedContract.contract.typeContract.name }}</p>
          </div>
        </div>

        <!-- Contract Details -->
        <div class="row mb-3">
          <div class="col-md-3">
            <strong>Contract Value</strong>
            <p>Rp. {{ convertNumber(selectedContract.contract.contract_value) }}</p>
          </div>
          <div class="col-md-3">
            <strong>Remaining Budget</strong>
            <p>
              Rp.
              {{ convertNumber(selectedContract.contract.remaining_budget) }}
            </p>
          </div>
          <div class="col-md-3">
            <strong>Start Date</strong>
            <p>{{ selectedContract.contract.start_date }}</p>
          </div>
          <div class="col-md-3">
            <strong>End Date</strong>
            <p>{{ selectedContract.contract.end_date }}</p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-3">
            <strong>Total Duration (Month)</strong>
            <p>{{ selectedContract.contract.total_duration }}</p>
          </div>
          <div class="col-md-3">
            <strong>OA Number</strong>
            <p>{{ selectedContract.contract.oa_number }}</p>
          </div>
          <div class="col-md-3">
            <strong>Contract Owner</strong>
            <p>{{ selectedContract.contract.owner.fullname }}</p>
          </div>
          <div class="col-md-3">
            <strong>Contract Co-Owner/PMO</strong>
            <p>{{ selectedContract.contract.co_owner.fullname }}</p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-3">
            <strong>Vendor</strong>
            <p>{{ selectedContract.contract.vendor }}</p>
          </div>
          <div class="col-6">
            <strong>Scope of Work</strong>
            <p>{{ selectedContract.contract.scope_of_work }}</p>
          </div>
          <div class="col-md-3">
            <strong>Status</strong>
            <div class="status-box">
              <span :class="['status-badge', getStatusClass(selectedContract.contract.status)]">
                {{ selectedContract.contract.status }}
              </span>
            </div>
          </div>
        </div>

        <!-- Supporting File -->
        <div class="row mt-4">
          <div class="col-12">
            <strong>Supporting File</strong>
          </div>
          <div class="col-md-3">
            <ul class="list-unstyled">
              <li class="file-item">
                • ToR
                <span class="mt-2 mb-2" v-for="(file, index) in selectedContract.contract.upload_tor" :key="'tor-' + index">
                  <a @click.prevent="checkFileAvailability(file.file)" :href="file.file" target="_blank">{{ file.name }}</a
                  ><span v-if="index < selectedContract.contract.upload_tor.length - 1">, </span>
                </span>
              </li>
              <li class="file-item">
                • Contract Fully Signed
                <span class="mt-2 mb-2" v-for="(file, index) in selectedContract.contract.upload_fs" :key="'fs-' + index">
                  <a @click.prevent="checkFileAvailability(file.file)" :href="file.file" target="_blank">{{ file.name }}</a
                  ><span v-if="index < selectedContract.contract.upload_fs.length - 1">, </span>
                </span>
              </li>
            </ul>
          </div>
          <div class="col-md-3">
            <ul class="list-unstyled">
              <li class="file-item">
                • BoQ
                <span class="mt-2 mb-2" v-for="(file, index) in selectedContract.contract.upload_boq" :key="'boq-' + index">
                  <a @click.prevent="checkFileAvailability(file.file)" :href="file.file" target="_blank">{{ file.name }}</a
                  ><span v-if="index < selectedContract.contract.upload_boq.length - 1">, </span>
                </span>
              </li>
              <li class="file-item">
                • BAPP
                <span class="mt-2 mb-2" v-for="(file, index) in selectedContract.contract.upload_bapp" :key="'bapp-' + index">
                  <a @click.prevent="checkFileAvailability(file.file)" :href="file.file" target="_blank">{{ file.name }}</a
                  ><span v-if="index < selectedContract.contract.upload_bapp.length - 1">, </span>
                </span>
              </li>
            </ul>
          </div>
          <div class="col-md-3">
            <ul class="list-unstyled">
              <li class="file-item">
                • OE
                <span class="mt-2 mb-2" v-for="(file, index) in selectedContract.contract.upload_oe" :key="'oe-' + index">
                  <a @click.prevent="checkFileAvailability(file.file)" :href="file.file" target="_blank">{{ file.name }}</a
                  ><span v-if="index < selectedContract.contract.upload_oe.length - 1">, </span>
                </span>
              </li>
              <li class="file-item">
                • Others
                <template v-if="selectedContract.contract.upload_others && selectedContract.contract.upload_others.length">
                  <span class="mt-2 mb-2" v-for="(file, index) in selectedContract.contract.upload_others" :key="'others-' + index">
                    <a @click.prevent="checkFileAvailability(file.file)" :href="file.file" target="_blank">{{ file.name }}</a
                    ><span v-if="index < selectedContract.contract.upload_others.length - 1">, </span>
                  </span>
                </template>
              </li>
            </ul>
          </div>
          <div class="col-md-3">
            <ul class="list-unstyled">
              <li class="file-item">
                • NoA/SPP
                <span class="mt-2 mb-2" v-for="(file, index) in selectedContract.contract.upload_noa_spp" :key="'noa-' + index">
                  <a @click.prevent="checkFileAvailability(file.file)" :href="file.file" target="_blank">{{ file.name }}</a
                  ><span v-if="index < selectedContract.contract.upload_noa_spp.length - 1">, </span>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-detail-contract-po-pr" size="lg" title="Detail Contract - PR Name 1" hide-footer dialog-class="full-width-modal">
      <div class="container">
        <!-- GL & Budget Task -->
        <div class="row">
          <div class="col-md-6">
            <strong>GL</strong>
            <p>6480100 - 05.01 - Professional Fee Others</p>
          </div>
          <div class="col-md-6">
            <strong>Budget Task</strong>
            <p>Development Manage Service</p>
          </div>
        </div>

        <!-- PR Number & PO Number -->
        <div class="row mt-3">
          <div class="col-md-6">
            <strong>PR Number</strong>
            <p>0000000000</p>
          </div>
          <div class="col-md-6">
            <strong>PO Number</strong>
            <p>0000000000</p>
          </div>
        </div>

        <!-- Contract Name & Contract Detail -->
        <div class="row mt-3">
          <div class="col-md-6">
            <strong>Contract Name</strong>
            <p>88897621 - Contract Name 1</p>
          </div>
          <div class="col-md-6">
            <strong>Contract Detail</strong>
            <p>Contract Detail 1</p>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-new-contract-form" size="lg" title="Detail Contract">
      <!-- <form @submit.prevent="submitFormExpanses"> -->
      <!-- GL & Budget Task -->
      <div class="row">
        <div class="col-md-6" v-if="selectedTask && loadingSave == false">
          <strong>GL</strong>
          <p>6480100 - 05.01 - DUMMY Professional Fee Others</p>
        </div>
        <div class="col-md-6" v-if="selectedTask && loadingSave == false">
          <strong>Budget Task</strong>
          <p>{{ this.selectingPO[0]?.name }}</p>
        </div>
      </div>

      <!-- PR Name & PR Number -->
      <div class="form-row mt-3">
        <div class="form-group col-md-6">
          <label>PR Name</label>
          <p>PR Name 1</p>
        </div>
        <div class="form-group col-md-6">
          <label>PR Number</label>
          <p>000000000</p>
        </div>
      </div>

      <!-- PO Number & PO Date -->
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>PO Number</label>
          <p>000000000</p>
        </div>
      </div>

      <!-- Contract Name & Contract Detail -->
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>Contract Name</label>
          <select v-model="formExpanses.contractName" class="form-control">
            <option value="88897621 - Contract Name 1">88897621 - Contract Name 1</option>
          </select>
        </div>
        <div class="form-group col-md-6">
          <label>Contract Detail</label>
          <select v-model="formExpanses.contractDetail" class="form-control">
            <option value="" disabled>Select Contract Detail</option>
            <option value="Detail 1">Detail 1</option>
            <option value="Detail 2">Detail 2</option>
          </select>
        </div>
      </div>

      <!-- Tombol Aksi -->
      <!-- <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger" @click="showModal = false">Cancel</button>
          <button type="submit" class="btn btn-danger">Save</button>
        </div> -->
      <!-- </form> -->
      <template #modal-footer>
        <b-button variant="outline-primary" @click="$bvModal.hide('modal-new-contract-form')"> Cancel </b-button>
        <b-button v-if="isLoading == false" @click="submitFormExpanses" variant="primary"> Save </b-button>
        <b-button v-else type="button" variant="primary" disabled>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Loading...
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-form-detail-payment"
      size="xl"
      :title="isEditDetailPayment ? 'Edit Detail Payment Form' : 'New Detail Payment Form'"
      hide-footer
      @close="beforeCloseModalFormDetailPayment"
      ref="modalFormDetailPayment"
    >
      <form @submit.prevent="submitDetailPayment">
        <div class="container-fluid">
          <div class="row">
            <div class="card">
              <!--              <div class="card-header">
                BAST
              </div>-->
              <div class="card-body">
                <div class="row">
                  <!-- BAST Number -->
                  <div class="col-md-4">
                    <label> BAST Number </label>
                    <input
                      name="bast_number"
                      type="text"
                      v-model="formDetailPayment.bast_number"
                      class="form-control"
                      placeholder="Input BAST Number"
                      v-validate="'max:100'"
                    />
                    <span class="text-sm text-danger" v-show="errors.has('bast_number')">
                      BAST Number is required and must not exceed 100 characters.
                    </span>
                  </div>

                  <!-- BAST Date -->
                  <div class="col-md-4">
                    <label> BAST Date </label>
                    <input name="bast_date" type="date" v-model="formDetailPayment.bast_date" class="form-control" />
                    <span class="text-sm text-danger" v-show="errors.has('bast_date')"> BAST Date is required </span>
                  </div>

                  <!-- Vendor Name -->
                  <div class="col-md-4">
                    <label> Vendor Name </label>
                    <v-select
                      name="vendor_name"
                      :disabled="statuss === true"
                      v-model="formDetailPayment.vendor_name"
                      :options="filteredVendors"
                      placeholder="Type to search and press enter to select"
                      no-options-text="No vendors found."
                      taggable
                      @search="searchVendors"
                      @input="handleSelectedVendor(0, $event)"
                    />
                    <span class="text-sm text-danger" v-show="errors.has('vendor_name')"> Vendor Name is required </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <!--
              <div class="card-header">
                FAMS
              </div>
              -->
              <div class="card-body">
                <div class="row">
                  <!-- SES/GR Number -->
                  <div class="col-md-4 mt-3">
                    <label>SES/GR Number </label>
                    <v-select
                      name="ses_gr_number"
                      :options="listSesGrNumber"
                      :disabled="statuss === true"
                      v-model="formDetailPayment.ses_gr_number"
                      placeholder="Type to search and press enter to select"
                      label="grses_number"
                      taggable
                      @input="handleSelectedSesGrNumber(detailBudgetType, $event, 0)"
                    >
                      <template #no-options="{ search, searching, loading }"> No SES/GR Number found </template>
                    </v-select>
                    <span class="text-sm text-danger" v-show="errors.has('ses_gr_number')"> SES/GR Number is required </span>
                  </div>

                  <!-- INV Number -->
                  <div class="col-md-4 mt-3">
                    <label> INV Number </label>
                    <input
                      name="inv_number"
                      type="text"
                      v-model="formDetailPayment.inv_number"
                      class="form-control"
                      placeholder="Input INV Number"
                      v-validate="'max:100'"
                    />
                    <span class="text-sm text-danger" v-show="errors.has('inv_number')">
                      INV Number is required, and must not exceed 100 characters
                    </span>
                  </div>

                  <!-- DPP (Rp) -->
                  <div class="col-md-4 mt-3">
                    <label> DPP (Rp) </label>
                    <vue-numeric
                      name="dpp"
                      v-model="formDetailPayment.dpp"
                      class="form-control"
                      :precision="0"
                      :min="0"
                      separator=","
                      placeholder="Input DPP Number"
                      @blur="newDppCalculation(formDetailPayment.dpp, formDetailPayment.wht, formDetailPayment.vat, 'dpp')"
                      v-validate="'numeric'"
                    />
                    <!-- <RupiahInput
                      name="dpp"
                      v-model="formDetailPayment.dpp"
                      placeholder="Input DPP Number"
                      @blur="newDppCalculation(formDetailPayment.dpp, formDetailPayment.wht, formDetailPayment.vat, 'dpp')"
                      v-validate="'required|numeric'"
                    /> -->
                    <span class="text-sm text-danger" v-show="errors.has('dpp')"> DPP is required </span>
                  </div>
                  <div class="col-md-4 mt-3">
                    <label> VAT (Rp) </label>
                    <vue-numeric
                      name="vat"
                      v-model="formDetailPayment.vat"
                      class="form-control"
                      :precision="0"
                      separator=","
                      :min="0"
                      placeholder="Input VAT Number"
                      @blur="newDppCalculation(formDetailPayment.dpp, formDetailPayment.wht, formDetailPayment.vat, 'vat')"
                      v-validate="'numeric'"
                    />
                    <!-- <RupiahInput
                      name="vat"
                      v-model="formDetailPayment.vat"
                      placeholder="Input VAT Number"
                      @blur="newDppCalculation(formDetailPayment.dpp, formDetailPayment.wht, formDetailPayment.vat, 'vat')"
                      v-validate="'required|numeric'"
                    /> -->
                    <span class="text-sm text-danger" v-show="errors.has('vat')"> VAT is required </span>
                  </div>

                  <!-- WHT (Rp) -->
                  <div class="col-md-4 mt-3">
                    <label> WHT (Rp) </label>
                    <vue-numeric
                      name="wht"
                      v-model="formDetailPayment.wht"
                      class="form-control"
                      :precision="0"
                      separator=","
                      :min="0"
                      placeholder="Input WHT Number"
                      @blur="newDppCalculation(formDetailPayment.dpp, formDetailPayment.wht, formDetailPayment.vat, 'wht')"
                      v-validate="'numeric'"
                    />
                    <!-- <RupiahInput
                      name="wht"
                      v-model="formDetailPayment.wht"
                      placeholder="Input WHT Number"
                      @blur="newDppCalculation(formDetailPayment.dpp, formDetailPayment.wht, formDetailPayment.vat, 'wht')"
                      v-validate="'required|numeric'"
                    /> -->
                    <span class="text-sm text-danger" v-show="errors.has('wht')"> WHT is required </span>
                  </div>

                  <!-- After Tax (Rp) -->
                  <div class="col-md-4 mt-3">
                    <label> After Tax (Rp) </label>
                    <vue-numeric
                      name="after_tax"
                      :value="formDetailPayment.after_tax"
                      class="form-control"
                      :precision="0"
                      separator=","
                      placeholder="Auto Calculate"
                      disabled
                    />
                    <!-- <RupiahInput
                      name="after_tax"
                      :value="formDetailPayment.after_tax"
                      placeholder="Auto Calculate"
                      disabled
                    /> -->
                  </div>

                  <!-- Net Value (Rp) -->
                  <div class="col-md-4 mt-3">
                    <label> Net Value (Rp) </label>
                    <vue-numeric
                      name="net_value"
                      :value="formDetailPayment.net_value"
                      class="form-control"
                      :precision="0"
                      separator=","
                      placeholder="Auto Calculate"
                      disabled
                    />
                    <!-- <RupiahInput
                      name="net_value"
                      :value="formDetailPayment.net_value"
                      placeholder="Auto Calculate"
                      disabled
                    /> -->
                  </div>

                  <!-- FA Form Date -->
                  <div class="col-md-4 mt-3">
                    <label> FA Form Date </label>
                    <input name="fa_form_date" type="date" v-model="formDetailPayment.fa_form_date" class="form-control" />
                    <span class="text-sm text-danger" v-show="errors.has('fa_form_date')"> FA Form Date is required </span>
                  </div>

                  <!-- Doc To FA Date -->
                  <div class="col-md-4 mt-3">
                    <label> Doc To FA Date </label>
                    <input name="doc_to_fa_date" type="date" v-model="formDetailPayment.doc_to_fa_date" class="form-control" />
                    <span class="text-sm text-danger" v-show="errors.has('doc_to_fa_date')"> Doc To FA Date is required </span>
                  </div>

                  <!-- Payment Date -->
                  <div class="col-md-4 mt-3">
                    <label> Payment Date </label>
                    <input name="payment_date" type="date" v-model="formDetailPayment.payment_date" class="form-control" />
                    <span class="text-sm text-danger" v-show="errors.has('payment_date')"> Payment Date is required </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="card">
              <!--
              <div class="card-header">
                CONTRACT
              </div>
              -->
              <div class="card-body">
                <div class="row">
                  <!-- Contract Item -->
                  <div class="col-md-4 mt-3">
                    <label>
                      Contract Item
                      <span class="text-danger" v-show="listContractItem.length > 0"></span>
                    </label>
                    <v-select
                      name="contract_item"
                      v-model="formDetailPayment.contract_item"
                      :options="listContractItem"
                      label="label"
                      :reduce="(option) => option.value"
                      placeholder="Type to search Contract Item..."
                      no-options-text="No Contract Item found."
                      @input="onSelectContractItem"
                      clearable
                    />
                    <span class="text-sm text-danger" v-show="errors.has('contract_item')"> Contract Item is required </span>
                  </div>

                  <!-- Term -->
                  <div class="col-md-4 mt-3">
                    <label>
                      Term
                      <span class="text-danger" v-show="listContractItem.length > 0"></span>
                    </label>
                    <v-select
                      name="term"
                      v-model="formDetailPayment.term"
                      :disabled="!formDetailPayment.contract_item"
                      :options="listTerm"
                      label="label"
                      :reduce="(option) => option.value"
                      placeholder="Type to search Term..."
                      no-options-text="No Term found."
                      clearable
                    />
                    <span class="text-sm text-danger" v-show="errors.has('term')"> Term is required </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- VAT (Rp) -->
          </div>

          <!-- Action Buttons -->
          <div class="mt-4 d-flex justify-content-end">
            <b-button variant="outline-primary" class="mr-2" @click="beforeCloseModalFormDetailPayment" type="button"> Cancel </b-button>
            <b-button v-if="!isLoading" variant="primary" type="submit">
              {{ isEditDetailPayment ? 'Update' : 'Save' }}
            </b-button>
            <b-button v-else type="button" variant="primary" disabled>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Loading...
            </b-button>
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="modal-historical-log" size="xl" title="Historical Log Detail - Updated">
      <div class="container-fluid">
        <!-- Bagian Header -->
        <div class="row mb-3">
          <div class="col-md-3">
            <strong>GL</strong>
            <p>6480100 - 05.01 - Professional Fee Others</p>
          </div>
          <div class="col-md-3">
            <strong>Budget Task</strong>
            <p>Development Manage Service</p>
          </div>
          <div class="col-md-3">
            <strong>Update By</strong>
            <p>Name 1</p>
          </div>
          <div class="col-md-3">
            <strong>Update At</strong>
            <p>14 Desember 2024 11:05</p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-3">
            <strong>Total Budget</strong>
            <p>Rp. 400,000,000</p>
          </div>
          <div class="col-md-3">
            <strong>Total PO Value</strong>
            <p>Rp. 245,309,000</p>
          </div>
          <div class="col-md-3">
            <strong>BRS In</strong>
            <p>Rp. 0</p>
          </div>
          <div class="col-md-3">
            <strong>BRS Out</strong>
            <p>Rp. 46,000,000</p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-3">
            <strong>Remaining Budget</strong>
            <p>Rp. 153,000,000</p>
          </div>
          <div class="col-md-3">
            <strong>PR Name</strong>
            <p>PR Name 3</p>
          </div>
          <div class="col-md-3">
            <strong>PR Number</strong>
            <p>000000000</p>
          </div>
          <div class="col-md-3">
            <strong>PO Number</strong>
            <p>000000000</p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-3">
            <strong>PR Date</strong>
            <p>14-12-2024</p>
          </div>
          <div class="col-md-3">
            <strong>PO Date</strong>
            <p>14-12-2024</p>
          </div>
          <div class="col-md-3">
            <strong>PO Value</strong>
            <p>Rp. 4,210,000</p>
          </div>
          <div class="col-md-3">
            <strong>Total DPP</strong>
            <p>Rp. 4,210,000</p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-3">
            <strong>Contract Name</strong>
            <p>88897621 - Contract Name 1</p>
          </div>
          <div class="col-md-3">
            <strong>Contract Detail</strong>
            <p>Contract Detail 1</p>
          </div>
        </div>

        <!-- Tabel Detail Payment -->
        <h5 class="mt-3">Detail Payment</h5>
        <div class="table-responsive">
          <table class="table table-sm table-bordered">
            <thead class="thead-light">
              <tr>
                <th>Contract Item</th>
                <th>Term</th>
                <th>BAST Number</th>
                <th>BAST Date</th>
                <th>Vendor Name</th>
                <th>SES/GR Number</th>
                <th>INV Number</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Contract Item 1</td>
                <td>Term 1</td>
                <td>20000222</td>
                <td>14-12-2024</td>
                <td>Vendor Name 1</td>
                <td>100010001</td>
                <td>100010001</td>
              </tr>
              <tr>
                <td>Contract Item 2</td>
                <td>Term 2</td>
                <td>20000222</td>
                <td>14-12-2024</td>
                <td>Vendor Name 2</td>
                <td>100010002</td>
                <td>100010002</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Update Value Section -->
        <div class="mt-4 p-3 border rounded bg-white">
          <h5 class="mb-3 bg-warning text-white px-3 py-1 rounded" style="display: inline-block">Update Value</h5>

          <div class="row align-items-center">
            <!-- PR Name -->
            <div class="col-md-3">
              <div class="border p-3 rounded bg-light text-dark">
                <strong>PR Name</strong>
                <p class="mb-0">PR Name 1</p>
              </div>
            </div>

            <!-- Arrow -->
            <div class="col-md-1 text-center">
              <strong>➝</strong>
            </div>

            <!-- PR Name (Updated) -->
            <div class="col-md-3">
              <div class="border p-3 rounded bg-light text-dark">
                <strong>PR Name</strong>
                <p class="mb-0">PR Name 3</p>
              </div>
            </div>
          </div>

          <div class="row align-items-center mt-3">
            <!-- PO Value -->
            <div class="col-md-3">
              <div class="border p-3 rounded bg-light text-dark">
                <strong>PO Value</strong>
                <p class="mb-0">Rp. 5,030,000</p>
              </div>
            </div>

            <!-- Arrow -->
            <div class="col-md-1 text-center">
              <strong>➝</strong>
            </div>

            <!-- PO Value (Updated) -->
            <div class="col-md-3">
              <div class="border p-3 rounded bg-light text-dark">
                <strong>PO Value</strong>
                <p class="mb-0">Rp. 4,210,000</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <template #modal-footer>
        <b-button variant="outline-primary" @click="$bvModal.hide('modal-historical-log')"> Cancel </b-button>
      </template>
    </b-modal>
    <!-- Modal for Relocation Form -->
    <b-modal
      id="modal-plan-relocate"
      size="xl"
      v-if="selectedTask"
      :title="modalPlanRelocate"
      hide-footer
      @close="beforeCloseModalPlanRelocate"
      @hide="preventModalClose"
    >
      <form @submit.prevent="submitPlanRelocate">
        <div class="container-fluid card p-4">
          <label class="font-weight-bold">BRS Section</label>
          <div class="row">
            <!-- Int to Ext -->
            <template v-if="tabNow === 'intExt'">
              <div class="col-md-6 mt-3">
                <label>Department Sender</label>
                <div>
                  {{ selectingPO[0]?.department?.code }} -
                  {{ selectingPO[0]?.department?.name }}
                </div>
              </div>

              <div class="col-md-6 mt-3">
                <label>Department Recipient</label>
                <v-select
                  v-model="formPlanRelocate.dept_recipient"
                  label="department_name"
                  :options="filteredDeptIntToExtListFundCenter"
                  :reduce="(option) => option.id"
                  placeholder="Select Department Recipient"
                  @input="filterFund($event)"
                  name="dept_recipient"
                >
                  <template #option="{ department_code, department_name }"> {{ department_code }} - {{ department_name }} </template>
                  <template #selected-option="{ department_code, department_name }"> {{ department_code }} - {{ department_name }} </template>
                </v-select>
                <span class="text-danger">{{ errors.first('dept_recipient') }}</span>
              </div>

              <div class="col-md-6 mt-3">
                <label>Type</label>
                <v-select
                  v-model="formPlanRelocate.type"
                  :options="typeOf()"
                  @input="changeGLNew($event, formPlanRelocate.dept_recipient)"
                  placeholder="Select Type"
                  name="type"
                ></v-select>
                <span class="text-danger">{{ errors.first('type') }}</span>
              </div>

              <div class="col-md-6 mt-3">
                <label>Budget Item or GL tujuan</label>
                <v-select
                  v-model="formPlanRelocate.new_gl_number"
                  :options="listGLNumber"
                  label="label"
                  :reduce="(e) => e.id"
                  placeholder="Select GL Number"
                  @input="selectedFund($event, '', formPlanRelocate.type)"
                  name="new_gl_number"
                ></v-select>
              </div>
              <div class="col-md-6 mt-3">
                <label>Budget Task</label>
                <v-select
                  v-model="formPlanRelocate.origin_budget_task"
                  :options="listBudgetTask"
                  :reduce="(e) => e.code"
                  label="name"
                  placeholder="Select Budget Task"
                  name="origin_budget_task"
                  @input="selectTaskRelocate"
                ></v-select>
              </div>
            </template>

            <!-- Int to Int -->
            <template v-if="tabNow === 'intInt'">
              <div class="col-md-6 mt-3">
                <label>Department From</label>
                <div>
                  {{ selectingPO[0]?.department?.code }} -
                  {{ selectingPO[0]?.department?.name }}
                </div>
              </div>

              <div class="col-md-6 mt-3">
                <label>Department To</label>
                <div>
                  {{ selectingPO[0]?.department.code }} -
                  {{ selectingPO[0]?.department?.name }}
                </div>
              </div>

              <div class="col-md-6 mt-3">
                <label>Type</label>
                <v-select
                  v-model="formPlanRelocate.type"
                  :options="typeOf()"
                  @input="changeGLNew($event, deptFromId(listFundCenter))"
                  placeholder="Select Type"
                  name="type"
                  v-validate="'required'"
                  :disabled="modalUpdatePlanRelocate"
                ></v-select>
                <span class="text-danger">{{ errors.first('type') }}</span>
              </div>

              <div class="col-md-6 mt-3">
                <label>Budget Item or GL tujuan</label>
                <v-select
                  v-model="formPlanRelocate.new_gl_number"
                  :options="listGLNumber"
                  label="label"
                  :reduce="(e) => e.id"
                  placeholder="Select GL Number"
                  @input="selectedFund($event, '', formPlanRelocate.type)"
                  name="new_gl_number"
                  v-validate="'required'"
                  :disabled="!formPlanRelocate.type || modalUpdatePlanRelocate"
                ></v-select>
                <span class="text-danger">{{ errors.first('new_gl_number') }}</span>
              </div>

              <div class="col-md-6 mt-3">
                <label>Budget Task</label>
                <v-select
                  v-model="formPlanRelocate.new_budget_task"
                  :options="listBudgetTask"
                  label="name"
                  :reduce="(e) => e.code"
                  placeholder="Select Budget Task"
                  name="new_budget_task"
                  v-validate="'required'"
                  @input="selectTaskRelocate"
                  :disabled="!formPlanRelocate.new_gl_number || modalUpdatePlanRelocate"
                ></v-select>
                <span class="text-danger">{{ errors.first('new_budget_task') }}</span>
              </div>
            </template>

            <!-- Ext to Int -->
            <template v-if="tabNow === 'extInt'">
              <div class="col-md-6 mt-3">
                <label>Department From</label>
                <v-select
                  v-model="formPlanRelocate.dept_from"
                  :options="filteredDeptIntToExtListFundCenter"
                  label="department_name"
                  :reduce="(e) => e.id"
                  @input="filterFund($event)"
                  placeholder="Select Dept From"
                >
                  <template #option="{ department_code, department_name }"> {{ department_code }} - {{ department_name }} </template>
                  <template #selected-option="{ department_code, department_name }"> {{ department_code }} - {{ department_name }} </template>
                </v-select>
              </div>

              <div class="col-md-6 mt-3">
                <label>Department To</label>
                <div>
                  {{ selectingPO[0]?.department?.code }} -
                  {{ selectingPO[0]?.department?.name }}
                </div>
              </div>

              <div class="col-md-6 mt-3">
                <label>Type</label>
                <v-select
                  v-model="formPlanRelocate.type"
                  :options="typeOf()"
                  @input="changeGLNew($event, formPlanRelocate.dept_from)"
                  placeholder="Select Type"
                  name="type"
                ></v-select>
              </div>

              <div class="col-md-6 mt-3">
                <label>Budget Item or GL tujuan</label>
                <v-select
                  v-model="formPlanRelocate.new_gl_number"
                  :options="listGLNumber"
                  label="label"
                  :reduce="(e) => e.id"
                  placeholder="Select GL Number"
                  @input="selectedFund($event, '', formPlanRelocate.type)"
                  name="new_gl_number"
                ></v-select>
              </div>
              <div class="col-md-6 mt-3">
                <label>Budget Task</label>
                <v-select
                  v-model="formPlanRelocate.origin_budget_task"
                  :options="listBudgetTask"
                  label="name"
                  :reduce="(e) => e.code"
                  placeholder="Select Budget Task"
                  name="origin_budget_task"
                  @input="selectTaskRelocate"
                ></v-select>
              </div>
            </template>

            <div class="col-md-6 mt-3">
              <label>Delivery Date</label>
              <date-picker
                class="w-100 border-0"
                v-model="formPlanRelocate.delivery_date"
                valueType="format"
                placeholder="Select Delivery Date"
                name="delivery_date"
                v-validate="tabNow === 'intInt' ? 'required' : ''"
              />
              <FieldError name="delivery_date" label="Delivery Date" :errorBags="errors" />
            </div>

            <div class="col-md-6 mt-3">
              <label>Relocation Value</label>
              <RupiahInput
                name="relocation_value"
                v-model="formPlanRelocate.relocation_value"
                v-validate="tabNow === 'intInt' ? 'required|numeric|max_value:999999999999999' : 'numeric|max_value:999999999999999'"
                :disabled="withIm && selectedImRelocateValue > 0"
              />
              <FieldError name="relocation_value" label="Relocation Value" :errorBags="errors" />
            </div>
            <div class="col-md-6 mt-5">
              <div class="form-check mt-3">
                <input class="form-check-input" type="checkbox" value="" id="with-im" v-model="withIm" v-b-toggle.collapse-im />
                <label class="form-check-label" for="with-im"><i class="fe fe-tag text-danger"></i> With Internal Memo </label>
              </div>
            </div>
          </div>
        </div>

        <b-collapse id="collapse-im" :visible="withIm">
          <div class="card p-3 mt-3">
            <label class="font-weight-bold">Internal Memo Section</label>
            <div class="row row-cols-1 row-cols-lg-2">
              <div class="col mt-3">
                <label>Internal Memo Category</label>
                <v-select
                  v-model="formPlanRelocate.im_category"
                  :options="ImTypeOptions"
                  name="im_category"
                  :clearable="false"
                  v-validate="withIm ? 'required' : ''"
                ></v-select>
                <FieldError name="im_category" label="IM Category" :errorBags="errors" />
              </div>
              <div class="col mt-3">
                <label>Internal Memo</label>
                <v-select
                  v-model="formPlanRelocate.im_number_id"
                  :options="filteredListIm"
                  :reduce="(e) => e.id"
                  label="label"
                  name="im_number_id"
                  v-validate="withIm ? 'required' : ''"
                  @input="resetPlanRelocateFields(['im_projects_id', 'im_projects_relocates_id'])"
                ></v-select>
                <FieldError name="im_number_id" label="IM Number" :errorBags="errors" />
              </div>
              <div class="col mt-3">
                <label>IM Project</label>
                <v-select
                  v-model="formPlanRelocate.im_projects_id"
                  :options="listImProjects"
                  :reduce="(e) => e.id"
                  label="project_name"
                  name="im_projects_id"
                  v-validate="withIm ? 'required' : ''"
                  @input="resetPlanRelocateFields(['im_projects_relocates_id'])"
                ></v-select>
                <FieldError name="im_projects_id" label="IM Project" :errorBags="errors" />
              </div>
              <div class="col mt-3">
                <label>Project Relocation</label>
                <v-select
                  v-model="formPlanRelocate.im_projects_relocates_id"
                  :options="listImRelocates"
                  :reduce="(e) => e.id"
                  label="label"
                  name="im_projects_relocates_id"
                  v-validate="withIm ? 'required' : ''"
                  @input="selectImRelocate"
                ></v-select>
                <FieldError name="im_projects_relocates_id" label="Project Relocation" :errorBags="errors" />
              </div>
            </div>
          </div>
          <div class="card p-3 mt-3" v-if="formPlanRelocate.im_projects_relocates_id">
            <div class="row row-cols-1 row-cols-md-3 gx-3 gy-5 mt-2 mb-2">
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Departmen From</h4>
                    <small class="text-body-secondary"
                      ><span> {{ selectedImRelocate?.budget_task_from_detail?.department_name }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Plan Title From</h4>
                    <small class="text-body-secondary"
                      ><span>
                        {{
                          `${selectedImRelocate?.budget_task_from_detail?.plan_title} version ${selectedImRelocate?.budget_task_from_detail?.plan_version}`
                        }}</span
                      >
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Fund From</h4>
                    <small class="text-body-secondary"
                      ><span>
                        {{
                          `${selectedImRelocate?.budget_task_from_detail?.budget_type} | ${selectedImRelocate?.budget_task_from_detail?.fund_name}`
                        }}</span
                      >
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">GL From</h4>
                    <small class="text-body-secondary">
                      <span>
                        {{ `${selectedImRelocate?.budget_task_from_detail?.gl_code} | ${selectedImRelocate?.budget_task_from_detail?.account_name}` }}
                      </span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Budget Task From</h4>
                    <small class="text-body-secondary"
                      ><span> {{ selectedImRelocate?.budget_task_from_detail?.name }}</span>
                    </small>
                  </div>
                </div>
              </div>

              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Departmen To</h4>
                    <small class="text-body-secondary"
                      ><span> {{ selectedImRelocate?.budget_task_to_detail?.department_name }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Plan Title To</h4>
                    <small class="text-body-secondary"
                      ><span>
                        {{
                          `${selectedImRelocate?.budget_task_to_detail?.plan_title} version ${selectedImRelocate?.budget_task_to_detail?.plan_version}`
                        }}</span
                      >
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Fund To</h4>
                    <small class="text-body-secondary"
                      ><span>
                        {{
                          `${selectedImRelocate?.budget_task_to_detail?.budget_type} | ${selectedImRelocate?.budget_task_to_detail?.fund_name}`
                        }}</span
                      >
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">GL To</h4>
                    <small class="text-body-secondary">
                      <span>
                        {{ `${selectedImRelocate?.budget_task_to_detail?.gl_code} | ${selectedImRelocate?.budget_task_to_detail?.account_name}` }}
                      </span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Budget Task To</h4>
                    <small class="text-body-secondary"
                      ><span> {{ selectedImRelocate?.budget_task_to_detail?.name }}</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row align-items-center">
                  <div class="col-auto">
                    <div class="avatar avatar-sm">
                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i class="fe fe-home"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col ms-n2">
                    <h4 class="mb-1 font-weight-bold">Relocation Value</h4>
                    <small class="text-body-secondary"
                      ><span>Rp. {{ convertNumber(selectedImRelocate?.relocate_value) }}</span>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>

        <!-- Tombol Aksi -->
        <div class="modal-footer mt-3">
          <b-button variant="outline-primary" @click="beforeCloseModalPlanRelocate"> Cancel </b-button>
          <b-button variant="primary" type="submit" :disabled="isSubmitting">
            {{ modalUpdatePlanRelocate ? 'Update' : 'Save' }}
          </b-button>
        </div>
      </form>
    </b-modal>
    <ModalDetailBRS :detail="detailBrs" />
  </div>
</template>

<script>
import axios from 'axios';
import axiosIns from '@/api/axios';
import moment from 'moment';
import RupiahInput from '@/components/helpers/rupiahInput.vue';
import FieldError from '@/components/helpers/fieldError.vue';
import CustomPagination from '@/components/Pagination.vue';
import { onlyNumber, formatCurrency } from '@/utils/formatNumber';
import ModalDetailBRS from './components/ModalDetailBRS.vue';

export default {
  components: {
    RupiahInput,
    FieldError,
    CustomPagination,
    ModalDetailBRS,
  },
  // created() {
  //   // Saat pertama kali dirender, kosongkan data
  //   this.$store.commit("budgetMonitor/SET_LIST_DATA", []);
  // },
  beforeDestroy() {
    // Saat meninggalkan route, kosongkan data kembali
    this.$store.commit('budgetMonitor/SET_LIST_DATA', []);
  },
  computed: {
    list_box_opex_realization() {
      return this.$store.getters['ttAccount/list_box_opex_realization'];
    },
    list_box_capex_realization() {
      return this.$store.getters['ttAccount/list_box_capex_realization'];
    },
    ttAccount() {
      return this.$store.getters['ttAccount/listAccount'];
    },
    vendorList() {
      return this.$store.getters['budgetMonitor/listVendor'];
    },
    listUser() {
      return this.$store.getters['role/listData'];
    },
    budgetItem() {
      return this.$store.getters['opexGL/listData'];
    },
    listOpex: {
      get() {
        return this.$store.getters['budgetMonitor/listData'];
      },
      set(value) {
        this.$store.commit('SET_LIST_DATA', value);
      },
    },
    listCapex() {
      return this.$store.getters['budgetMonitor/listDataCapex'];
    },
    emails() {
      return this.$store.getters['role/identity'].email;
    },
    /*listCapexBudget() {
		let dat = this.$store.getters['capexGL/listData'].data;
		for (let i = 0; i < dat.length; i++) {
			/!*dat[i].label = `${dat[i].gl_code} - ${ dat[i].account_id } - ${ dat[i].account.account }`*!/
			dat[i].label = `${dat[i].account.account}`;
		}
		return dat?.filter((e) => e.fund.fund_center_id == '1');
	},*/
    listFundCenter() {
      return this.$store.getters['fundCenter/listData']?.data || [];
    },
    listIMPO() {
      return this.$store.getters['imNumber/listIMPO']?.map((e) => {
        return {
          ...e,
          label: `${e.im_number} - ${e.name}`,
        };
      });
    },
    listIM() {
      return this.$store.getters['imNumber/listIM']?.map((e) => {
        return {
          ...e,
          label: `${e.im_number} - ${e.name}`,
        };
      });
    },
    filteredListIm() {
      return this.listIM?.filter((e) => e.im_category == this.formPlanRelocate.im_category) || [];
    },
    listImProjects() {
      const projects = this.listIM?.find((e) => e.id == this.formPlanRelocate.im_number_id)?.im_projects || [];
      return projects;
    },
    listImRelocates() {
      const relocates =
        this.listImProjects
          ?.find((e) => e.id == this.formPlanRelocate.im_projects_id)
          ?.project_relocations?.map((r, idx) => {
            return {
              ...r,
              label: `Relocation ${idx + 1} | Rp. ${this.convertNumber(r.relocate_value)}`,
            };
          }) || [];
      console.log('listImRelocates', relocates);
      return relocates;
    },
    selectedImRelocate() {
      return this.listImRelocates?.find((e) => e.id == this.formPlanRelocate.im_projects_relocates_id) || null;
      return relocateValue;
    },
    selectedImRelocateValue() {
      const relocateValue = this.selectedImRelocate?.relocate_value || 0;
      return relocateValue;
    },
    selectedIMPO() {
      const im = this.listIMPO?.find((e) => e.id == this.formExpanses.imNumberId) || null;
      console.log('im', im);
      if (im) {
        if (im.im_category == 'Budget Relocation Statement (BRS)') {
          const project = im.im_projects?.find((e) => e.id == im?.budget_relocate?.im_projects_id) || null;
          const relocated = project?.project_relocations?.find((e) => e.id == im?.budget_relocate?.im_projects_relocates_id) || null;
          return { ...relocated, budget_relocate_id: im?.budget_relocate?.id, im_relocated_value: im?.relocate_value };
        } else {
          return { ...im.im_budget };
        }
      }
    },
    /*listUser() {
		return this.$store.getters['role/listData'].data;
		// let after = data.filter((e) => e.roles_id === "4")
		// return after
	},*/
    listProjectTags() {
      return this.$store.getters['projectTag/list'] || [];
    },
    listFilterContract() {
      return this.selectingPO[0]?.contract_budget?.map((e) => e.contract) || [];
    },
    filteredsPO() {
      // Clone the data to avoid mutating the original
      let filteredData = [...(this.selectingPO[0]?.actual_budget || [])];

      if (this.filterContract) {
        console.log('filterContract', this.filterContract);
        filteredData = filteredData.filter((item) => item.contract_id == this.filterContract);
      }

      // Apply search filter
      if (this.searchQuery) {
        this.currentPage = 1;
        const searchQueries = this.searchQuery
          .toLowerCase()
          .split(',')
          .map((query) => query.trim());
        filteredData = filteredData?.filter((item) => {
          const poName = item.po_name_label?.toLowerCase() || '';
          const poSubject = item.po_subject_label?.toLowerCase() || '';
          const prSubject = item.pr_subject_label?.toLowerCase() || '';
          return searchQueries.some((query) => poName.includes(query) || poSubject.includes(query) || prSubject.includes(query));
        });
      }

      if (this.filterTag) {
        this.currentPage = 1;
        filteredData = filteredData?.filter((item) => item.project_tag_id === this.filterTag);
      }

      // Apply sorting logic all pages
      // if (this.sortPRDate === 'asc') {
      //   filteredData.sort((a, b) => new Date(a.pr_date_label) - new Date(b.pr_date_label));
      // } else if (this.sortPRDate === 'desc') {
      //   filteredData.sort((a, b) => new Date(b.pr_date_label) - new Date(a.pr_date_label));
      // }

      // if (this.sortPODate === 'asc') {
      //   filteredData.sort((a, b) => new Date(a.po_date_label) - new Date(b.po_date_label));
      // } else if (this.sortPODate === 'desc') {
      //   filteredData.sort((a, b) => new Date(b.po_date_label) - new Date(a.po_date_label));
      // }

      // if (this.sortPRNumber === 'asc') {
      //   filteredData.sort((a, b) =>
      //     a.pr_subject_label ?.localeCompare(b.pr_subject_label, undefined, {
      //       numeric: true
      //     })
      //   );
      // } else if (this.sortPRNumber === 'desc') {
      //   filteredData.sort((a, b) =>
      //     b.pr_subject_label  .localeCompare(a.pr_subject_label, undefined, {
      //       numeric: true
      //     })
      //   );
      // }

      // if (this.sortPOName === 'asc') {
      //   filteredData.sort((a, b) =>
      //     a.po_name_label ?.localeCompare(b.po_name_label));
      // } else if (this.sortPOName === 'desc') {
      //   filteredData.sort((a, b) =>
      //     b.po_name_label ?.localeCompare(a.po_name_label)
      //   );
      // }

      // if (this.sortPONumber === 'asc') {
      //   filteredData.sort((a, b) =>
      //     a.po_subject_label ?.localeCompare(b.po_subject_label, undefined, {
      //       numeric: true
      //     })
      //   );
      // } else if (this.sortPONumber === 'desc') {
      //   filteredData.sort((a, b) =>
      //     b.po_subject_label ?.localeCompare(a.po_subject_label, undefined, {
      //       numeric: true
      //     })
      //   );
      // }

      return filteredData;
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = this.currentPage * this.itemsPerPage;

      // Ambil data halaman saat ini
      const pageData = this.filteredsPO.slice(start, end);

      // Sorting lokal hanya halaman ini
      if (this.sortPRDate === 'asc') {
        pageData.sort((a, b) => new Date(a.pr_date_label) - new Date(b.pr_date_label));
      } else if (this.sortPRDate === 'desc') {
        pageData.sort((a, b) => new Date(b.pr_date_label) - new Date(a.pr_date_label));
      }

      if (this.sortPODate === 'asc') {
        pageData.sort((a, b) => new Date(a.po_date_label) - new Date(b.po_date_label));
      } else if (this.sortPODate === 'desc') {
        pageData.sort((a, b) => new Date(b.po_date_label) - new Date(a.po_date_label));
      }

      if (this.sortPRNumber === 'asc') {
        pageData.sort((a, b) => (a.pr_subject_label || '').localeCompare(b.pr_subject_label || '', undefined, { numeric: true }));
      } else if (this.sortPRNumber === 'desc') {
        pageData.sort((a, b) => (b.pr_subject_label || '').localeCompare(a.pr_subject_label || '', undefined, { numeric: true }));
      }

      if (this.sortPOName === 'asc') {
        pageData.sort((a, b) => (a.po_name_label || '').localeCompare(b.po_name_label || ''));
      } else if (this.sortPOName === 'desc') {
        pageData.sort((a, b) => (b.po_name_label || '').localeCompare(a.po_name_label || ''));
      }

      if (this.sortPONumber === 'asc') {
        pageData.sort((a, b) => (a.po_subject_label || '').localeCompare(b.po_subject_label || '', undefined, { numeric: true }));
      } else if (this.sortPONumber === 'desc') {
        pageData.sort((a, b) => (b.po_subject_label || '').localeCompare(a.po_subject_label || '', undefined, { numeric: true }));
      }
      this.sumTotalBudgetActual;
      return pageData;
    },
    sumTotalBudgetActual() {
      let filteredData = this.filteredsPO;

      this.filterTotalPO = filteredData.reduce((acc, item) => acc + Number(item.po_value || 0), 0);
      this.filterTotalDPP = filteredData.reduce((acc, item) => acc + Number(item.totalDpp || 0), 0);
    },
    totalPages() {
      return Math.ceil(this.filteredsPO.length / this.itemsPerPage);
    },
    pageRange() {
      const start = Math.max(1, this.currentPage - Math.floor(this.maxPagesToShow / 2));
      const end = Math.min(this.totalPages, start + this.maxPagesToShow - 1);

      let pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
    listContract() {
      return this.$store.getters['budgetMonitor/listContract'] || [];
    },
    isLoadingExpanses() {
      return this.$store.getters['expanses/isLoadingExpanses'];
    },
    uContractUrl() {
      return process.env.VUE_APP_U_CONTRACT_LIST_CONTRACT;
    },
    filteredDeptIntToExtListFundCenter() {
      let tempFundCenter = [];
      if (this.tabNow !== 'intInt') {
        tempFundCenter = this.listFundCenter?.filter((item) => item.id.toString() !== this.activePlan?.fund_center_id);
      }
      return tempFundCenter;
    },
    mappedIntToExt() {
      console.log('intExt', this.intExt);
      let mappedData = this.intExt.map((item) => {
        return {
          department_code_from: item?.department_from?.code ?? '-',
          department_code_to: item?.department_to?.code ?? '-',
          department_name_from: item?.department_from?.name ?? '-',
          department_name_to: item?.department_to?.name ?? '-',
          type_from: item?.budget_task_from?.opex_gl_id != null ? 'OPEX' : 'CAPEX',
          type_to: item?.budget_task_to?.opex_gl_id != null ? 'OPEX' : 'CAPEX',
          gl_code_from:
            (item?.budget_task_from?.opex_gl_id ? item?.budget_task_from?.opex_gl?.gl_code : item?.budget_task_from?.capex_gl?.gl_code) ?? '-',
          gl_code_to: (item?.budget_task_to?.opex_gl_id ? item?.budget_task_to?.opex_gl?.gl_code : item?.budget_task_to?.capex_gl?.gl_code) ?? '-',
          budget_item_from:
            (item?.budget_task_from?.opex_gl_id
              ? item?.budget_task_from?.opex_gl?.budgetItem?.budget_item
              : item?.budget_task_from?.capex_gl?.account?.account) ?? '-',
          budget_item_to:
            (item?.budget_task_to?.opex_gl_id
              ? item?.budget_task_to?.opex_gl?.budgetItem?.budget_item
              : item?.budget_task_to?.capex_gl?.account?.account) ?? '-',
          fund_from: item?.budget_task_from?.fund?.fund ? item?.budget_task_from?.fund?.fund : '-',
          fund_to: item?.budget_task_to?.fund?.fund ? item?.budget_task_to?.fund?.fund : '-',
          budget_task_from: item?.budget_from?.name ?? '-',
          budget_task_to: item?.budget_to?.name ?? '-',
          delivery_date: item?.delivery_date ?? '',
          relocate_value: item?.relocate_value ?? 0,
          im_number: item?.im_number ? `${item?.im_number.im_number} - ${item?.im_number.name}` : '-',
          im_number_id: item?.im_number?.id ?? '',
          im_projects_id: item?.im_projects_id ?? '',
          im_projects_relocates_id: item?.im_projects_relocates_id ?? '',
          relocate_po: item?.relocate_po || [],
          budget_task_code_from: item.code_plan_budget,
          budget_task_code_to: item.budget_task,
          id: item?.id ?? '',
        };
      });
      // If have search
      if (this.filterIntToExt.search) {
        const searchTerm = this.filterIntToExt.search.toLowerCase().trim();
        mappedData = mappedData.filter((item) => {
          // Search through all properties of the item
          return Object.values(item).some((value) => {
            if (value === null || value === undefined) return false;
            return value.toString().toLowerCase().includes(searchTerm);
          });
        });
      }
      //If have delivery date filter
      if (
        this.filterIntToExt.delivery_date &&
        this.filterIntToExt.delivery_date.length > 0 &&
        this.filterIntToExt.delivery_date[0] != null &&
        this.filterIntToExt.delivery_date[1] != null
      ) {
        const [startDateStr, endDateStr] = this.filterIntToExt.delivery_date;

        const startDate = new Date(startDateStr);
        startDate.setHours(0, 0, 0, 0); // Start of day

        const endDate = new Date(endDateStr);
        endDate.setHours(23, 59, 59, 999); // End of day

        mappedData = mappedData.filter((item) => {
          // Skip items with no valid delivery date
          if (item.delivery_date === '-' || !item.delivery_date) return false;

          // Parse the item delivery date
          const itemDate = new Date(item.delivery_date);

          // Check if date is valid
          if (isNaN(itemDate.getTime())) return false;

          // Compare dates
          return itemDate >= startDate && itemDate <= endDate;
        });
      }

      return mappedData;
    },
    mappedIntToInt() {
      console.log('intInt', this.intInt);
      let mappedData = this.intInt.map((item) => {
        let data = {
          relocate_type: item?.relocate_type ?? '-',
          department_code_from: item?.department_from?.code ?? '-',
          department_code_to: item?.department_from?.code ?? '-',
          department_name_from: item?.department_from?.name ?? '-',
          department_name_to: item?.department_from?.name ?? '-',
          type_from: item?.budget_task_from?.opex_gl_id != null ? 'OPEX' : 'CAPEX',
          type_to: item?.budget_task_to?.opex_gl_id != null ? 'OPEX' : 'CAPEX',
          gl_code_from:
            (item?.budget_task_from?.opex_gl_id ? item?.budget_task_from?.opex_gl?.gl_code : item?.budget_task_from?.capex_gl?.gl_code) ?? '-',
          gl_code_to: (item?.budget_task_to?.opex_gl_id ? item?.budget_task_to?.opex_gl?.gl_code : item?.budget_task_to?.capex_gl?.gl_code) ?? '-',
          budget_item_from:
            (item?.budget_task_from?.opex_gl_id
              ? item?.budget_task_from?.opex_gl?.budgetItem?.budget_item
              : item?.budget_task_from?.capex_gl?.account?.account) ?? '-',
          budget_item_to:
            (item?.budget_task_to?.opex_gl_id
              ? item?.budget_task_to?.opex_gl?.budgetItem?.budget_item
              : item?.budget_task_to?.capex_gl?.account?.account) ?? '-',
          fund_from: item?.budget_task_from?.fund?.fund ? item?.budget_task_from?.fund?.fund : '-',
          fund_to: item?.budget_task_to?.fund?.fund ? item?.budget_task_to?.fund?.fund : '-',
          budget_task_from: item?.budget_from?.name ?? '-',
          budget_task_to: item?.budget_to?.name ?? '-',
          delivery_date: item?.delivery_date ?? '',
          relocate_value: item?.relocate_value ?? 0,
          im_number: item?.im_number ? `${item?.im_number.im_number} - ${item?.im_number.name}` : '-',
          im_number_id: item?.im_number?.id ?? '',
          im_projects_id: item?.im_projects_id ?? '',
          im_projects_relocates_id: item?.im_projects_relocates_id ?? '',
          relocate_type: item?.relocate_type ?? '-',
          relocate_po: item?.relocate_po || [],
          budget_task_code_from: item.code_plan_budget,
          budget_task_code_to: item.budget_task,
          id: item?.id ?? '',
        };
        if (item.relocate_type == 'INT-INT-TO') {
          data.fund_from = item?.budget_task_from?.fund?.fund ?? '-';
          data.fund_to = item?.budget_task_to?.fund?.fund ?? '-';
          data.budget_item_from = item?.budget_task_from?.opex_gl_id
            ? item?.budget_task_from?.opex_gl?.budgetItem?.budget_item
            : item?.budget_task_from?.capex_gl?.account?.account ?? '-';
          data.budget_item_to = item?.budget_task_to?.opex_gl_id
            ? item?.budget_task_to?.opex_gl?.budgetItem?.budget_item
            : item?.budget_task_to?.capex_gl?.account?.account ?? '-';
          data.gl_code_from = item?.budget_task_from?.opex_gl_id
            ? item?.budget_task_from?.opex_gl?.gl_code
            : item?.budget_task_from?.capex_gl?.gl_code ?? '-';
          data.gl_code_to = item?.budget_task_to?.opex_gl_id
            ? item?.budget_task_to?.opex_gl?.gl_code
            : item?.budget_task_to?.capex_gl?.gl_code ?? '-';
          data.type_from = item?.budget_task_from?.opex_gl_id != null ? 'OPEX' : 'CAPEX';
          data.type_to = item?.budget_task_to?.opex_gl_id != null ? 'OPEX' : 'CAPEX';
          data.budget_task_from = item?.budget_from?.name ?? '-';
          data.budget_task_to = item?.budget_to?.name ?? '-';
        }
        return data;
      });
      // If have search
      if (this.filterIntToInt.search) {
        const searchTerm = this.filterIntToInt.search.toLowerCase().trim();
        mappedData = mappedData.filter((item) => {
          // Search through all properties of the item
          return Object.values(item).some((value) => {
            if (value === null || value === undefined) return false;
            return value.toString().toLowerCase().includes(searchTerm);
          });
        });
      }
      // If have delivery date filter
      if (
        this.filterIntToInt.delivery_date &&
        this.filterIntToInt.delivery_date.length > 0 &&
        this.filterIntToInt.delivery_date[0] != null &&
        this.filterIntToInt.delivery_date[1] != null
      ) {
        const [startDateStr, endDateStr] = this.filterIntToInt.delivery_date;

        const startDate = new Date(startDateStr);
        startDate.setHours(0, 0, 0, 0); // Start of day

        const endDate = new Date(endDateStr);
        endDate.setHours(23, 59, 59, 999); // End of day

        mappedData = mappedData.filter((item) => {
          // Skip items with no valid delivery date
          if (item.delivery_date === '-' || !item.delivery_date) return false;

          // Parse the item delivery date
          const itemDate = new Date(item.delivery_date);

          // Check if date is valid
          if (isNaN(itemDate.getTime())) return false;

          // Compare dates
          return itemDate >= startDate && itemDate <= endDate;
        });
      }

      return mappedData;
    },
    mappedExtToInt() {
      console.log('extInt', this.extInt);
      let mappedData = this.extInt.map((item) => {
        let data = {
          department_code_from: item?.department_from?.code ?? '-',
          department_code_to: item?.department_to?.code ?? '-',
          department_name_from: item?.department_from?.name ?? '-',
          department_name_to: item?.department_to?.name ?? '-',
          type_from: item?.budget_task_to?.opex_gl_id != null ? 'OPEX' : 'CAPEX',
          type_to: item?.budget_task_from?.opex_gl_id != null ? 'OPEX' : 'CAPEX',
          gl_code_from: (item?.budget_task_to?.opex_gl_id ? item?.budget_task_to?.opex_gl?.gl_code : item?.budget_task_to?.capex_gl?.gl_code) ?? '-',
          gl_code_to:
            (item?.budget_task_from?.opex_gl_id ? item?.budget_task_from?.opex_gl?.gl_code : item?.budget_task_from?.capex_gl?.gl_code) ?? '-',
          budget_item_from:
            (item?.budget_task_to?.opex_gl_id
              ? item?.budget_task_to?.opex_gl?.budgetItem?.budget_item
              : item?.budget_task_to?.capex_gl?.account?.account) ?? '-',
          budget_item_to:
            (item?.budget_task_from?.opex_gl_id
              ? item?.budget_task_from?.opex_gl?.budgetItem?.budget_item
              : item?.budget_task_from?.capex_gl?.account?.account) ?? '-',
          fund_from: item?.budget_task_to?.fund?.fund ? item?.budget_task_to?.fund?.fund : '-',
          fund_to: item?.budget_task_from?.fund?.fund ? item?.budget_task_from?.fund?.fund : '-',
          budget_task_from: item?.budget_to_in ? item?.budget_to_in?.name : item?.budget_to?.name ?? '-',
          budget_task_to: item?.budget_from_in ? item?.budget_from_in?.name : item?.budget_from?.name ?? '-',
          delivery_date: item?.delivery_date ?? '',
          relocate_value: item?.relocate_value ?? 0,
          im_number: item?.im_number ? `${item?.im_number.im_number} - ${item?.im_number.name}` : '-',
          im_number_id: item?.im_number?.id ?? '',
          im_projects_id: item?.im_projects_id ?? '',
          im_projects_relocates_id: item?.im_projects_relocates_id ?? '',
          relocate_type: item?.relocate_type ?? '-',
          relocate_po: item?.relocate_po || [],
          fund_center_id: item?.fund_center_id ?? '-',
          budget_task_code_from: item.code_plan_budget,
          budget_task_code_to: item.budget_task,
          id: item?.id ?? '',
        };
        if (item.relocate_type == 'INT-EKS') {
          data.department_name_from = item?.budget_from_in?.fund_center?.department_name;
          data.department_name_to = item?.budget_to_in?.fund_center?.department_name;
          data.department_code_from = item?.budget_from_in?.fund_center?.department_code;
          data.department_code_to = item?.budget_to_in?.fund_center?.department_code;
          data.fund_from = item?.budget_task_from?.fund?.fund ? item?.budget_task_from?.fund?.fund : '-';
          data.fund_to = item?.budget_task_to?.fund?.fund ? item?.budget_task_to?.fund?.fund : '-';
          data.budget_task_from = item?.budget_from_in ? item?.budget_from_in?.name : item?.budget_from?.name ?? '-';
          data.budget_task_to = item?.budget_to_in ? item?.budget_to_in?.name : item?.budget_to?.name ?? '-';
          data.gl_code_from = item?.budget_task_from?.opex_gl_id
            ? item?.budget_task_from?.opex_gl?.gl_code
            : item?.budget_task_from?.capex_gl?.gl_code ?? '-';
          data.gl_code_to = item?.budget_task_to?.opex_gl_id
            ? item?.budget_task_to?.opex_gl?.gl_code
            : item?.budget_task_to?.capex_gl?.gl_code ?? '-';

          data.budget_item_from =
            (item?.budget_task_from?.opex_gl_id
              ? item?.budget_task_from?.opex_gl?.budgetItem?.budget_item
              : item?.budget_task_from?.capex_gl?.account?.account) ?? '-';
          data.budget_item_to =
            (item?.budget_task_to?.opex_gl_id
              ? item?.budget_task_to?.opex_gl?.budgetItem?.budget_item
              : item?.budget_task_to?.capex_gl?.account?.account) ?? '-';
          data.type_from = item?.budget_task_from?.opex_gl_id != null ? 'OPEX' : 'CAPEX';
          data.type_to = item?.budget_task_to?.opex_gl_id != null ? 'OPEX' : 'CAPEX';
        }
        return data;
      });
      // if have search
      if (this.filterExtToInt.search) {
        const searchTerm = this.filterExtToInt.search.toLowerCase().trim();
        mappedData = mappedData.filter((item) => {
          // Search through all properties of the item
          return Object.values(item).some((value) => {
            if (value === null || value === undefined) return false;
            return value.toString().toLowerCase().includes(searchTerm);
          });
        });
      }
      // If have delivery date filter
      if (
        this.filterExtToInt.delivery_date &&
        this.filterExtToInt.delivery_date.length > 0 &&
        this.filterExtToInt.delivery_date[0] != null &&
        this.filterExtToInt.delivery_date[1] != null
      ) {
        const [startDateStr, endDateStr] = this.filterExtToInt.delivery_date;

        const startDate = new Date(startDateStr);
        startDate.setHours(0, 0, 0, 0); // Start of day

        const endDate = new Date(endDateStr);
        endDate.setHours(23, 59, 59, 999); // End of day

        mappedData = mappedData.filter((item) => {
          // Skip items with no valid delivery date
          if (item.delivery_date === '-' || !item.delivery_date) return false;

          // Parse the item delivery date
          const itemDate = new Date(item.delivery_date);

          // Check if date is valid
          if (isNaN(itemDate.getTime())) return false;

          // Compare dates
          return itemDate >= startDate && itemDate <= endDate;
        });
      }

      return mappedData;
    },
    paginatedIntToExt() {
      const startIndex = (this.filterIntToExt.currentPage - 1) * this.filterIntToExt.perPage;
      const endIndex = startIndex + this.filterIntToExt.perPage;

      return this.mappedIntToExt.slice(startIndex, endIndex);
    },
    paginatedIntToInt() {
      const startIndex = (this.filterIntToInt.currentPage - 1) * this.filterIntToInt.perPage;
      const endIndex = startIndex + this.filterIntToInt.perPage;

      return this.mappedIntToInt.slice(startIndex, endIndex);
    },
    paginatedExtToInt() {
      const startIndex = (this.filterExtToInt.currentPage - 1) * this.filterExtToInt.perPage;
      const endIndex = startIndex + this.filterExtToInt.perPage;

      return this.mappedExtToInt.slice(startIndex, endIndex);
    },
  },
  watch: {
    selectedIds() {
      this.allSelected = this.paginatedItems.every((item) => this.selectedIds.includes(item.id));
    },
    listBudget() {
      const result = this.listBudget.reduce(
        (acc, item) => {
          // Process contracts
          if (item?.contract_budget?.length > 0) {
            item?.contract_budget?.forEach((contract) => {
              if (contract?.contract) {
                acc.contracts.add(contract?.contract_id);
              }
            });
          }

          // Process expenses
          const actualBudget = item.actual_budget || [];
          if (actualBudget && Array.isArray(actualBudget)) {
            acc.totalExpense += actualBudget.length;
            acc.linkedPoContract += actualBudget.filter((e) => e.contract_id !== null).length;
            for (const expense of actualBudget) {
              if (expense?.is_closed === true) {
                acc.expenseClose++;
              } else if (expense?.is_closed === false) {
                acc.expenseOpen++;
              }
            }
          }

          acc.totalBudget += BigInt(item.total);
          acc.totalDpp += BigInt(actualBudget.reduce((accu, curr) => accu + BigInt(curr.totalDpp || 0), 0n));

          return acc;
        },
        {
          totalExpense: 0,
          expenseOpen: 0,
          expenseClose: 0,
          contracts: new Set(),
          linkedPoContract: 0,
          totalBudget: BigInt(0),
          totalDpp: BigInt(0),
        }
      );

      console.log('contracts', result.contracts);

      this.budgetItemInfo = {
        totalExpense: result.totalExpense,
        expenseOpen: result.expenseOpen,
        expenseClose: result.expenseClose,
        totalTask: this.listBudget.length,
        totalContract: result.contracts.size,
        totalPoLinkedContract: result.linkedPoContract,
        totalBudget: result.totalBudget,
        totalDpp: result.totalDpp,
      };
    },
    selectingPO() {
      const budget = this.selectingPO[0]?.actual_budget || [];
      const closedExpenses = budget.filter((e) => e.is_closed === true);
      const openExpenses = budget.filter((e) => e.is_closed === false);
      const linkedContracts = budget.filter((e) => e.contract_id !== null);

      this.budgetTaskInfo = {
        totalExpense: budget.length,
        expenseOpen: openExpenses.length,
        expenseClose: closedExpenses.length,
        linkedContract: linkedContracts.length,
        totalDpp: budget.reduce((acc, curr) => acc + BigInt(curr.totalDpp || 0), 0n),
      };
    },
    formPlanRelocate: {
      handler() {
        console.log('formPlanRelocate', this.formPlanRelocate);
      },
      deep: true,
    },
  },
  data() {
    return {
      isValidPOValue: true,
      isSubmitting: false,
      selectTedDepartmentId: '',
      allSelected: false,
      filterTotalPO: 0,
      filterTotalDPP: 0,
      planId: 0,
      fundCenterId: 0,
      activePlan: [],
      filter: null,
      filterTag: null,
      isEditDetailPayment: false,
      isEditPo: false,
      currentPage: 1,
      itemsPerPage: 10,
      maxPagesToShow: 5,
      selectedIds: [],
      filteredVendors: [],
      allItems: [],
      budgetOpex: [],
      searchQuery: '',
      newFund: [],
      fundByOPEX: [],
      fundByCAPEX: [],
      extLabel: false,
      listViewer: [],
      glOpex: [],
      role_id: '',
      glCapex: [],
      loadingTask: false,
      idOfActual: '',
      po_val: '',
      body: {
        search: '',
      },
      listBudget: {},
      selectingPO: '',
      opexSelected: '',
      typeSelected: '',
      ttItemSelected: '',
      // codeBudgetPlanSelected: "",
      capexSelected: '',
      selectedTask: '',
      selectedContract: null,
      listSesGrNumber: [],
      isReview: false,
      bodyShare: {
        entity_type: '',
        entity_id: '',
        user_id: '',
      },
      bodyEmail: {
        to: ['yusak-putra@borneo-indobara.com', 'muhammad.krismansyah@borneo-indobara.com'],
        cc: ['budget-bib@sinarmasmining.com'],
        // to: [],
        // cc: [],
        id: [],
      },
      formExpanses: {
        budgetTask: '',
        prName: '',
        prNumber: '',
        prDate: null,
        poValue: '',
        prValue: '',
        poNumber: '',
        poDate: null,
        contractId: null,
        contractDetail: null,
        imNumberId: null,
        imCategory: null,
        projectTagId: null,
      },
      listPlanBudgetContract: [],
      listPlanBudgetContractDetail: [],
      listImNumber: [],
      detailRelocate: null,
      formDetailPayment: {
        id: null, // diisi saat edit
        code_actual_budget: '',
        bast_number: '',
        bast_date: '',
        vendor_name: '',
        inv_number: '',
        dpp: 0,
        vat: 0,
        wht: 0,
        after_tax: 0,
        net_value: 0,
        ses_gr_number: '',
        fa_form_date: '',
        doc_to_fa_date: '',
        payment_date: '',
        contract_item: '',
        term: '',
        isFieldDppCalculationDisabled: false,
      },
      listContractItem: [],
      listTerm: [],
      contractOptions: [
        {
          value: '88897621 - Contract Name 1',
          text: '88897621 - Contract Name 1',
        },
      ],
      contractDetailOptions: [
        { value: '', text: 'Select Contract Detail', disabled: true },
        { value: 'Detail 1', text: 'Detail 1' },
        { value: 'Detail 2', text: 'Detail 2' },
      ],
      // isType: ""
      sortPRDate: 'none',
      sortPRNumber: 'none',
      sortPODate: 'none',
      sortPOName: 'none',
      sortPONumber: 'none',
      intExt: [],
      intInt: [],
      extInt: [],
      tabNow: 'intExt',
      code_plan: '',
      titleBudget: '',
      transaction: [],
      tt_opex: 0,
      tt_capex: [],
      type: 'opex',
      code_actual: '',
      viewRelocateSelected: [],
      isOpex: true,
      isLoading: false,
      actualItem: [],
      selectedBudgetItem: '',
      loadingSave: false,
      statuss: false,
      rows: [
        {
          title: '1',
          description: '1',
          budget_total: 100,
          latest_version: 1,
        },
      ],
      columns: [
        {
          label: 'Title',
          field: 'title',
          thClass: 'table-header w-auto text-muted font-weight-bold',
          tdClass: 'w-autocolor-secondary align-middle',
        },
        {
          label: 'Description',
          field: 'description',
          thClass: 'table-header w-auto text-muted font-weight-bold',
          tdClass: 'w-autocolor-secondary align-middle',
        },
        {
          label: 'Budget Total',
          field: 'budget_total',
          thClass: 'table-header w-auto text-muted font-weight-bold',
          tdClass: 'w-autocolor-secondary align-middle',
        },
        {
          label: 'Version',
          field: 'latest_version',
          thClass: 'table-header w-auto text-muted font-weight-bold',
          tdClass: 'w-autocolor-secondary align-middle',
        },
        {
          label: 'Action',
          field: 'action',
          thClass: 'table-header w-auto text-muted font-weight-bold',
          tdClass: 'w-autocolor-secondary align-middle',
        },
      ],
      selectedLinkContract: null,
      plan_budget_id: '',
      // Modal budget plan relocate
      modalPlanRelocate: 'Relocate Plan',
      modalUpdatePlanRelocate: false,
      formPlanRelocate: {
        // Fields untuk Int to Ext
        id: null, // for Update
        dept_sender: '', // Readonly
        dept_recipient: '', // v-select
        type: '', // v-select (dependent dengan dept_recipient)
        new_gl_number: '', // Readonly
        new_fund_number: '', // Readonly
        new_budget_task: '', // Text input
        delivery_date: '', // Date-picker
        relocation_value: '', // Text input
        im_number_id: '', // v-select
        im_category: '', // v-select
        im_projects_id: '', // v-select
        im_projects_relocates_id: '', // v-select

        // Fields untuk Int to Int
        dept_from: '', // Readonly
        dept_to: '', // Readonly
        relocate_type: '', // Readonly
        type_int: '', // v-select
        new_gl_number_int: '', // v-select (dependent dengan type_int)
        new_fund_number_int: '', // Readonly
        new_budget_task_int: '', // v-select (dependent dengan type_int)

        // Fields untuk Ext to Int
        dept_from_ext: '', // v-select
        dept_to_ext: '', // Readonly
        type_ext: '', // v-select
        origin_gl_number: '', // v-select (dependent dengan type_ext)
        origin_fund_number: '', // Readonly
        origin_budget_task: '', // Text input
      },
      // List untuk v-select
      listDept: [
        { id: 1, name: 'Finance' },
        { id: 2, name: 'IT' },
        { id: 3, name: 'HR' },
      ], // List Departemen

      listType: [
        { id: 'opex', name: 'Operational Expenditure' },
        { id: 'capex', name: 'Capital Expenditure' },
      ], // List Type (untuk setiap jenis relokasi)

      listGLNumber: [], // List GL Number (dependent dengan type)

      listFundNumber: [
        { id: '00320202', name: '003.202.02' },
        { id: '00430506', name: '004.305.06' },
      ], // List Fund Number
      detailBudgetType: '',
      listBudgetTask: [], // List Budget Task (dependent dengan type)
      isRead: false,
      isCreat: false,
      isUpdate: false,
      isDelete: false,
      budgetItemInfo: {},
      budgetTaskInfo: {},
      selectedRow: {},
      filterContract: '',
      withIm: false,
      ImTypeOptions: ['Budget Relocation Statement (BRS)'],
      PoImTypeOptions: ['Budget Relocation Statement (BRS)', 'Pengajuan Khusus'],
      filterIntToExt: {
        search: '',
        delivery_date: [],
        perPage: 5,
        currentPage: 1,
        totalRow: 0,
      },
      filterIntToInt: {
        search: '',
        delivery_date: [],
        perPage: 5,
        currentPage: 1,
        totalRow: 0,
      },
      filterExtToInt: {
        search: '',
        delivery_date: [],
        perPage: 5,
        currentPage: 1,
        totalRow: 0,
      },
      detailBrs: {},
    };
  },
  mounted() {
    //this.getTTAccount();
    //this.getBudgetItem();
    //this.getCapexGL();
    this.getFundCenter();
    this.getListUser();
    //this.getOpexCapex();
    this.getVendorList();
    // this.getIM()
    this.checkPermission();
    this.getActivePlan();
    this.role_id = localStorage.getItem('roles');
    this.formPlanRelocate.dept_sender = this.deptFrom(this.listFundCenter);
    this.preloadOpexCapex();
  },
  methods: {
    async preloadOpexCapex() {
      this.type = 'capex';
      await this.searchBudget().then(async () => {
        this.type = 'opex';
        await this.searchBudget();
      });
    },
    async historicalLog() {
      this.$router.push(`/historical-log`);
    },
    async getActivePlan() {
      try {
        const response = await axiosIns.get('/plan/active-plan');
        this.activePlan = response?.data?.data;
        this.planId = this.activePlan?.id || 0;
        this.fundCenterId = this.activePlan?.fund_center?.id || 0;
        if (this.planId > 0 && this.fundCenterId > 0) {
          this.getListBoxOpexRealization(this.planId, this.fundCenterId);
          this.getListBoxCapexRealization(this.planId, this.fundCenterId);
        }
      } catch (error) {
        console.error('Failed to fetch active plan:', error);
      }
    },
    async checkPermission() {
      const roleName = localStorage.getItem('roles');
      const roleId = await axiosIns.get('/master-role/find-name?name=' + roleName);
      const menuId = await axiosIns.get('/master-menu/find-link?link=' + this.$route.path);
      const payloadPermission = {
        role_id: roleId.data.data[0]?.id || null,
        menu_id: menuId.data.data[0]?.id || null,
      };
      const checkAuth = await axiosIns.post('/master-role/check-permission', payloadPermission);
      if (checkAuth.data.data?.authorization) {
        this.isRead = checkAuth.data.data?.authorization.includes('read');
        this.isCreat = checkAuth.data.data?.authorization.includes('create');
        this.isUpdate = checkAuth.data.data?.authorization.includes('update');
        this.isDelete = checkAuth.data.data?.authorization.includes('delete');
      }
    },
    async beforeCloseModalPlanRelocate(bvModalEvt) {
      if (bvModalEvt) bvModalEvt.preventDefault();

      const confirm = await this.$swal({
        title: `Are you sure to close?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      });

      if (!confirm.isConfirmed) return;

      this.$bvModal.hide('modal-plan-relocate');
      this.resetFormPlanRelocate();
    },
    async beforeCloseModalFormDetailPayment(bvModalEvt) {
      if (bvModalEvt) bvModalEvt.preventDefault();

      const confirm = await this.$swal({
        title: `Are you sure to close?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      });

      if (!confirm.isConfirmed) return;

      this.$bvModal.hide('modal-form-detail-payment');
      this.resetFormDetailPayment();
    },
    async checkFileAvailability(url) {
      try {
        // Ensure the URL is using https
        if (!url.startsWith('https://')) {
          url = url.replace('http://', 'https://'); // If it's 'http://', switch to 'https://'
        }

        // Make a GET request to check if the file exists
        const response = await axios.get(url);

        if (response.status === 200) {
          // File exists, open the link
          window.open(url, '_blank');
        }
      } catch (error) {
        let errorMessage = 'An unexpected error occurred while checking the file.';

        // Handle different error scenarios
        if (error.response) {
          // If response status is 404, file not found
          if (error.response.status === 404) {
            errorMessage = 'The file you are trying to access is not available.';
          } else {
            // For other HTTP errors (like 500, 403, etc.)
            errorMessage = `Error: ${error.response.status} - ${error.response.statusText}`;
          }
        } else if (error.request) {
          // If no response was received, possible network issues
          errorMessage = 'Network error: Unable to reach the server.';
        } else {
          // If something went wrong in setting up the request
          errorMessage = `Error in setting up request: ${error.message}`;
        }

        // Show the error message using SweetAlert
        this.$swal.fire({
          title: 'Error',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    },
    handleInputPoValue(value) {
      if (value.includes('e') || value < 0) {
        value = value.replace(/[^0-9]/g, '');
      }
      this.formExpanses.poValue = value;

      this.$validator.errors.remove('poValueLimit');

      if (this.formExpanses?.totalDpp > 0 && this.formExpanses?.totalDpp > Number(this.formExpanses?.poValue)) {
        console.log('add error bag');
        // Add the new error
        this.$validator.errors.add({
          field: 'poValueLimit',
          msg: `PO value must be equal or greater than total DPP Rp. ${formatCurrency(this.formExpanses?.totalDpp)}`,
        });
      }
    },
    handleInputRelocateValue(value) {
      // Pastikan input hanya berisi angka positif dan tidak ada huruf 'e'
      if (value.includes('e') || value < 0) {
        this.formPlanRelocate.relocation_value = value.replace(/[^0-9]/g, ''); // Menghapus karakter selain angka
      } else {
        this.formPlanRelocate.relocation_value = value;
      }
    },
    handleInputNumber(e, field, obj) {
      const value = e.target.value;
      // Pastikan input hanya berisi angka positif dan tidak ada huruf 'e'
      if (value.includes('e') || value < 0) {
        this[obj][field] = value.replace(/[^0-9]/g, ''); // Menghapus karakter selain angka
      }
    },
    truncate(e, field, max, obj) {
      const fullValue = e.target.value;

      this[obj][field] = fullValue;

      if (fullValue.length > max) {
        e.target.value = fullValue.toString().substring(0, max);
      }
    },
    truncateInvNumber(e) {
      const fullValue = e.target.value;
      // Simpan nilai penuh ke model
      this.formDetailPayment.inv_number = fullValue;
      // Jika lebih dari 100 karakter, hanya tampilkan 100 karakter pertama
      if (fullValue.length > 100) {
        e.target.value = fullValue.substring(0, 100);
      }
    },
    getStatusClass(status) {
      switch (status) {
        case 'On Going':
          return 'status-on-going';
        case 'Closed':
          return 'status-closed';
        case 'Early Termination':
          return 'status-early-termination';
        case 'Expired Soon':
          return 'status-expired-soon';
        case 'Value Warning':
          return 'status-value-warning';
        default:
          return '';
      }
    },
    // START: Form Budget Plan relocate
    openModalPlanRelocate(title) {
      this.modalPlanRelocate = `Create Relocate Plan - ${title}`;
      this.modalUpdatePlanRelocate = false;
      this.withIm = false;
      this.resetFormPlanRelocate();
      this.$bvModal.show('modal-plan-relocate');
      console.log('tabNow: ', this.tabNow);
      if (this.tabNow === 'intInt') {
        this.getOpexCapexFilter(this.activePlan.fund_center_id || null);
      }
      this.formPlanRelocate.im_category = 'Budget Relocation Statement (BRS)';
    },
    async openUpdateModalPlanRelocate(title, item) {
      this.modalPlanRelocate = `Update Relocate Plan - ${title}`;
      this.modalUpdatePlanRelocate = true;
      this.$bvModal.show('modal-plan-relocate');
      console.log('isi item: ', item);
      if (this.tabNow === 'intExt') {
        this.formPlanRelocate = {
          ...this.formPlanRelocate, // Mempertahankan properti lain yang ada
          id: item?.id,
          dept_recipient: item?.fund_center_id || '',
          new_fund_number: item?.fund_id || '',
          type: item?.opex_gl_id ? 'OPEX' : item?.capex_gl_id ? 'CAPEX' : '', // Menentukan tipe berdasarkan data
          new_gl_number: item?.opex_gl_id || item.capex_gl_id || null, // Mengambil nilai GL berdasarkan tipe
          new_budget_task: item?.budget_task || '',
          delivery_date: item?.delivery_date || '',
          relocation_value: item?.relocate_value || 0,
          origin_budget_task: item?.budget_task,
        };
        const fund = this.listFundCenter.find((i) => i.id === this.formPlanRelocate?.dept_recipient)?.fund_center;
        await this.getOpexCapexFilter(fund?.substring(1) || null);
        let dtas;
        if (this.formPlanRelocate.type === 'OPEX') {
          this.listGLNumber = this.fundByOPEX;
          dtas = this.fundByOPEX?.filter((e) => e.id.toString() === (this.formPlanRelocate?.new_gl_number?.toString() || ''));
          this.formPlanRelocate.new_fund_number = dtas[0]?.fund?.id;
          this.formPlanRelocate.new_fund_number_label_fund = dtas[0]?.fund?.fund;
          this.listBudgetTask = dtas[0]?.budget_task || [];
        } else {
          this.listGLNumber = this.fundByCAPEX;
          dtas = this.fundByCAPEX?.filter((e) => e.id.toString() === (this.formPlanRelocate?.new_gl_number?.toString() || ''));
          this.formPlanRelocate.new_fund_number = dtas[0]?.fund?.id;
          this.formPlanRelocate.new_fund_number_label_fund = dtas[0]?.fund?.fund;
          this.listBudgetTask = dtas[0]?.budget_task || [];
        }
        let tempLabelFund = this.listGLNumber.filter((e) => e.code === this.formPlanRelocate?.new_gl_number);
        this.formPlanRelocate.new_fund_number_label_fund = tempLabelFund[0]?.fund?.fund || '';
      } else if (this.tabNow === 'intInt') {
        item = this.intInt.find((itm) => itm.id === item?.id);
        this.formPlanRelocate = {
          ...this.formPlanRelocate, // Mempertahankan properti lain yang ada
          id: item?.id,
          new_fund_number: item?.fund_id || '',
          type: item?.opex_gl_id ? 'OPEX' : item?.capex_gl_id ? 'CAPEX' : '', // Menentukan tipe berdasarkan data
          new_gl_number: item?.opex_gl_id || item?.capex_gl_id || null, // Mengambil nilai GL berdasarkan tipe
          new_budget_task: item?.budget_task || '',
          delivery_date: item?.delivery_date || '',
          relocation_value: item?.relocate_value || 0,
          origin_budget_task: item?.budget_task,
        };

        // Ambil dept_recipient berdasarkan fungsi deptFromId
        const deptRecipient = this.deptFromId(this.listFundCenter) || '';
        this.formPlanRelocate.dept_recipient = deptRecipient;

        const fund = this.listFundCenter.find((i) => i.id === this.activePlan?.fund_center_id)?.fund_center;
        await this.getOpexCapexFilter(fund?.substring(1) || null);
        let dtas;
        if (this.formPlanRelocate.type === 'OPEX') {
          this.listGLNumber = this.fundByOPEX;

          dtas = this.fundByOPEX?.filter((e) => e.id.toString() === (this.formPlanRelocate?.new_gl_number?.toString() || ''));
          this.formPlanRelocate.new_fund_number = dtas[0]?.fund?.id;
          this.formPlanRelocate.new_fund_number_label_fund = dtas[0]?.fund.fund;
          this.listBudgetTask = dtas[0]?.budget_task || [];
        } else {
          this.listGLNumber = this.fundByCAPEX;
          dtas = this.fundByCAPEX?.filter((e) => e.id.toString() === (this.formPlanRelocate?.new_gl_number?.toString() || ''));
          this.formPlanRelocate.new_fund_number = dtas[0]?.fund.id;
          this.formPlanRelocate.new_fund_number_label_fund = dtas[0]?.fund.fund;
          this.listBudgetTask = dtas[0]?.budget_task || [];
        }
        //.data.data.filter((e) => e.id == this.selectedTask);
        let tempLabelFund = this.listGLNumber.filter((e) => e.id === this.formPlanRelocate?.new_gl_number);
        this.formPlanRelocate.new_fund_number_label_fund = tempLabelFund[0]?.fund.fund || '';
      } else if (this.tabNow === 'extInt') {
        // Update formPlanRelocate dengan data dari item
        item = this.extInt.find((itm) => itm.id === item?.id);
        this.formPlanRelocate = {
          ...this.formPlanRelocate, // Mempertahankan properti lain yang ada
          id: item?.id,
          dept_from: item?.fund_center_id || '',
          new_fund_number: item.fund_id || '',
          type: item?.opex_gl_id ? 'OPEX' : item?.capex_gl_id ? 'CAPEX' : '', // Menentukan tipe berdasarkan data
          new_gl_number: item?.opex_gl_id || item?.capex_gl_id || null, // Mengambil nilai GL berdasarkan tipe
          origin_budget_task: item?.budget_task || '',
          delivery_date: item?.delivery_date || '',
          relocation_value: item?.relocate_value || 0,
          new_budget_task: item?.budget_task || '',
        };
        const fund = this.listFundCenter.find((i) => i.id === this.formPlanRelocate?.dept_from)?.fund_center;
        await this.getOpexCapexFilter(fund?.substring(1) || null);
        let dtas;
        let dtId = '';
        if (this.formPlanRelocate.type === 'OPEX') {
          this.listGLNumber = this.fundByOPEX;
          dtId = item?.budget_to?.id || item?.budget_to_in?.id;
          dtas = this.fundByOPEX?.filter((e) => e.id.toString() === (this.formPlanRelocate?.new_gl_number?.toString() || ''));
          this.formPlanRelocate.new_fund_number = dtas[0]?.fund?.id;
          this.formPlanRelocate.new_fund_number_label_fund = dtas[0]?.fund?.fund;
          this.listBudgetTask = dtas[0]?.budget_task || [];
        } else {
          this.listGLNumber = this.fundByCAPEX;
          dtas = this.fundByCAPEX?.filter((e) => e.id.toString() === (this.formPlanRelocate?.new_gl_number?.toString() || ''));
          this.formPlanRelocate.new_fund_number = dtas[0]?.fund?.id;
          this.formPlanRelocate.new_fund_number_label_fund = dtas[0]?.fund?.fund;
          this.listBudgetTask = dtas[0]?.budget_task || [];
        }
      }
      this.formPlanRelocate.im_number_id = item?.im_number_id || '';
      this.formPlanRelocate.im_projects_id = item?.im_projects_id;
      this.formPlanRelocate.im_projects_relocates_id = item?.im_projects_relocates_id;
      this.formPlanRelocate.im_category = item?.im_number?.im_category || '';
      if (item?.im_number_id) {
        this.withIm = true;
      } else {
        this.withIm = false;
      }
      this.getIM();
    },
    closeModalPlanRelocate() {
      this.$bvModal.hide('modal-plan-relocate');
    },
    async submitPlanRelocate() {
      // Validation
      const valid = await this.$validator.validateAll();
      console.log('Valid:', this.$validator.errors);
      if (!valid) {
        const errors = this.$validator.errors.all();
        console.log('Form has errors:', errors);
        return;
      }

      if (this.selectedImRelocateValue > 0 && this.selectedImRelocateValue < this.formPlanRelocate.relocation_value && this.withIm) {
        await this.$validator.errors.add({
          field: 'relocation_value',
          msg: `Relocation value must be less than Rp. ${this.convertNumber(this.selectedImRelocateValue)}`,
        });
      }

      if (this.$validator.errors.any()) {
        console.log('Form has errors, cannot submit');
        return;
      }

      this.loadingSave = true;
      this.isSubmitting = true;

      try {
        let payload = {};
        if (this.withIm) {
          payload.im_number_id = this.formPlanRelocate.im_number_id || null;
          payload.im_category = this.formPlanRelocate.im_category || null;
          payload.im_projects_id = this.formPlanRelocate.im_projects_id || null;
          payload.im_projects_relocates_id = this.formPlanRelocate.im_projects_relocates_id || this.formPlanRelocate.new_budget_task || null;
        }
        if (this.tabNow === 'intExt') {
          payload = {
            ...payload,
            process_type: this.getProcessType(), // Menentukan process_type berdasarkan tab aktif
            code_plan_budget: this.code_plan || null, // Harus diisi sesuai data
            fund_center_id: this.formPlanRelocate.dept_recipient || null, // Harus diisi sesuai data
            fund_id: this.formPlanRelocate.new_fund_number || null, // Harus diisi sesuai data
            opex_gl_id: this.formPlanRelocate.type === 'OPEX' ? this.formPlanRelocate.new_gl_number : null, // Hanya diisi jika ada
            capex_gl_id: this.formPlanRelocate.type === 'CAPEX' ? this.formPlanRelocate.new_gl_number : null, // Hanya diisi jika ada
            //budget_task: this.formPlanRelocate.new_budget_task || "", // Harus diisi sesuai data
            delivery_date: this.formPlanRelocate.delivery_date || null, // Harus diisi sesuai data
            relocate_value: onlyNumber(this.formPlanRelocate.relocation_value) || 0, // Harus diisi sesuai data
            budget_task: this.formPlanRelocate.origin_budget_task
              ? this.formPlanRelocate.origin_budget_task
              : this.formPlanRelocate.new_budget_task
              ? this.formPlanRelocate.new_budget_task
              : null,
            remaining_budget: onlyNumber(this.selectingPO[0]?.remaining_budget) || 0,
          };
        } else if (this.tabNow === 'intInt') {
          payload = {
            ...payload,
            process_type: this.getProcessType(), // Menentukan process_type berdasarkan tab aktif
            code_plan_budget: this.code_plan || null, // Harus diisi sesuai data
            fund_center_id: this.deptFromId(this.listFundCenter) || null, // Harus diisi sesuai data
            fund_id: this.formPlanRelocate.new_fund_number || null, // Harus diisi sesuai data
            opex_gl_id: this.formPlanRelocate.type === 'OPEX' ? this.formPlanRelocate.new_gl_number : null, // Hanya diisi jika ada
            capex_gl_id: this.formPlanRelocate.type === 'CAPEX' ? this.formPlanRelocate.new_gl_number : null, // Hanya diisi jika ada
            //budget_task: this.formPlanRelocate.new_budget_task || "", // Harus diisi sesuai data
            delivery_date: this.formPlanRelocate.delivery_date || null, // Harus diisi sesuai data
            relocate_value: onlyNumber(this.formPlanRelocate.relocation_value) || 0, // Harus diisi sesuai data
            budget_task: this.formPlanRelocate.origin_budget_task
              ? this.formPlanRelocate.origin_budget_task
              : this.formPlanRelocate.new_budget_task
              ? this.formPlanRelocate.new_budget_task
              : null,
            remaining_budget: onlyNumber(this.selectingPO[0]?.remaining_budget) || 0,
          };
          // Validasi input sebelum mengirimkan request
          // if (
          //   !payload.code_plan_budget ||
          //   !payload.fund_center_id ||
          //   !payload.fund_id ||
          //   !payload.budget_task ||
          //   !payload.delivery_date ||
          //   !payload.relocate_value ||
          //   !payload.im_number_id
          // ) {
          //   this.loadingSave = false;
          //   this.isSubmitting = false;
          //   console.log('Form has errors, cannot submit', payload);
          //   this.$swal({
          //     icon: 'warning',
          //     title: 'Incomplete Data',
          //     text: 'Please fill in all required fields before submitting.',
          //   });
          //   return;
          // }
        } else if (this.tabNow === 'extInt') {
          payload = {
            ...payload,
            process_type: this.getProcessType(), // Menentukan process_type berdasarkan tab aktif
            code_plan_budget: this.code_plan || null, // Harus diisi sesuai data
            fund_center_id: this.formPlanRelocate.dept_from || null, // Harus diisi sesuai data
            fund_id: this.formPlanRelocate.new_fund_number || null, // Harus diisi sesuai data
            opex_gl_id: this.formPlanRelocate.type === 'OPEX' ? this.formPlanRelocate.new_gl_number : null, // Hanya diisi jika ada
            capex_gl_id: this.formPlanRelocate.type === 'CAPEX' ? this.formPlanRelocate.new_gl_number : null, // Hanya diisi jika ada
            budget_task: this.formPlanRelocate.origin_budget_task || null, // Harus diisi sesuai data
            delivery_date: this.formPlanRelocate.delivery_date || null, // Harus diisi sesuai data
            relocate_value: onlyNumber(this.formPlanRelocate.relocation_value) || 0, // Harus diisi sesuai data
            remaining_budget: onlyNumber(this.selectingPO[0]?.remaining_budget) || 0,
          };
        }

        let response;

        // Update Relocate
        if (this.modalUpdatePlanRelocate && this.formPlanRelocate.id) {
          // Gunakan API PUT jika sedang dalam mode update
          response = await axiosIns.put(`/plan/relocate-v2/${this.formPlanRelocate.id}`, payload);
        }
        // Create Relocate
        else {
          // Gunakan API POST jika sedang dalam mode create
          response = await axiosIns.post('/plan/relocate-v2', payload);
        }

        // Tampilkan notifikasi sukses
        this.$swal({
          icon: 'success',
          title: 'Success',
          text: this.modalUpdatePlanRelocate ? 'Plan relocation has been successfully updated.' : 'Plan relocation has been successfully submitted.',
        });

        this.$bvModal.hide('modal-plan-relocate'); // Tutup modal setelah submit
        this.resetFormPlanRelocate(); // Reset form setelah submit
        this.resetFilterRelocate(); // Reset filter relocate

        await this.refreshMonitoringGL({
          success: 'Budget Relocation data has been updated',
          error: 'Failed to refresh Budget Relocation data',
        }); // Refresh data monitoring GL
        await this.changeTask('yes', this.listBudget, 'realization'); // Panggil ulang changeTask dengan listBudget terbaru
        this.loadingSave = false;
        this.isSubmitting = false;
      } catch (error) {
        const errorMessage = error.response?.data?.error || 'Failed to submit plan relocation. Please try again.';
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: errorMessage,
        });
        console.error('Error submitting plan relocation:', error);
        this.loadingSave = false;
        this.isSubmitting = false;
      }
    },

    // Fungsi untuk mendapatkan process_type berdasarkan tab aktif
    getProcessType() {
      switch (this.tabNow) {
        case 'intExt':
          return 'INT-EKS';
        case 'intInt':
          return 'INT-INT';
        case 'extInt':
          return 'EKS-INT';
        default:
          return '';
      }
    },

    // Fungsi untuk mereset form setelah submit
    resetFormPlanRelocate() {
      this.formPlanRelocate = {
        id: null,
        code_plan_budget: '',
        fund_center_id: '',
        fund_id: '',
        opex_gl_id: null,
        capex_gl_id: null,
        budget_task: '',
        delivery_date: '',
        relocate_value: 0,
        im_number_id: '',
        im_projects_id: '',
        im_projects_relocates_id: '',
        im_category: '',
      };
      this.withIm = false;
      this.$store.commit('imNumber/SET_LIST_IM', []);
    },
    // END: Form Budget Plan relocate

    async fetchContractItem() {
      try {
        const resp = await axiosIns.post(`/actual/contract-item/${this.selectedBudgetItem.contract_id}`);
        const items = resp.data.data || [];

        this.listContractItem = Array.from(new Set(items.map((item) => item.contract_item))).map((name) => ({
          label: name,
          value: name,
        }));
      } catch (error) {
        console.error('Failed to load contract items:', error);
        this.listContractItem = [];
      }
    },
    async onSelectContractItem(contractItem) {
      // reset term
      this.formDetailPayment.term = null;

      try {
        const resp = await axiosIns.post(`/actual/contract-item/${this.selectedBudgetItem.contract_id}`, {
          contract_item: contractItem,
        });
        const items = resp.data.data || [];

        this.listTerm = Array.from(new Set(items.map((item) => item.term))).map((name) => ({
          label: name,
          value: name,
        }));
      } catch (error) {
        console.error('Failed to load contract details:', error);
        this.listTerm = [];
      }
    },
    async openDetailPaymentModal(item) {
      this.isEditDetailPayment = true;
      this.formDetailPayment = {
        id: item.id,
        bast_number: item.bast_subject,
        bast_date: item.bast_date,
        vendor_name: item.vendor_name,
        ses_gr_number: item.ses_gr_no_subject,
        inv_number: item.inv_subject,
        dpp: Number(item.dpp),
        vat: Number(item.vat),
        wht: Number(item.wht),
        after_tax: Number(item.after_tax),
        net_value: Number(item.net_value),
        fa_form_date: item.fa_form,
        doc_to_fa_date: item.doc_to_fa,
        payment_date: item.payment_date,
        contract_item: item.contract_item,
        term: item.term,
      };
      await this.fetchContractItem();
      await this.searchSES(0, item.vendor_name);

      this.$bvModal.show('modal-form-detail-payment');
    },
    async submitDetailPayment() {
      const valid = await this.$validator.validateAll();

      if (!valid) {
        console.log('Form has errors.', this.$validator.errors.all());
        return;
      }

      const payload = {
        code_actual_budget: this.selectedBudgetItem.code_actual_budget, // Pastikan ini tersedia
        bast_number: this.formDetailPayment.bast_number,
        bast_date: this.formDetailPayment.bast_date,
        vendor_name: this.formDetailPayment.vendor_name,
        inv_number: this.formDetailPayment.inv_number,
        dpp: this.formDetailPayment.dpp || 0,
        vat: this.formDetailPayment.vat || 0,
        wht: this.formDetailPayment.wht || 0,
        after_tax: this.formDetailPayment.after_tax || 0,
        net_value: this.formDetailPayment.net_value || 0,
        ses_gr_number: this.formDetailPayment.ses_gr_number,
        fa_form_date: this.formDetailPayment.fa_form_date,
        doc_to_fa_date: this.formDetailPayment.doc_to_fa_date,
        payment_date: this.formDetailPayment.payment_date,
        contract_item: this.formDetailPayment.contract_item,
        term: this.formDetailPayment.term,
      };

      console.log('Payload:', payload);

      const confirm = await this.$swal({
        title: `Are you sure to ${this.isEditDetailPayment ? 'update' : 'create'} this data?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      });

      if (!confirm.isConfirmed) return;

      this.isLoading = true;

      try {
        if (this.isEditDetailPayment) {
          await axiosIns.put(`/plan-budget/actual-item/${this.formDetailPayment.id}`, payload);
          this.$swal({
            icon: 'success',
            title: 'Success',
            text: 'Successfully updated detail payment.',
          });
        } else {
          await axiosIns.post(`/plan-budget/actual-item`, payload);
          this.$swal({
            icon: 'success',
            title: 'Success',
            text: 'Successfully created detail payment.',
          });
        }

        this.$bvModal.hide('modal-form-detail-payment');

        this.resetFormDetailPayment();

        await this.refreshMonitoringGL({
          success: 'Budget Actual data has been updated',
          error: 'Failed to refresh Budget Actual data',
        }); // Refresh data monitoring GL

        // Cari budget terbaru sesuai ID
        await this.changeTask('yes', this.listBudget);
        const updatedBudget = this.selectingPO.find((item) => item.id === this.plan_budget_id);

        if (updatedBudget) {
          //await this.changeTask("yes", this.listBudget);

          // Cari index dari actual_budget yang sesuai idActual
          const actualBudgetIndex = updatedBudget.actual_budget.findIndex((item) => item.id === this.idOfActual);
          const actualBudgetItem = updatedBudget.actual_budget[actualBudgetIndex];

          if (actualBudgetItem) {
            this.newItem(
              actualBudgetItem, // Data budget utuh
              actualBudgetItem.code_actual_budget, // Code dari actual_budget item
              actualBudgetIndex, // Index actual_budget item
              actualBudgetItem.status, // Status actual_budget item
              false, // cond / isReview
              actualBudgetItem.po_value, // PO Value actual_budget item
              actualBudgetItem.id // ID actual_budget item
            );
          } else {
            console.error('Actual budget item not found after refresh!');
          }
        }
      } catch (error) {
        console.error('Failed:', error);
        const errorMessage = error.response?.data?.error || 'Failed. Please try again.';
        this.$swal({
          icon: 'error',
          title: this.isEditDetailPayment ? 'Failed to update detail payment.' : 'Failed to create detail payment.',
          text: errorMessage,
        });
      } finally {
        this.isLoading = false;
      }
    },
    resetFormDetailPayment() {
      this.formDetailPayment = {
        id: null,
        bast_number: '',
        bast_date: '',
        vendor_name: '',
        inv_number: '',
        dpp: 0,
        vat: 0,
        wht: 0,
        after_tax: 0,
        net_value: 0,
        ses_gr_number: '',
        fa_form_date: '',
        doc_to_fa_date: '',
        payment_date: '',
        contract_item: '',
        term: '',
      };
    },
    async fetchPlanBudgetContract() {
      try {
        const response = await axiosIns.get(`/plan-budget/contract/${this.plan_budget_id}`);
        this.listPlanBudgetContract = response.data.data;
      } catch (error) {
        console.error('Failed to load contracts:', error);
        this.listPlanBudgetContract = [];
      }
    },
    async fetchPlanBudgetContractDetail(contractId) {
      try {
        const response = await axiosIns.get(`/plan-budget/contract-detail/${contractId}`);
        this.listPlanBudgetContractDetail = response.data.data;
      } catch (error) {
        console.error('Failed to load contract details:', error);
        this.listPlanBudgetContractDetail = [];
      }
    },
    async fetchImNumber() {
      try {
        const response = await axiosIns.get(`/plan-relocate-v2?code=${this.code_plan}`);
        const datas = response.data.data?.map((e) => {
          return {
            ...e,
            id: e.id,
            label: `${e.im_number} - ${e.im_number_name}`,
          };
        });
        this.listImNumber = datas;
      } catch (error) {
        console.error('Failed to load IM Number:', error);
        this.listImNumber = [];
      }
    },
    async selectImNumber(budget_relocate_id) {
      if (!budget_relocate_id) {
        this.detailRelocate = null;
        return;
      }

      try {
        const response = await axiosIns.get(`/plan-relocate-v2/${budget_relocate_id}`);
        this.detailRelocate = response.data.data;
      } catch (error) {
        console.error('Failed to load Detail Relocate:', error);
        this.detailRelocate = null;
      }
    },
    async fetchProjectTags() {
      await this.$store.dispatch('projectTag/GET_LIST', {
        autocomplete: true,
        search: '',
      });
    },
    async openCreatePo() {
      await this.fetchPlanBudgetContract(); // get plan budget contract
      // await this.fetchImNumber() // get IM Number
      // await this.getIM()
      await this.fetchProjectTags();

      this.isEditPo = false;
      this.withIm = false;
      this.resetFormPo();
      this.$bvModal.show('modal-form-po');
    },
    async openEditPo(item, indx) {
      this.resetFormPo();
      await this.fetchPlanBudgetContract(); // get plan budget contract
      // await this.fetchImNumber() // get IM Number
      await this.selectImNumber(item.budget_relocate_id); // get detail relocate
      // await this.getIM()
      await this.fetchProjectTags();

      if (item.im_file_id) {
        this.withIm = true;
        await this.getIMPO(item?.im_number?.im_category || null);
      } else {
        this.withIm = false;
      }

      this.isEditPo = true;

      this.formExpanses = {
        id: item.id,
        prName: item.po_name,
        prNumber: item.pr_subject,
        prDate: item.pr_date,
        poValue: item.po_value,
        prValue: item.pr_value,
        poNumber: item.po_subject,
        poDate: item.po_date,
        contractName: item.contract_name,
        contractId: item.contract_id,
        contractDetail: item.contract_detail_name,
        projectTagId: Number(item.project_tag_id) || null,
        imCategory: item?.im_number?.im_category || null,
        imNumberId: Number(item.im_file_id) || null,
        totalDpp: Number(item.totalDpp) || 0,
      };

      this.$bvModal.show('modal-form-po');
    },
    async submitFormPo() {
      // Validation
      const valid = await this.$validator.validateAll();
      this.isValidPOValue = true;

      if (!valid || (await this.$validator.errors.any())) {
        console.log('Form has errors.', this.$validator.errors.all());
        return;
      }
      if (this.formExpanses.id) {
        const validPO = this.selectingPO[0]?.actual_budget.find((item) => item.id === this.formExpanses.id);
        const valuePO = (Number(this.selectingPO[0]?.remaining_budget) || 0) + Number(validPO?.po_value || 0) || 0;
        if (Number(this.formExpanses.poValue) > Number(valuePO)) {
          this.isValidPOValue = false;
          return;
        }
      } else {
        if (Number(this.formExpanses.poValue) > Number(this.selectingPO[0]?.remaining_budget)) {
          this.isValidPOValue = false;
          return;
        }
      }

      // Confirm
      const confirm = await this.$swal({
        title: `Are you sure to ${this.isEditPo ? 'update' : 'create'} this data?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      });

      if (!confirm.isConfirmed) return; // Jika cancel, hentikan proses

      const id = this.formExpanses.id;
      const payload = {
        code_plan_budget: this.code_plan, // Pastikan aman jika selectingPO kosong
        po_date: this.formExpanses.poDate,
        po_number: this.formExpanses.poNumber,
        po_value: Number(this.formExpanses.poValue) || 0,
        pr_value: Number(this.formExpanses.prValue) || 0,
        pr_date: this.formExpanses.prDate,
        po_name: this.formExpanses.prName,
        pr_number: this.formExpanses.prNumber,
        contract_id: this.formExpanses.contractId || '', // pastikan kamu set ini di formExpanses jika ada
        contract_detail_name: this.formExpanses.contractDetail || '',
        project_tag_id: this.formExpanses.projectTagId,
        plan_id: this.planId,
      };
      // if (this.withIm) {
      payload.im_file_id = this.formExpanses.imNumberId;
      payload.budget_relocate_id = this.selectedIMPO?.budget_relocate_id || '';
      // }

      if (this.isEditPo) {
        // Update
        try {
          await this.$store.dispatch('expanses/updateExpanses', {
            id,
            payload,
          });
          this.$bvModal.hide('modal-form-po');
          this.$swal({
            icon: 'success',
            title: 'Success',
            text: 'Successfully updated expanses data.',
          });

          this.searchBudget();
          await this.refreshMonitoringGL({
            success: 'Budget Actual data has been updated',
            error: 'Failed to refresh Budget Actual data',
          }); // Refresh data monitoring GL
          await this.changeTask('yes', this.listBudget); // Panggil ulang changeTask dengan listBudget terbaru
        } catch (error) {
          const errorMessage = error.response?.data?.error || 'Failed to update expanses data.';
          this.$swal({
            icon: 'error',
            title: 'Failed',
            html: errorMessage,
            didOpen: () => {
              const pre = document.querySelector('.swal2-html-container pre');

              if (pre) {
                pre.style.userSelect = 'text';
                pre.style.webkitUserSelect = 'text';
                pre.style.position = 'relative'; // For button positioning

                // Create the Copy Button
                const btn = document.createElement('button');
                btn.innerHTML = 'Copy';
                btn.type = 'button';
                btn.style.cssText = `
                position: absolute;
                right: 5px;
                top: 5px;
                padding: 2px 8px;
                font-size: 12px;
                cursor: pointer;
                background: #fff;
                border: 1px solid #ccc;
                border-radius: 4px;
                font-family: sans-serif;
                `;

                // Add Click Event to the Button
                btn.addEventListener('click', (e) => {
                  e.stopPropagation(); // Prevent modal interference

                  // Clean up text (remove "1. " or extra spaces if needed)
                  const textToCopy = pre.innerText.replace('Copy', '').trim();

                  navigator.clipboard.writeText(textToCopy).then(() => {
                    btn.innerText = '✓ Copied';
                    btn.style.backgroundColor = '#e8f5e9';
                    setTimeout(() => {
                      btn.innerText = 'Copy';
                      btn.style.backgroundColor = '#fff';
                    }, 2000);
                  });
                });

                // Append the button to the <pre> tag
                pre.appendChild(btn);
              }
            },
          });
          console.error('Failed to update:', error);
        }
      } else {
        // Create
        try {
          await this.$store.dispatch('expanses/saveExpanses', payload);
          this.$bvModal.hide('modal-form-po');
          this.$swal({
            icon: 'success',
            title: 'Success',
            text: 'Successfully saved expanses data.',
          });

          this.searchBudget();
          await this.refreshMonitoringGL({
            success: 'Budget Actual data has been updated',
            error: 'Failed to refresh Budget Actual data',
          }); // Refresh data monitoring GL
          await this.changeTask('yes', this.listBudget); // Panggil ulang changeTask dengan listBudget terbaru
        } catch (error) {
          const errorMessage = error.response?.data?.error || 'Failed to save expanses data.';
          this.$swal({
            icon: 'error',
            title: 'Failed',
            html: errorMessage,
            didOpen: () => {
              const pre = document.querySelector('.swal2-html-container pre');

              if (pre) {
                pre.style.userSelect = 'text';
                pre.style.webkitUserSelect = 'text';
                pre.style.position = 'relative'; // For button positioning

                // Create the Copy Button
                const btn = document.createElement('button');
                btn.innerHTML = 'Copy';
                btn.type = 'button';
                btn.style.cssText = `
                position: absolute;
                right: 5px;
                top: 5px;
                padding: 2px 8px;
                font-size: 12px;
                cursor: pointer;
                background: #fff;
                border: 1px solid #ccc;
                border-radius: 4px;
                font-family: sans-serif;
                `;

                // Add Click Event to the Button
                btn.addEventListener('click', (e) => {
                  e.stopPropagation(); // Prevent modal interference

                  // Clean up text (remove "1. " or extra spaces if needed)
                  const textToCopy = pre.innerText.replace('Copy', '').trim();

                  navigator.clipboard.writeText(textToCopy).then(() => {
                    btn.innerText = '✓ Copied';
                    btn.style.backgroundColor = '#e8f5e9';
                    setTimeout(() => {
                      btn.innerText = 'Copy';
                      btn.style.backgroundColor = '#fff';
                    }, 2000);
                  });
                });

                // Append the button to the <pre> tag
                pre.appendChild(btn);
              }
            },
          });
          console.error('Failed to save:', error);
        }
      }
    },
    resetFormPo() {
      this.formExpanses = {
        budgetTask: '',
        prName: '',
        prNumber: '',
        prDate: null,
        poValue: '',
        prValue: '',
        poNumber: '',
        poDate: null,
        contractId: null,
        contractDetail: null,
        imNumberId: null,
        imCategory: null,
        projectTagId: null,
      };
      this.withIm = false;
      this.$store.commit('imNumber/SET_LIST_IM_PO', []);
    },
    async submitLinkToContract() {
      if (!this.plan_budget_id || !this.selectedLinkContract) {
        this.$swal({
          icon: 'warning',
          title: 'Incomplete Data',
          text: 'Please select both Plan Budget and Contract.',
        });
        return;
      }

      const payload = {
        plan_budget_id: this.plan_budget_id,
        contract_id: this.selectedLinkContract, // karena pakai :reduce, langsung dapat id
      };

      try {
        this.isLoading = true;
        await axiosIns.post('/actual/contract', payload);

        this.$swal({
          icon: 'success',
          title: 'Success',
          text: 'Successfully linked contract to budget.',
        });

        this.$bvModal.hide('modal-link-to-contract');
        // reset selected link contract
        this.selectedLinkContract = null;

        await this.refreshMonitoringGL({
          success: 'Budget Actual data has been updated',
          error: 'Failed to refresh Budget Actual data',
        }); // Refresh data monitoring GL
        await this.changeTask('yes', this.listBudget); // Panggil ulang changeTask dengan listBudget terbaru
      } catch (error) {
        const errorMessage = error.response?.data?.error || 'Failed to link contract. Please try again.';
        this.$swal({
          icon: 'error',
          title: 'Failed',
          text: errorMessage,
        });
        console.error('Link contract failed:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async refreshMonitoringGL(msg) {
      try {
        const gl_code = this.opexSelected || this.capexSelected;
        const type = this.type; // pastikan this.type sudah ada (opex/capex)

        const response = await axiosIns.get(`/budget-realization/gl_code/${type}/${gl_code}`);

        this.listBudget = response.data.data;

        this.$swal({
          icon: 'success',
          title: 'Refreshed',
          // text: "Monitoring data has been updated.",
          text: msg.success,
        });
      } catch (error) {
        console.error(msg.error, error);
        this.$swal({
          icon: 'error',
          title: 'Failed',
          // text: "Failed to refresh monitoring data.",
          text: msg.error,
        });
      }
    },
    goToPage(page) {
      this.currentPage = page;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    async getFundCenter() {
      if (this.listFundCenter.length > 0) return;
      await this.$store.dispatch('fundCenter/GET_LIST_DATA', {
        pageNumber: 1,
        pageSize: 1000,
      });
    },
    getListUser() {
      let body = {
        search: this.body.search,
      };
      this.$store.dispatch('role/GET_LIST_DATA', body);
    },
    async getVendorList() {
      if (this.vendorList.length > 0) return;
      await this.$store.dispatch('budgetMonitor/GET_VENDORS').then((resp) => {
        this.filteredVendors = this.vendorList.slice(0, 10);
      });
    },
    async getIM() {
      if (this.formPlanRelocate.origin_budget_task || this.formPlanRelocate.new_budget_task) {
        const imYear = Number(this.activePlan?.year);
        const taskCodeFrom = this.code_plan;
        const taskCodeTo = this.formPlanRelocate.origin_budget_task || this.formPlanRelocate.new_budget_task;
        this.$store.dispatch('imNumber/GET_BY_BUDGET_TASK', { taskCodeFrom, taskCodeTo, imYear });
      }
    },
    selectIMPOCategory() {
      if (!this.formExpanses.imCategory) {
        this.withIm = false;
      } else {
        this.withIm = true;
      }
      this.formExpanses.imNumberId = '';
      this.$store.commit('imNumber/SET_LIST_IM_PO', []);
      this.getIMPO(this.formExpanses.imCategory);
    },
    async getIMPO(imCategory) {
      if (imCategory) {
        const imYear = Number(this.activePlan?.year);
        const taskCode = this.code_plan;
        this.$store.dispatch('imNumber/GET_FOR_PO', { imYear, imCategory, taskCode });
      }
    },
    getOpexCapex() {
      const fetchOpex = this.$store.dispatch('opexGL/GET_LIST_DATA', {
        pageNumber: 1,
        pageSize: 1000,
      });

      const fetchCapex = this.$store.dispatch('capexGL/GET_LIST_DATA', {
        pageNumber: 1,
        pageSize: 1000,
      });

      Promise.all([fetchOpex, fetchCapex])
        .then(() => {
          const opexData = this.$store.getters['opexGL/listData'].data;
          const capexData = this.$store.getters['capexGL/listData'].data;

          this.fundByOPEX = this.transformData(opexData, 'budgetItem');
          this.fundByCAPEX = this.transformData(capexData, 'account');
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    },
    async getOpexCapexFilter(fundCenter) {
      /*const search = fundCenter;

     try {
       await Promise.all([
         this.$store.dispatch("opexGL/GET_LIST_DATA", {
           pageNumber: 1,
           pageSize: 1000,
           search,
         }),
         this.$store.dispatch("capexGL/GET_LIST_DATA", {
           pageNumber: 1,
           pageSize: 1000,
           search,
         }),
       ]);

       const opexRows = this.$store.getters["opexGL/listData"]?.data || [];
       const capexRows = this.$store.getters["capexGL/listData"]?.data || [];

       this.fundByOPEX = this.transformDataFilter(
         opexRows,
         "budgetItem",
         "budget_item"
       );
       this.fundByCAPEX = this.transformDataFilter(
         capexRows,
         "account",
         "account"
       );
     } catch (e) {
       console.error("Error fetching OPEX/CAPEX:", e);
     }*/
      const search = fundCenter;
      let fund_center_id = '';
      if (this.tabNow === 'intExt') {
        fund_center_id = this.formPlanRelocate?.dept_recipient || '';
      } else if (this.tabNow === 'intInt') {
        fund_center_id = this.activePlan.fund_center_id || '';
      } else if (this.tabNow === 'extInt') {
        fund_center_id = this.formPlanRelocate.dept_from || '';
      }
      try {
        let year = this.activePlan?.year;
        console.log('fund_center_id: ', fund_center_id);
        console.log('tabNow: ', this.tabNow);
        if (fund_center_id) {
          const respPlant = await axiosIns.get(`${axiosIns.defaults.baseURL}/plan/find-by-fund-center-year/${fund_center_id}/${year}`);
          const respond = respPlant.data.data;
          const planIdTemp = respond.id;
          this.plan_id_to = planIdTemp;
          await Promise.all([
            this.$store.dispatch('opexGL/GET_LIST_DATA_BOX', {
              id: planIdTemp,
              fundCenterId: fund_center_id,
            }),
            this.$store.dispatch('capexGL/GET_LIST_DATA_BOX', {
              id: planIdTemp,
              fundCenterId: fund_center_id,
            }),
          ]);
          const opexRows = this.$store.getters['opexGL/listData'] || [];
          const capexRows = this.$store.getters['capexGL/listData'] || [];
          let tempOpexList = [];
          let tempCapexList = [];
          if (opexRows && opexRows.length > 0) {
            opexRows?.map((item) => {
              item?.budgetItems?.map((i) => {
                tempOpexList.push({
                  id: String(i?.opex_gl[0]?.id),
                  fund: i?.opex_gl[0]?.fund,
                  label: `${i?.opex_gl[0]?.gl_code} - ${i.budget_item || ''}`,
                  gl_code: i?.opex_gl[0]?.gl_code,
                  budget_task: i?.opex_gl[0]?.budget_task,
                });
              });
            });
          }
          if (capexRows && capexRows.length > 0) {
            capexRows?.map((item) => {
              item?.gl_code?.map((i) => {
                tempCapexList.push({
                  id: String(i?.id),
                  fund: i?.fund,
                  label: `${i?.gl_code} - ${i.account?.account || ''}`,
                  gl_code: i?.gl_code,
                  budget_task: i?.budget_task,
                });
              });
            });
          }
          this.fundByOPEX = tempOpexList;
          this.fundByCAPEX = tempCapexList;
        }

        console.log('fundByOPEX: ', this.fundByOPEX);
        console.log('fundByCAPEX: ', this.fundByCAPEX);
      } catch (e) {
        console.error('Error fetching OPEX/CAPEX:', e);
      }
    },

    transformData(data, labelKey) {
      const prop = labelKey == 'budgetItem' ? 'budget_item' : 'account';
      return data.map((item) => ({
        id: `${item.id}`,
        fund: item.fund,
        label: `${item.gl_code} - ${item[labelKey][prop.split('.')[0]]}`,
        gl_code: item.gl_code,
      }));
    },
    transformDataFilter(data, childKey, field) {
      return data.map((item) => ({
        id: String(item.id),
        fund: item.fund,
        label: `${item.gl_code} - ${item[childKey]?.[field] || ''}`,
        gl_code: item.gl_code,
      }));
    },
    detailBudget(item, title, type) {
      this.detailBudgetType = type;
      this.selectedRow = item;
      this.titleBudget = title;
      this.fetchProjectTags();
      this.listBudget = [];
      this.typeSelected = type;
      if (type === 'opex') {
        this.opexSelected = item.opex_gl.gl_code;
        this.ttItemSelected = item.budget_item.item;
        axiosIns.get(`${axiosIns.defaults.baseURL}/budget-realization/gl_code/${this.type}/${item.opex_gl.gl_code}`).then((resp) => {
          this.listBudget = resp.data.data;
          setTimeout(() => {
            this.$bvModal.show('modalBudget');
          }, 100);
        });
      } else {
        this.capexSelected = item.capex_gl.gl_code;
        axiosIns.get(`${axiosIns.defaults.baseURL}/budget-realization/gl_code/${this.type}/${item.capex_gl.gl_code}`).then((resp) => {
          this.listBudget = resp.data.data;
          setTimeout(() => {
            this.$bvModal.show('modalBudget');
          }, 100);
        });
      }
    },

    reviewBudget(item, title, type) {
      this.titleBudget = title;
      this.selectedRow = item;
      this.filterContract = null;
      this.listBudget = [];
      this.typeSelected = type;
      if (type === 'opex') {
        this.opexSelected = item.opex_gl.gl_code;
        axiosIns.get(`${axiosIns.defaults.baseURL}/budget-realization/gl_code/${this.type}/${item.opex_gl.gl_code}`).then((resp) => {
          this.listBudget = resp.data.data;
          setTimeout(() => {
            this.$bvModal.show('modalReview');
          }, 500);
        });
      } else {
        this.capexSelected = item.capex_gl.gl_code;
        axiosIns.get(`${axiosIns.defaults.baseURL}/budget-realization/gl_code/${this.type}/${item.capex_gl.gl_code}`).then((resp) => {
          this.listBudget = resp.data.data;
          setTimeout(() => {
            this.$bvModal.show('modalReview');
          }, 500);
        });
      }
    },

    async relocationBudget(item, title, type) {
      await this.getFundCenter();

      this.titleBudget = title;
      this.listBudget = [];
      this.typeSelected = type;
      if (type === 'opex') {
        this.opexSelected = item.opex_gl.gl_code;
        await axiosIns.get(`${axiosIns.defaults.baseURL}/budget-realization/gl_code/${this.type}/${item.opex_gl.gl_code}`).then((resp) => {
          this.listBudget = resp.data.data;
          setTimeout(() => {
            this.$bvModal.show('modalRelocation');
          }, 500);
        });
      } else {
        this.capexSelected = item.capex_gl.gl_code;
        await axiosIns.get(`${axiosIns.defaults.baseURL}/budget-realization/gl_code/${this.type}/${item.capex_gl.gl_code}`).then((resp) => {
          this.listBudget = resp.data.data;
          setTimeout(() => {
            this.$bvModal.show('modalRelocation');
          }, 500);
        });
      }
    },

    // filterUsers(dat) {
    //   return dat.filter((e) => e.roles_id === "4")
    // },

    selectTT(evt) {
      this.glOpex = [];
      this.budgetOpex = [];
      this.tt_opex = Number(evt);
      let budget = this.list_box_opex_realization.filter((e) => this.transaction.includes(e.id));
      budget?.map((items) => {
        items?.budgetItems?.map((i) =>
          this.budgetOpex.push({
            label: i?.budget_item,
            value: i.id,
            id: i.id,
            gl_code: i?.opex_gl[0]?.gl_code,
          })
        );
      });
    },

    async searchBudget() {
      this.isLoading = true;
      let body = {};
      if (this.type === 'opex') {
        let filterTransaction = this.list_box_opex_realization.filter((e) => this.transaction.includes(e.id));
        let tempTransactionId = [];

        this.list_box_opex_realization
          .filter((item) => this.transaction.includes(item.id))
          .forEach((item) => {
            if (item.budgetItems?.some((bi) => this.glOpex.includes(bi?.opex_gl?.[0]?.gl_code))) {
              tempTransactionId.push(item.id);
            }
          });
        filterTransaction = filterTransaction.filter((e) => !tempTransactionId.includes(e.id));
        let tempGL = [...this.glOpex];
        filterTransaction.forEach((item) => {
          item?.budgetItems?.map((i) => {
            tempGL.push(i?.opex_gl[0]?.gl_code);
          });
        });
        body = {
          type: this.type,
          account_id: this.type === 'opex' ? this.transaction : this.tt_capex,
          gl_code: tempGL, //this.type == 'opex' ? this.glOpex : this.glCapex,
        };
      }
      if (this.type === 'capex') {
        body = {
          type: this.type,
          gl_code: this.glCapex,
        };
      }
      /*else {
			body = {
				type: this.type,
				gl_code: this.type == 'opex' ? this.glOpex : this.glCapex,
			};
		}*/

      /*console.log("isi filterTransaction: ", filterTransaction, tempTransactionId)
     console.log("isi form: ", this.transaction, this.glOpex)
     console.log("isi tempGL: ", tempGL)*/

      await this.$store.dispatch('budgetMonitor/GET_LIST_MONITOR', body).finally(() => {
        this.isLoading = false;
      });
    },

    convertNumber(dat) {
      if (dat) {
        return dat.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return 0;
      }
    },
    convertMonth(dat) {
      if (dat) {
        return moment(dat).format('DD MMMM YYYY');
      } else {
        return '-';
      }
    },

    tabOpex() {
      this.type = 'opex';
      this.isOpex = true;
    },

    tabCapex() {
      this.type = 'capex';
      this.isOpex = false;
      //this.transaction = '';
      //this.glOpex = [];
    },

    afterValue(index, list) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to save changes?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          this.loadingSave = true;
          let send = this.selectingPO[0]?.actual_budget;
          for (let i = 0; i < this.selectingPO[0]?.actual_budget?.length; i++) {
            delete this.selectingPO[0]?.actual_budget[i]?.actual_budget_item;
            delete this.selectingPO[0]?.actual_budget[i]?.totalDpp;
          }
          if (this.type === 'opex') {
            this.$store
              .dispatch('budgetMonitor/ACTUAL_BEFORE', {
                datas: send,
              })
              .then((resp) => {
                axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/gl_code/${this.type}/${this.opexSelected}`).then((resp) => {
                  this.listBudget = resp.data.data;
                  this.selectingPO = resp.data.data.filter((e) => e.id == this.selectedTask);
                  this.selectingPO[0]?.actual_budget?.forEach((item) => {
                    item.pr_subject_label = item.pr_subject;
                    item.pr_date_label = item.pr_date;
                    item.po_subject_label = item.po_subject;
                    item.po_name_label = item.po_name;
                    item.po_date_label = item.po_date;
                  });
                  this.loadingSave = false;
                  this.searchBudget();
                  this.goToPage(1);
                  this.$swal
                    .mixin({
                      toast: true,
                      position: 'top-end',
                      showConfirmButton: false,
                      timer: 3000,
                      timerProgressBar: true,
                      didOpen: (toast) => {
                        toast.addEventListener('mouseenter', this.$swal.stopTimer);
                        toast.addEventListener('mouseleave', this.$swal.resumeTimer);
                      },
                    })
                    .fire({
                      icon: 'success',
                      title: 'Success Insert PO',
                    });
                });
              })
              .catch((err) => {
                this.loadingSave = false;
                this.$swal
                  .mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                      toast.addEventListener('mouseenter', this.$swal.stopTimer);
                      toast.addEventListener('mouseleave', this.$swal.resumeTimer);
                    },
                  })
                  .fire({
                    icon: 'error',
                    title: `${err.response.data.error}`,
                  });
              });
          } else {
            this.$store
              .dispatch('budgetMonitor/ACTUAL_BEFORE', {
                datas: send,
              })
              .then((resp) => {
                axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/gl_code/${this.type}/${this.capexSelected}`).then((resp) => {
                  this.listBudget = resp.data.data;
                  this.selectingPO = resp.data.data.filter((e) => e.id == this.selectedTask);
                  this.selectingPO[0]?.actual_budget?.forEach((item) => {
                    item.pr_subject_label = item.pr_subject;
                    item.pr_date_label = item.pr_date;
                    item.po_subject_label = item.po_subject;
                    item.po_name_label = item.po_name;
                    item.po_date_label = item.po_date;
                  });
                  this.loadingSave = false;
                  this.goToPage(1);
                  this.$swal
                    .mixin({
                      toast: true,
                      position: 'top-end',
                      showConfirmButton: false,
                      timer: 3000,
                      timerProgressBar: true,
                      didOpen: (toast) => {
                        toast.addEventListener('mouseenter', this.$swal.stopTimer);
                        toast.addEventListener('mouseleave', this.$swal.resumeTimer);
                      },
                    })
                    .fire({
                      icon: 'success',
                      title: 'PO has been Saved',
                    });
                });
              })
              .catch((err) => {
                console.log(err);
                this.loadingSave = false;
                this.$swal
                  .mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                      toast.addEventListener('mouseenter', this.$swal.stopTimer);
                      toast.addEventListener('mouseleave', this.$swal.resumeTimer);
                    },
                  })
                  .fire({
                    icon: 'error',
                    title: `${err.response.data.error}`,
                  });
              });
          }
        }
      });
    },
    saveRelocate() {
      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to save changes?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$validator.validateAll().then(async (res) => {
            if (!res) return false;
            try {
              this.loadingSave = true;
              if (this.tabNow == 'extInt') {
                let send = this.extInt;
                for (let i = 0; i < send.length; i++) {
                  // delete send[i].labelFund
                  // delete send[i].budget_from
                  // delete send[i].budget_to
                  // delete send[i].capex_gl
                  // delete send[i].capex_gl_id
                  // delete send[i].fund
                  // delete send[i].fund_center
                  // delete send[i].opex_gl
                  // delete send[i].relocate_type
                  if (send[i].hasOwnProperty('id')) {
                    send[i].code = send[i].code_plan_budget;
                  }
                }
                if (this.type == 'opex') {
                  this.$store
                    .dispatch('budgetMonitor/SAVE_RELOCATE_EXT', {
                      datas: send,
                    })
                    .then(() => {
                      this.searchBudget();
                      axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/gl_code/${this.type}/${this.opexSelected}`).then((resp) => {
                        this.listBudget = resp.data.data;
                        let budget = resp.data.data.filter((e) => e.id == this.selectedTask);
                        this.selectingPO = budget;
                        this.loadingSave = false;
                        this.intExt = budget[0]?.relocate.filter((e) => e.relocate_type === 'INT-EKS');
                        this.extInt = budget[0]?.relocate.filter((e) => e.relocate_type === 'EKS-INT');
                        this.intInt = budget[0]?.relocate.filter((e) => e.relocate_type.includes('INT-INT'));
                        this.$swal
                          .mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                              toast.addEventListener('mouseenter', this.$swal.stopTimer);
                              toast.addEventListener('mouseleave', this.$swal.resumeTimer);
                            },
                          })
                          .fire({
                            icon: 'success',
                            title: `Success insert Relocation`,
                          });
                      });
                    })
                    .catch((err) => {
                      this.$swal(`Error`, err.response.data.error, 'error');
                      this.loadingSave = false;
                    });
                } else {
                  this.searchBudget();
                  this.$store
                    .dispatch('budgetMonitor/SAVE_RELOCATE_EXT', {
                      datas: send,
                    })
                    .then(() => {
                      axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/gl_code/${this.type}/${this.capexSelected}`).then((resp) => {
                        this.listBudget = resp.data.data;
                        let budget = resp.data.data.filter((e) => e.id === this.selectedTask);
                        this.selectingPO = budget;
                        this.loadingSave = false;
                        this.intExt = budget[0]?.relocate.filter((e) => e.relocate_type === 'INT-EKS');
                        this.extInt = budget[0]?.relocate.filter((e) => e.relocate_type === 'EKS-INT');
                        this.intInt = budget[0]?.relocate.filter((e) => e.relocate_type.includes('INT-INT'));
                        this.$swal
                          .mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                              toast.addEventListener('mouseenter', this.$swal.stopTimer);
                              toast.addEventListener('mouseleave', this.$swal.resumeTimer);
                            },
                          })
                          .fire({
                            icon: 'success',
                            title: `Success insert Relocation`,
                          });
                      });
                    })
                    .catch((err) => {
                      this.$swal(`Error`, err.response.data.error, 'error');
                      this.loadingSave = false;
                    });
                }
              } else if (this.tabNow == 'intInt') {
                let send = [...this.intInt];
                let send2 = send.filter((e) => e.relocate_type !== 'INT-INT-TO');

                for (let i = 0; i < send2.length; i++) {
                  // delete send[i].labelFund
                  // delete send[i].budget_from
                  // delete send[i].budget_to
                  // delete send[i].capex_gl
                  // delete send[i].capex_gl_id
                  // delete send[i].fund
                  // delete send[i].fund_center
                  // delete send[i].opex_gl
                  // delete send[i].relocate_type
                  if (send2[i].hasOwnProperty('id')) {
                    send2[i].code = send[i].code_plan_budget;
                  }
                }
                if (this.type == 'opex') {
                  this.$store
                    .dispatch('budgetMonitor/SAVE_RELOCATE', {
                      datas: send2,
                    })
                    .then(() => {
                      this.searchBudget();
                      axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/gl_code/${this.type}/${this.opexSelected}`).then((resp) => {
                        this.listBudget = resp.data.data;
                        let budget = resp.data.data.filter((e) => e.id == this.selectedTask);
                        this.selectingPO = budget;
                        this.loadingSave = false;
                        this.intExt = budget[0]?.relocate.filter((e) => e.relocate_type === 'INT-EKS');
                        this.extInt = budget[0]?.relocate.filter((e) => e.relocate_type === 'EKS-INT');
                        this.intInt = budget[0]?.relocate.filter((e) => e.relocate_type.includes('INT-INT'));
                        this.$swal
                          .mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                              toast.addEventListener('mouseenter', this.$swal.stopTimer);
                              toast.addEventListener('mouseleave', this.$swal.resumeTimer);
                            },
                          })
                          .fire({
                            icon: 'success',
                            title: `Success insert Relocation`,
                          });
                      });
                    })
                    .catch((err) => {
                      this.$swal(`Error`, err.response.data.error, 'error');
                      this.loadingSave = false;
                    });
                } else {
                  this.$store
                    .dispatch('budgetMonitor/SAVE_RELOCATE', {
                      datas: send,
                    })
                    .then(() => {
                      this.searchBudget();
                      axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/gl_code/${this.type}/${this.capexSelected}`).then((resp) => {
                        this.listBudget = resp.data.data;
                        let budget = resp.data.data?.filter((e) => e.id === this.selectedTask);
                        this.selectingPO = resp.data.data?.filter((e) => e.id === this.selectedTask);
                        this.loadingSave = false;
                        this.intExt = budget[0]?.relocate?.filter((e) => e.relocate_type === 'INT-EKS');
                        this.extInt = budget[0]?.relocate?.filter((e) => e.relocate_type === 'EKS-INT');
                        this.intInt = budget[0]?.relocate?.filter((e) => e.relocate_type.includes('INT-INT'));
                        this.$swal
                          .mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                              toast.addEventListener('mouseenter', this.$swal.stopTimer);
                              toast.addEventListener('mouseleave', this.$swal.resumeTimer);
                            },
                          })
                          .fire({
                            icon: 'success',
                            title: `Success insert Relocation`,
                          });
                      });
                    })
                    .catch((err) => {
                      this.$swal(`Error`, err.response.data.error, 'error');
                      this.loadingSave = false;
                    });
                }
              } else if (this.tabNow == 'intExt') {
                let send = [...this.intExt];

                for (let i = 0; i < send.length; i++) {
                  // delete send[i].labelFund
                  // delete send[i].budget_from
                  // delete send[i].budget_to
                  // delete send[i].capex_gl
                  // delete send[i].capex_gl_id
                  // delete send[i].fund
                  // delete send[i].fund_center
                  // delete send[i].opex_gl
                  // delete send[i].relocate_type
                  if (send[i].hasOwnProperty('id')) {
                    send[i].code = send[i].code_plan_budget;
                  }
                }
                if (this.type == 'opex') {
                  this.$store
                    .dispatch('budgetMonitor/SAVE_RELOCATE', {
                      datas: send,
                    })
                    .then(() => {
                      this.searchBudget();
                      axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/gl_code/${this.type}/${this.opexSelected}`).then((resp) => {
                        this.listBudget = resp.data.data;
                        let budget = resp.data.data?.filter((e) => e.id == this.selectedTask);
                        this.selectingPO = budget;
                        this.loadingSave = false;
                        this.intExt = budget[0]?.relocate?.filter((e) => e.relocate_type === 'INT-EKS');
                        this.extInt = budget[0]?.relocate?.filter((e) => e.relocate_type === 'EKS-INT');
                        this.intInt = budget[0]?.relocate?.filter((e) => e.relocate_type.includes('INT-INT'));
                        this.$swal
                          .mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                              toast.addEventListener('mouseenter', this.$swal.stopTimer);
                              toast.addEventListener('mouseleave', this.$swal.resumeTimer);
                            },
                          })
                          .fire({
                            icon: 'success',
                            title: `Success insert Relocation`,
                          });
                      });
                    })
                    .catch((err) => {
                      this.$swal(`Error`, err.response.data.error, 'error');
                      this.loadingSave = false;
                    });
                } else {
                  this.$store
                    .dispatch('budgetMonitor/SAVE_RELOCATE', {
                      datas: send,
                    })
                    .then(() => {
                      this.searchBudget();
                      axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/gl_code/${this.type}/${this.capexSelected}`).then((resp) => {
                        this.listBudget = resp.data.data;
                        let budget = resp.data.data?.filter((e) => e.id === this.selectedTask);
                        this.selectingPO = resp.data.data?.filter((e) => e.id === this.selectedTask);
                        this.loadingSave = false;
                        this.intExt = budget[0]?.relocate?.filter((e) => e.relocate_type === 'INT-EKS');
                        this.extInt = budget[0]?.relocate?.filter((e) => e.relocate_type === 'EKS-INT');
                        this.intInt = budget[0]?.relocate?.filter((e) => e.relocate_type.includes('INT-INT'));
                        this.$swal
                          .mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                              toast.addEventListener('mouseenter', this.$swal.stopTimer);
                              toast.addEventListener('mouseleave', this.$swal.resumeTimer);
                            },
                          })
                          .fire({
                            icon: 'success',
                            title: `Success insert Relocation`,
                          });
                      });
                    })
                    .catch((err) => {
                      this.$swal(`Error`, err.response.data.error, 'error');
                      this.loadingSave = false;
                    });
                }
              }
            } catch (error) {
              this.$swal('Error', 'Error while add data', 'error');
            }
          });
        }
      });
    },

    deleteRow(item, index) {
      if (item.hasOwnProperty('id')) {
        this.$swal({
          title: 'Are you sure?',
          text: 'Delete mean remove all data and cannot be revert',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#00D97E',
          cancelButtonColor: '#E63757',
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
        })
          .then((result) => {
            if (result.isConfirmed) {
              axiosIns.delete(`${axiosIns.defaults.baseURL}/actual/${item.id}`).then(() => {
                this.searchBudget();
                this.loadingSave = true;
                if (this.type == 'opex') {
                  axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/gl_code/${this.type}/${this.opexSelected}`).then((resp) => {
                    this.listBudget = resp.data.data;
                    this.selectingPO = resp.data.data?.filter((e) => e.id == this.selectedTask);
                    this.loadingSave = false;
                  });
                } else {
                  axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/gl_code/${this.type}/${this.capexSelected}`).then((resp) => {
                    this.listBudget = resp.data.data;
                    this.selectingPO = resp.data.data?.filter((e) => e.id == this.selectedTask);
                    this.loadingSave = false;
                  });
                }
                this.$swal('Success', 'Data has been deleted', 'success');
              });
            }
          })
          .catch((err) => {
            this.$swal(`Error`, 'err.response.data.error', 'error');
          });
      } else {
        const actualIndex = (this.currentPage - 1) * this.itemsPerPage + index;
        // Remove the item from the original array
        this.selectingPO[0]?.actual_budget.splice(actualIndex, 1);
        // Adjust the current page if necessary
        if (this.currentPage > this.totalPages) {
          this.currentPage = this.totalPages;
        }
      }
    },
    deleteRowDetail(item, index) {
      if (item.hasOwnProperty('id')) {
        this.$swal({
          title: 'Are you sure?',
          text: 'Delete mean remove all data and cannot be revert',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#00D97E',
          cancelButtonColor: '#E63757',
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
        }).then((result) => {
          if (result.isConfirmed) {
            axiosIns
              .delete(`${axiosIns.defaults.baseURL}/actual-items/${item.id}`)
              .then(async (resp) => {
                this.loadingSave = true;
                this.$swal('Success', 'Data has been deleted', 'success');

                if (this.type == 'opex') {
                  axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/gl_code/${this.type}/${this.opexSelected}`).then((resp) => {
                    this.selectingPO = resp.data.data?.filter((e) => e.id == this.selectedTask);
                    this.selectingPO[0]?.actual_budget?.forEach((item) => {
                      item.pr_subject_label = item.pr_subject;
                      item.pr_date_label = item.pr_date;
                      item.po_subject_label = item.po_subject;
                      item.po_name_label = item.po_name;
                      item.po_date_label = item.po_date;
                    });
                    this.loadingSave = false;

                    const actualBudget = this.selectingPO[0]?.actual_budget?.filter((e) => e.id == this.idOfActual);
                    this.actualItem = actualBudget[0]?.actual_budget_item;
                  });
                } else {
                  axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/gl_code/${this.type}/${this.capexSelected}`).then((resp) => {
                    this.selectingPO = resp.data.data?.filter((e) => e.id == this.selectedTask);
                    this.selectingPO[0]?.actual_budget?.forEach((item) => {
                      item.pr_subject_label = item.pr_subject;
                      item.pr_date_label = item.pr_date;
                      item.po_subject_label = item.po_subject;
                      item.po_name_label = item.po_name;
                      item.po_date_label = item.po_date;
                    });
                    this.loadingSave = false;

                    const actualBudget = this.selectingPO[0]?.actual_budget?.filter((e) => e.id == this.idOfActual);
                    this.actualItem = actualBudget[0]?.actual_budget_item;
                  });
                }
              })
              .catch((err) => {
                this.$swal(`Error`, err.response.data.error, 'error');
              });
          }
        });
      } else {
        this.actualItem.splice(index, 1);
      }
    },

    isNumberInput(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberInput2(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    checkPOUsed(item) {
      return Array.isArray(item?.relocate_po) && item.relocate_po.length > 0;
    },

    deleteRelocation(id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Delete mean remove all data and cannot be revert',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          this.loadingSave = true;
          axiosIns
            .delete(`/plan/relocate-v2/${id}`)
            .then(async (resp) => {
              this.searchBudget();
              await this.refreshMonitoringGL({
                success: 'Budget Relocation data has been updated',
                error: 'Failed to refresh Budget Relocation data',
              }); // Refresh data monitoring GL
              await this.changeTask('yes', this.listBudget, 'realization'); // Panggil ulang changeTask dengan listBudget terbaru

              this.$swal({
                icon: 'success',
                title: 'Deleted',
                text: 'Plan relocation has been successfully deleted.',
              });

              this.loadingSave = false;
            })
            .catch((error) => {
              this.loadingSave = false;

              this.$swal({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.error || 'An error occurred while deleting the plan relocation.',
              });
            });
        }
      });
    },

    async changeTask(type, list, modal) {
      let budget = [];
      try {
        this.$swal({
          title: 'Loading...',
          text: 'Please wait while we process your request',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showConfirmButton: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
        console.log('modal: ', modal);
        if (modal === 'realization') {
          if (this.typeSelected === 'opex') {
            await axiosIns
              .get(`${axiosIns.defaults.baseURL}/budget-realization/gl_code/${this.type}/${this.opexSelected}/${this.selectedTask}`)
              .then(async (resp) => {
                budget = resp.data.data;
                this.code_plan = budget?.[0]?.code;
                this.plan_budget_id = budget?.[0]?.id;
                budget?.[0]?.actual_budget?.forEach((item) => {
                  item.pr_subject_label = item.pr_subject;
                  item.pr_date_label = item.pr_date;
                  item.po_subject_label = item.po_subject;
                  item.po_name_label = item.po_name;
                  item.po_date_label = item.po_date;
                });
                this.selectingPO = budget;

                this.currentPage = 1; // reset currect page table PO

                // if (type == 'yes') {
                this.viewRelocateSelected = budget?.[0]?.relocate;
                this.intExt = budget?.[0]?.relocate?.filter((e) => e.relocate_type === 'INT-EKS') || [];
                this.extInt = budget?.[0]?.relocate?.filter((e) => e.relocate_type === 'EKS-INT');
                let exts =
                  budget?.[0]?.relocate_in?.filter(
                    (e) => e.relocate_type !== 'EKS-INT' && e.relocate_type !== 'INT-INT-FROM' && e.relocate_type !== 'INT-INT-TO'
                  ) || [];
                let relocateExtToInt = [];
                for (const item of exts) {
                  this.extInt.push(item);
                }
                this.intInt = budget?.[0]?.relocate?.filter((e) => e.relocate_type.includes('INT-INT')) || [];
              });
          } else {
            await axiosIns
              .get(`${axiosIns.defaults.baseURL}/budget-realization/gl_code/${this.type}/${this.capexSelected}/${this.selectedTask}`)
              .then(async (resp) => {
                //this.listBudget = resp.data.data;
                budget = resp.data.data;
                this.code_plan = budget?.[0]?.code;
                this.plan_budget_id = budget?.[0]?.id;
                budget?.[0]?.actual_budget?.forEach((item) => {
                  item.pr_subject_label = item.pr_subject;
                  item.pr_date_label = item.pr_date;
                  item.po_subject_label = item.po_subject;
                  item.po_name_label = item.po_name;
                  item.po_date_label = item.po_date;
                });
                this.selectingPO = budget;

                this.currentPage = 1; // reset currect page table PO

                // if (type == 'yes') {
                this.viewRelocateSelected = budget?.[0]?.relocate;
                this.intExt = budget?.[0]?.relocate?.filter((e) => e.relocate_type === 'INT-EKS') || [];
                this.extInt = budget?.[0]?.relocate?.filter((e) => e.relocate_type === 'EKS-INT');
                let exts =
                  budget?.[0]?.relocate_in?.filter(
                    (e) => e.relocate_type !== 'EKS-INT' && e.relocate_type !== 'INT-INT-FROM' && e.relocate_type !== 'INT-INT-TO'
                  ) || [];
                let relocateExtToInt = [];
                for (const item of exts) {
                  this.extInt.push(item);
                }
                this.intInt = budget?.[0]?.relocate?.filter((e) => e.relocate_type.includes('INT-INT')) || [];
              });
          }
        } else {
          if (this.typeSelected === 'opex') {
            await axiosIns
              .get(`${axiosIns.defaults.baseURL}/budget-actual/gl_code/${this.type}/${this.opexSelected}/${this.selectedTask}`)
              .then(async (resp) => {
                budget = resp.data.data;
                this.code_plan = budget?.[0]?.code;
                this.plan_budget_id = budget?.[0]?.id;
                budget?.[0]?.actual_budget?.forEach((item) => {
                  item.pr_subject_label = item.pr_subject;
                  item.pr_date_label = item.pr_date;
                  item.po_subject_label = item.po_subject;
                  item.po_name_label = item.po_name;
                  item.po_date_label = item.po_date;
                });
                this.selectingPO = budget;

                this.currentPage = 1; // reset currect page table PO

                // if (type == 'yes') {
                this.viewRelocateSelected = budget?.[0]?.relocate;
                this.intExt = budget?.[0]?.relocate?.filter((e) => e.relocate_type === 'INT-EKS') || [];
                this.extInt = budget?.[0]?.relocate?.filter((e) => e.relocate_type === 'EKS-INT');
                let exts =
                  budget?.[0]?.relocate_in?.filter(
                    (e) => e.relocate_type !== 'EKS-INT' && e.relocate_type !== 'INT-INT-FROM' && e.relocate_type !== 'INT-INT-TO'
                  ) || [];
                let relocateExtToInt = [];
                for (const item of exts) {
                  this.extInt.push(item);
                }
                this.intInt = budget?.[0]?.relocate?.filter((e) => e.relocate_type.includes('INT-INT')) || [];
              });
          } else {
            await axiosIns
              .get(`${axiosIns.defaults.baseURL}/budget-actual/gl_code/${this.type}/${this.capexSelected}/${this.selectedTask}`)
              .then(async (resp) => {
                //this.listBudget = resp.data.data;
                budget = resp.data.data;
                this.code_plan = budget?.[0]?.code;
                this.plan_budget_id = budget?.[0]?.id;
                budget?.[0]?.actual_budget?.forEach((item) => {
                  item.pr_subject_label = item.pr_subject;
                  item.pr_date_label = item.pr_date;
                  item.po_subject_label = item.po_subject;
                  item.po_name_label = item.po_name;
                  item.po_date_label = item.po_date;
                });
                this.selectingPO = budget;

                this.currentPage = 1; // reset currect page table PO

                // if (type == 'yes') {
                this.viewRelocateSelected = budget?.[0]?.relocate;
                this.intExt = budget?.[0]?.relocate?.filter((e) => e.relocate_type === 'INT-EKS') || [];
                this.extInt = budget?.[0]?.relocate?.filter((e) => e.relocate_type === 'EKS-INT');
                let exts =
                  budget?.[0]?.relocate_in?.filter(
                    (e) => e.relocate_type !== 'EKS-INT' && e.relocate_type !== 'INT-INT-FROM' && e.relocate_type !== 'INT-INT-TO'
                  ) || [];
                let relocateExtToInt = [];
                for (const item of exts) {
                  this.extInt.push(item);
                }
                this.intInt = budget?.[0]?.relocate?.filter((e) => e.relocate_type.includes('INT-INT')) || [];
              });
          }
        }
        console.log('plan_budget_id: ', this.plan_budget_id);
        this.$swal.close();
      } catch (error) {
        this.$swal.close();
      }
      /*let budget = list?.filter((e) => e.id == this.selectedTask);
     this.code_plan = budget?.[0]?.code;
     this.plan_budget_id = budget?.[0]?.id;
     budget?.[0]?.actual_budget.forEach((item) => {
       item.pr_subject_label = item.pr_subject;
       item.pr_date_label = item.pr_date;
       item.po_subject_label = item.po_subject;
       item.po_name_label = item.po_name;
       item.po_date_label = item.po_date;
     });
     this.selectingPO = budget;

     this.currentPage = 1; // reset currect page table PO

     // if (type == 'yes') {
     this.viewRelocateSelected = budget?.[0]?.relocate;

      this.intExt = budget?.[0]?.relocate?.filter(
        (e) => e.relocate_type == "INT-EKS"
      );
      this.extInt = budget?.[0]?.relocate?.filter(
        (e) => e.relocate_type == "EKS-INT"
      );
      this.intInt = budget?.[0]?.relocate?.filter((e) =>
        e.relocate_type.includes("INT-INT")
      );
      */
      try {
        await this.$store.dispatch('budgetMonitor/GET_LIST_CONTRACT', budget?.[0]?.id);
      } catch (error) {
        console.error('Failed to fetch contract list:', error);
      }
    },

    addBudgetTask() {
      let scrollableDiv = document.getElementById('poScroll');
      scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
      this.selectingPO[0]?.actual_budget.push({
        code_plan_budget: this.code_plan,
        po_date: '',
        po_subject: '',
        po_value: '',
        pr_date: '',
        po_name: '',
        pr_value: '',
        actual_budget_item: [],
      });
      this.currentPage = this.totalPages;
      this.updateCurrentItems();
    },
    updateCurrentItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      this.currentItems = this.selectingPO[0]?.actual_budget.slice(start, end);
    },
    addNewRelocate() {
      if (this.tabNow == 'intExt') {
        if (this.type == 'opex') {
          this.intExt.push({
            code: this.code_plan,
            fund_center_id: '',
            fund_id: '',
            opex_gl_id: null,
            capex_gl_id: null,
            budget_task: '',
            delivery_date: '',
            relocate_value: '',
            im_number_id: '',
            options: [],
            type: '',
          });
        } else {
          this.intExt.push({
            code: this.code_plan,
            fund_center_id: '',
            fund_id: '',
            capex_gl_id: null,
            opex_gl_id: null,
            budget_task: '',
            delivery_date: '',
            relocate_value: '',
            im_number_id: '',
            options: [],
            type: '',
          });
        }
      } else if (this.tabNow == 'intInt') {
        if (this.type == 'opex') {
          this.intInt.push({
            code: this.code_plan,
            fund_center_id: '1',
            fund_id: '',
            opex_gl_id: null,
            capex_gl_id: null,
            budget_task: '',
            delivery_date: '',
            relocate_value: '',
            im_number_id: '',
            type: '',
            listTask: [],
            options: [],
          });
        } else {
          this.intInt.push({
            code: this.code_plan,
            fund_center_id: '1',
            fund_id: '',
            capex_gl_id: null,
            opex_gl_id: null,
            budget_task: '',
            delivery_date: '',
            relocate_value: '',
            type: '',
            im_number_id: '',
            listTask: [],
            options: [],
          });
        }
      } else if (this.tabNow == 'extInt') {
        if (this.type == 'opex') {
          this.extInt.push({
            code: this.code_plan,
            fund_center_id: null,
            fund_id: '',
            opex_gl_id: null,
            capex_gl_id: null,
            budget_task: '',
            delivery_date: '',
            type: '',
            relocate_value: '',
            im_number_id: '',
            options: [],
          });
        } else {
          this.extInt.push({
            code: this.code_plan,
            fund_center_id: null,
            fund_id: '',
            opex_gl_id: null,
            capex_gl_id: null,
            budget_task: '',
            delivery_date: '',
            relocate_value: '',
            type: '',
            im_number_id: '',
            options: [],
          });
        }
      }
    },
    newItem(data, code, index, status, cond, po_value, idActual) {
      let datas = data.actual_budget_item.map((item) => {
        return {
          ...item,
          listSes: [],
        };
      });
      this.idOfActual = idActual;
      this.code_actual = code;
      this.indexOfActual = index;
      this.statuss = status;
      this.isReview = cond;
      this.po_val = po_value;

      this.selectedBudgetItem = data;

      for (let i = 0; i < datas.length; i++) {
        // if (datas[i].ses_gr_no_subject || datas[i].ses_gr_n) {
        //     // If ses_gr_no_subject has value, skip this iteration
        //     continue;
        // }

        if (this.type === 'opex') {
          const vendor_n = datas[i].vendor_n ? datas[i].vendor_n.replace(/^\d+\s*-\s*/, '') : null;
          if (vendor_n) {
            try {
              axiosIns.get(`${axiosIns.defaults.baseURL}/ses-gr-by-vendor/${vendor_n}`).then((resp) => {
                const sesData = resp.data.data || [];
                datas[i].listSes = Array.from(new Map(sesData.map((x) => [x.grses_number, x])).values());
              });
            } catch (error) {
              console.error(`Failed to fetch data for vendor ${vendor_n}:`, error);
            }
          } else {
            console.log(`Skipping vendor with undefined or empty vendor_name at index ${i}`);
          }
        } else {
          const vendor_name = datas[i].vendor_name ? datas[i].vendor_name.replace(/^\d+\s*-\s*/, '') : null;
          if (vendor_name) {
            try {
              axiosIns.get(`${axiosIns.defaults.baseURL}/ses-gr-by-vendor/${vendor_name}`).then((resp) => {
                const sesData = resp.data.data || [];
                datas[i].listSes = Array.from(new Map(sesData.map((x) => [x.grses_number, x])).values());
              });
            } catch (error) {
              console.error(`Failed to fetch data for vendor ${vendor_name}:`, error);
            }
          } else {
            console.log(`Skipping vendor with undefined or empty vendor_name at index ${i}`);
          }
        }
      }

      this.actualItem = datas;
      setTimeout(() => {
        this.$bvModal.show('modalBudgetItem');
      }, 500);
    },

    pushNewItem() {
      if (this.type == 'opex') {
        this.actualItem.push({
          code_act: this.code_actual,
          listSes: [],
          bast_subject: null,
          bast_date: null,
          ses_gr_no_subject: null,
          inv_subject: null,
          vendor_name: null,
          dpp: '',
          vat: 0,
          after_tax: 0,
          wht: '',
          net_value: null,
          fa_form: null,
          doc_to_fa: null,
          payment_date: null,
        });
      } else {
        this.actualItem.push({
          code_actual_budge: this.code_actual,
          bast_subject: null,
          listSes: [],
          bast_date: null,
          ses_gr_no_subject: null,
          inv_subject: null,
          vendor_name: null,
          dpp: '',
          vat: 0,
          after_tax: 0,
          wht: '',
          net_value: null,
          fa_form: null,
          doc_to_fa: null,
          payment_date: null,
        });
      }
    },

    saveActualItem() {
      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to save changes?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          this.loadingSave = true;
          let send = [];
          if (this.type == 'opex') {
            for (let i = 0; i < this.actualItem.length; i++) {
              if (this.actualItem[i].hasOwnProperty('id')) {
                send.push({
                  code_actual_budget: this.actualItem[i].code_act,
                  id: this.actualItem[i].id,
                  bast_subject: this.actualItem[i].bast_sub,
                  bast_date: this.actualItem[i].bast_dat,
                  ses_gr_no_subject: this.actualItem[i].ses_gr_n,
                  inv_subject: this.actualItem[i].inv_subj,
                  vendor_name: this.actualItem[i].vendor_n,
                  dpp: this.actualItem[i].dpp,
                  vat: this.actualItem[i].vat,
                  after_tax: this.actualItem[i].after_ta,
                  wht: this.actualItem[i].wht,
                  net_value: this.actualItem[i].net_valu,
                  fa_form_no: this.actualItem[i].fa_form,
                  doc_to_fa: this.actualItem[i].doc_to_f,
                  payment_date: this.actualItem[i].payment_,
                });
              } else {
                send.push({
                  code_actual_budget: this.actualItem[i].code_act,
                  bast_subject: this.actualItem[i].bast_sub,
                  bast_date: this.actualItem[i].bast_dat,
                  ses_gr_no_subject: this.actualItem[i].ses_gr_n,
                  inv_subject: this.actualItem[i].inv_subj,
                  vendor_name: this.actualItem[i].vendor_n,
                  dpp: this.actualItem[i].dpp,
                  vat: this.actualItem[i].vat,
                  after_tax: this.actualItem[i].after_ta,
                  wht: this.actualItem[i].wht,
                  net_value: this.actualItem[i].net_valu,
                  fa_form_no: this.actualItem[i].fa_form,
                  doc_to_fa: this.actualItem[i].doc_to_f,
                  payment_date: this.actualItem[i].payment_,
                });
              }
            }
            this.$store
              .dispatch('budgetMonitor/SAVE_ACTUAL_ITEM', {
                datas: send,
              })
              .then(() => {
                axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/gl_code/${this.type}/${this.opexSelected}`).then((resp) => {
                  this.listBudget = resp.data.data;
                  this.selectingPO = resp.data.data?.filter((e) => e.id == this.selectedTask);
                  this.selectingPO[0]?.actual_budget?.forEach((item) => {
                    item.pr_subject_label = item.pr_subject;
                    item.pr_date_label = item.pr_date;
                    item.po_subject_label = item.po_subject;
                    item.po_name_label = item.po_name;
                    item.po_date_label = item.po_date;
                  });
                  let selectedActual = this.selectingPO[0]?.actual_budget?.filter((e) => e.id == this.idOfActual);
                  this.actualItem = selectedActual[0]?.actual_budget_item;
                  this.loadingSave = false;
                });
              })
              .catch((err) => {
                this.loadingSave = false;
                this.$swal('Error', err.response.data.error, 'error');
              });
          } else {
            for (let i = 0; i < this.actualItem.length; i++) {
              if (this.actualItem[i].hasOwnProperty('id')) {
                send.push({
                  code_actual_budget: this.actualItem[i].code_actual_budge,
                  id: this.actualItem[i].id,
                  bast_subject: this.actualItem[i].bast_subject,
                  bast_date: this.actualItem[i].bast_date,
                  ses_gr_no_subject: this.actualItem[i].ses_gr_no_subject,
                  inv_subject: this.actualItem[i].inv_subject,
                  vendor_name: this.actualItem[i].vendor_name,
                  dpp: this.actualItem[i].dpp,
                  vat: this.actualItem[i].vat,
                  after_tax: this.actualItem[i].after_tax,
                  wht: this.actualItem[i].wht,
                  net_value: this.actualItem[i].net_value,
                  fa_form_no: this.actualItem[i].fa_form,
                  doc_to_fa: this.actualItem[i].doc_to_fa,
                  payment_date: this.actualItem[i].payment_date,
                });
              } else {
                send.push({
                  code_actual_budget: this.actualItem[i].code_actual_budge,
                  bast_subject: this.actualItem[i].bast_subject,
                  bast_date: this.actualItem[i].bast_date,
                  ses_gr_no_subject: this.actualItem[i].ses_gr_no_subject,
                  inv_subject: this.actualItem[i].inv_subject,
                  vendor_name: this.actualItem[i].vendor_name,
                  dpp: this.actualItem[i].dpp,
                  vat: this.actualItem[i].vat,
                  after_tax: this.actualItem[i].after_tax,
                  wht: this.actualItem[i].wht,
                  net_value: this.actualItem[i].net_value,
                  fa_form_no: this.actualItem[i].fa_form,
                  doc_to_fa: this.actualItem[i].doc_to_fa,
                  payment_date: this.actualItem[i].payment_date,
                });
              }
            }
            this.$store
              .dispatch('budgetMonitor/SAVE_ACTUAL_ITEM', {
                datas: send,
              })
              .then(() => {
                axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/gl_code/${this.type}/${this.capexSelected}`).then((resp) => {
                  this.listBudget = resp.data.data;
                  this.selectingPO = resp.data.data?.filter((e) => e.id == this.selectedTask);
                  this.selectingPO[0]?.actual_budget?.forEach((item) => {
                    item.pr_subject_label = item.pr_subject;
                    item.pr_date_label = item.pr_date;
                    item.po_subject_label = item.po_subject;
                    item.po_name_label = item.po_name;
                    item.po_date_label = item.po_date;
                  });
                  let selectedActual = this.selectingPO[0]?.actual_budget?.filter((e) => e.id == this.idOfActual);
                  this.actualItem = selectedActual[0]?.actual_budget_item;
                  this.loadingSave = false;
                });
              })
              .catch((err) => {
                this.loadingSave = false;
                this.$swal('Error', err.response.data.error, 'error');
              });
          }
          this.resetFormDetailPayment();
        }
      });
    },

    closePO(id) {
      this.$swal({
        title: 'Are you sure? ',
        text: 'Do you want to close this PO?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          this.loadingSave = true;
          this.$store.dispatch('budgetMonitor/CLOSE_PO', id).then((resp) => {
            axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/gl_code/${this.type}/${this.opexSelected}`).then((resp) => {
              this.$swal('Success', 'PO has been Closed', 'success');
              this.listBudget = resp.data.data;
              this.selectingPO = resp.data.data?.filter((e) => e.id == this.selectedTask);
              this.loadingSave = false;
            });
          }).finally(() => {
            this.loadingSave = false;
          });
        }
      });
    },

    onHide() {
      this.selectedTask = '';
      this.viewRelocateSelected = [];
      this.searchQuery = '';
      this.currentPage = 1;
    },
    filterFund(evt, indx) {
      this.resetPlanRelocateFields(['im_number_id', 'im_projects_id', 'im_projects_relocates_id']);
      this.formPlanRelocate.new_gl_number = '';
      this.formPlanRelocate.new_budget_task = '';
      if (this.formPlanRelocate.origin_budget_task && this.formPlanRelocate.origin_budget_task.trim()) {
        this.formPlanRelocate.origin_budget_task = '';
      }
      if (this.tabNow === 'intExt') {
        this.fundByOPEX = [];
        this.fundByCAPEX = [];
        this.formPlanRelocate.type = '';
        this.formPlanRelocate.new_gl_number = '';
        this.listGLNumber = [];
        this.listBudgetTask = [];
        const fund = this.listFundCenter.find((i) => i.id === this.formPlanRelocate.dept_recipient)?.fund_center;
        this.getOpexCapexFilter(fund?.substring(1) || null);
      } else if (this.tabNow === 'intInt') {
        if (this.type === 'opex') {
          this.intExt[indx].type = '';
          this.intExt[indx].opex_gl_id = '';
          this.intExt[indx].capex_gl_id = '';
        } else {
          this.intExt[indx].type = '';
          this.intExt[indx].opex_gl_id = '';
          this.intExt[indx].capex_gl_id = '';
        }
      } else if (this.tabNow === 'extInt') {
        this.listBudgetTask = [];
        this.fundByOPEX = [];
        this.fundByCAPEX = [];
        this.formPlanRelocate.type = '';
        this.formPlanRelocate.new_gl_number = '';
        this.listGLNumber = [];
        const fund = this.listFundCenter.find((i) => i.id === this.formPlanRelocate.dept_from)?.fund_center;
        this.getOpexCapexFilter(fund?.substring(1) || null);
      }
    },

    selectedFund(evt, index, type) {
      this.resetPlanRelocateFields(['im_number_id', 'im_projects_id', 'im_projects_relocates_id']);
      let dtas;
      this.listBudgetTask = [];
      this.formPlanRelocate.new_budget_task = '';
      if (this.formPlanRelocate.origin_budget_task && this.formPlanRelocate.origin_budget_task.trim()) {
        this.formPlanRelocate.origin_budget_task = '';
      }
      if (type === 'OPEX') {
        dtas = this.fundByOPEX?.filter((e) => e.id === evt);
        this.listBudgetTask = dtas[0]?.budget_task || [];
      } else {
        dtas = this.fundByCAPEX?.filter((e) => e.id === evt);
        this.listBudgetTask = dtas[0]?.budget_task || [];
      }
      if (this.tabNow === 'intExt') {
        this.formPlanRelocate.new_fund_number = dtas[0]?.fund.id;
        this.formPlanRelocate.new_fund_number_label_fund = dtas[0]?.fund?.fund;
      } else if (this.tabNow === 'intInt') {
        this.loadingTask = true;
        this.formPlanRelocate.new_fund_number = dtas[0]?.fund.id;
        this.formPlanRelocate.new_fund_number_label_fund = dtas[0]?.fund?.fund;
      } else if (this.tabNow === 'extInt') {
        this.formPlanRelocate.new_fund_number = dtas[0]?.fund?.id;
        this.formPlanRelocate.new_fund_number_label_fund = dtas[0]?.fund?.fund;
      }
    },
    deptFrom(data) {
      let datas = data?.filter((e) => e.id == '1');
      return datas?.length > 0 ? datas[0]?.department_code : ''; // Hindari error jika data kosong
    },

    deptFromId(data) {
      let datas = data?.filter((e) => e.id === '1');
      return datas?.length > 0 ? datas[0]?.id : ''; // Hindari error jika data kosong
    },

    checkTabs(type) {
      this.tabNow = type;
      if (type == 'intInt') {
        // this?.filterFund(1)
      }
      if (type == 'extInt') {
        this.extLabel = true;
      } else {
        this.extLabel = false;
      }
    },

    removeRow(index) {
      if (this.tabNow == 'intExt') {
        this.intExt.splice(index, 1);
      } else if (this.tabNow == 'intInt') {
        this.intInt.splice(index, 1);
      } else if (this.tabNow == 'extInt') {
        this.extInt.splice(index, 1);
      }
    },

    isIntExt(data) {
      return data?.filter((e) => e.relocate_type == 'INT-EKS');
    },
    isIntInt(data) {
      return data?.filter((e) => e.relocate_type.includes('INT-INT'));
    },
    isExtInt(data) {
      return data?.filter((e) => e.relocate_type == 'EKS-INT');
    },

    //get API
    getListBoxOpexRealization(planId, fundCenterId) {
      if (planId && fundCenterId) {
        this.$store.dispatch('ttAccount/GET_LIST_BOX_OPEX_REALIZATION', {
          planId: planId,
          fundCenterId: fundCenterId,
        });
      }
    },
    getListBoxCapexRealization(planId, fundCenterId) {
      this.$store.dispatch('ttAccount/GET_LIST_BOX_CAPEX_REALIZATION', {
        planId: planId,
        fundCenterId: fundCenterId,
      });
    },
    getTTAccount() {
      this.$store.dispatch('ttAccount/GET_LIST_ACCOUNT', {
        pageNumber: 1,
        pageSize: 1000,
        search: 'Opex',
      });
    },
    getBudgetItem() {
      this.$store.dispatch('opexGL/GET_LIST_DATA', {
        pageNumber: 1,
        pageSize: 1000,
      });
    },
    getCapexGL() {
      this.$store.dispatch('capexGL/GET_LIST_DATA', {
        pageNumber: 1,
        pageSize: 1000,
      });
    },
    sharePlan(id, type) {
      (this.bodyShare.entity_id = id), (this.bodyShare.entity_type = type);
      axiosIns.get(`${axiosIns.defaults.baseURL}/users/viewer/${this.bodyShare.entity_type}/${this.bodyShare.entity_id}`).then((resp) => {
        this.listViewer = resp.data.data;
        this.$bvModal.show('modal-share');
      });
    },
    shares(id) {
      this.bodyShare.user_id = id;
      setTimeout(() => {
        this.$store.dispatch('role/SHARE_BUDGET_PLAN', this.bodyShare).then(() => {
          this.$swal
            .mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', this.$swal.stopTimer);
                toast.addEventListener('mouseleave', this.$swal.resumeTimer);
              },
            })
            .fire({
              icon: 'success',
              title: 'Action Success',
            });
          axiosIns.get(`${axiosIns.defaults.baseURL}/users/viewer/${this.bodyShare.entity_type}/${this.bodyShare.entity_id}`).then((resp) => {
            this.listViewer = resp.data.data;
          });
        });
      }, 100);
    },
    unshares(id) {
      // this.bodyShare.user_id = id
      setTimeout(() => {
        this.$store.dispatch('role/UNSHARE_BUDGET_PLAN', id).then(() => {
          this.$swal
            .mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', this.$swal.stopTimer);
                toast.addEventListener('mouseleave', this.$swal.resumeTimer);
              },
            })
            .fire({
              icon: 'success',
              title: 'Action Success',
            });
          axiosIns.get(`${axiosIns.defaults.baseURL}/users/viewer/${this.bodyShare.entity_type}/${this.bodyShare.entity_id}`).then((resp) => {
            this.listViewer = resp.data.data;
          });
        });
      }, 100);
    },

    filteredPO(data) {
      // Ensure `data` exists and is an array
      if (!Array.isArray(data)) return [];

      // Split and trim search queries
      const searchQueries = this.searchQuery
        .toLowerCase()
        .split(',')
        .map((query) => query.trim());

      // Filter the data based on search queries
      let filteredData = data?.filter((item) => {
        const poName = item.po_name_label?.toLowerCase() ?? '';
        const poSubject = item.po_subject_label?.toLowerCase() ?? '';
        const prSubject = item.pr_subject_label?.toLowerCase() ?? '';

        return searchQueries.some((query) => poName.includes(query) || poSubject.includes(query) || prSubject.includes(query));
      });

      // Sorting logic for different fields
      const sortByDate = (key, order) => {
        filteredData.sort((a, b) => {
          const dateA = new Date(a[key]);
          const dateB = new Date(b[key]);

          // Handle invalid dates
          if (isNaN(dateA) && !isNaN(dateB)) return 1;
          if (!isNaN(dateA) && isNaN(dateB)) return -1;
          if (isNaN(dateA) && isNaN(dateB)) return 0;

          return order === 'asc' ? dateA - dateB : dateB - dateA;
        });
      };

      const sortByString = (key, order) => {
        filteredData.sort((a, b) => {
          const strA = a[key]?.toLowerCase() ?? '';
          const strB = b[key]?.toLowerCase() ?? '';

          return order === 'asc' ? strA.localeCompare(strB) : strB.localeCompare(strA);
        });
      };

      const sortByNumericString = (key, order) => {
        filteredData.sort((a, b) => {
          const strA = a[key] ?? '';
          const strB = b[key] ?? '';

          return order === 'asc'
            ? strA.localeCompare(strB, undefined, {
                numeric: true,
              })
            : strB.localeCompare(strA, undefined, {
                numeric: true,
              });
        });
      };

      // Apply sorting based on the conditions
      if (this.sortPRDate) sortByDate('pr_date', this.sortPRDate);
      if (this.sortPODate) sortByDate('po_date', this.sortPODate);
      if (this.sortPRNumber) sortByNumericString('pr_subject', this.sortPRNumber);
      if (this.sortPONumber) sortByNumericString('po_subject', this.sortPONumber);
      if (this.sortPOName) sortByString('po_name', this.sortPOName);

      // Return the filtered (and sorted) data
      return filteredData;
    },

    dppCalculation(dpp, wht, vat, index, property) {
      let body = {};
      if (property == 'dpp') {
        body = {
          dpp: dpp,
        };
      } else {
        body = {
          dpp: dpp,
          wht: wht,
          vat: vat,
        };
      }

      axiosIns.post(`${axiosIns.defaults.baseURL}/calculate-dpp`, body).then((resp) => {
        let respond = resp.data.data;
        if (this.type == 'opex') {
          this.actualItem[index].vat = respond.vat;
          this.actualItem[index].after_ta = respond.after_tax;
          this.actualItem[index].wht = respond.wht;
          this.actualItem[index].net_valu = respond.net_value;
        } else {
          this.actualItem[index].vat = respond.vat;
          this.actualItem[index].after_tax = respond.after_tax;
          this.actualItem[index].wht = respond.wht;
          this.actualItem[index].net_value = respond.net_value;
        }
        this.$swal
          .mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', this.$swal.stopTimer);
              toast.addEventListener('mouseleave', this.$swal.resumeTimer);
            },
          })
          .fire({
            icon: 'success',
            title: 'Data has been calculated',
          });
      });
    },
    async newDppCalculation(dpp, wht, vat, property) {
      let body = {};
      if (property == 'dpp') {
        body = {
          dpp: Number(dpp) || 0,
        };
      } else {
        body = {
          dpp: Number(dpp) || 0,
          wht: Number(wht) || 0,
          vat: Number(vat) || 0,
        };
      }

      try {
        const resp = await axiosIns.post(`${axiosIns.defaults.baseURL}/calculate-dpp`, body);
        const respond = resp.data.data;

        this.formDetailPayment.vat = respond?.vat || 0;
        this.formDetailPayment.after_tax = respond?.after_tax || 0;
        this.formDetailPayment.wht = respond?.wht || 0;
        this.formDetailPayment.net_value = respond?.net_value || 0;

        this.$swal
          .mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', this.$swal.stopTimer);
              toast.addEventListener('mouseleave', this.$swal.resumeTimer);
            },
          })
          .fire({
            icon: 'success',
            title: 'Data has been calculated',
            text: 'Data After tax & Net Value',
          });
      } catch (error) {
        console.error('Calculation failed:', error);
        this.formDetailPayment.vat = 0;
        this.formDetailPayment.after_tax = 0;
        this.formDetailPayment.wht = 0;
        this.formDetailPayment.net_value = 0;
        this.formDetailPayment.dpp = 0;
      }
    },
    hideDetail() {
      for (let i = this.actualItem.length - 1; i >= 0; i--) {
        if (!this.actualItem[i].hasOwnProperty('id')) {
          this.actualItem.splice(i, 1);
        }
      }
    },

    validateDeptFrom(indx) {
      if (this.extInt[indx].fund_center_id == null) {
        return '';
      } else {
        return 'required';
      }
    },
    changeGLNew(evt, dept) {
      this.formPlanRelocate.new_gl_number = '';
      this.listGLNumber = [];
      this.listBudgetTask = [];
      this.formPlanRelocate.new_budget_task = '';
      if (this.formPlanRelocate.origin_budget_task && this.formPlanRelocate.origin_budget_task.trim()) {
        this.formPlanRelocate.origin_budget_task = '';
      }
      if (this.tabNow === 'intExt') {
        if (evt === 'OPEX') {
          this.listGLNumber = this.fundByOPEX;
        } else {
          this.listGLNumber = this.fundByCAPEX;
        }
      } else if (this.tabNow === 'intInt') {
        if (evt === 'OPEX') {
          this.listGLNumber = this.fundByOPEX;
        } else {
          this.listGLNumber = this.fundByCAPEX;
        }
      } else if (this.tabNow === 'extInt') {
        if (evt === 'OPEX') {
          this.listGLNumber = this.fundByOPEX;
        } else {
          this.listGLNumber = this.fundByCAPEX;
        }
      }
    },

    changeGL(evt, indx, dept) {
      if (this.tabNow == 'intExt') {
        if (evt == 'OPEX') {
          let first = this.fundByOPEX;
          let second = first?.filter((e) => e.fund.fund_center_id == dept);
          this.intExt[indx].options = second;
        } else {
          let first = this.fundByCAPEX;
          let second = first?.filter((e) => e.fund.fund_center_id == dept);
          this.intExt[indx].options = second;
        }
      } else if (this.tabNow == 'intInt') {
        if (evt == 'OPEX') {
          let first = this.fundByOPEX;
          let second = first?.filter((e) => e.fund.fund_center_id == dept);
          this.intInt[indx].options = second;
        } else {
          let first = this.fundByCAPEX;
          let second = first?.filter((e) => e.fund.fund_center_id == dept);
          this.intInt[indx].options = second;
        }
      } else if (this.tabNow == 'extInt') {
        if (evt == 'OPEX') {
          let first = this.fundByOPEX;
          let second = first?.filter((e) => e.fund.fund_center_id == dept);
          this.extInt[indx].options = second;
        } else {
          let first = this.fundByCAPEX;
          let second = first?.filter((e) => e.fund.fund_center_id == dept);
          this.extInt[indx].options = second;
        }
      }
    },
    typeOf() {
      if (this.type === 'opex') {
        if (this.tabNow === 'intExt') {
          //return ['OPEX'];
          return ['OPEX', 'CAPEX'];
        } else if (this.tabNow === 'intInt') {
          //return ['OPEX'];
          return ['OPEX', 'CAPEX'];
        } else if (this.tabNow === 'extInt') {
          return ['OPEX', 'CAPEX'];
        }
      } else if (this.type === 'capex') {
        if (this.tabNow === 'intExt') {
          return ['OPEX', 'CAPEX'];
        } else if (this.tabNow === 'intInt') {
          return ['OPEX', 'CAPEX'];
        } else if (this.tabNow === 'extInt') {
          //return ['CAPEX'];
          return ['OPEX', 'CAPEX'];
        }
      }
    },
    sortingPRDate() {
      this.sortPODate = 'none';
      this.sortPOName = 'none';
      this.sortPRNumber = 'none';
      this.sortPONumber = 'none';
      if (this.sortPRDate === 'none') {
        this.sortPRDate = 'asc';
      } else if (this.sortPRDate === 'asc') {
        this.sortPRDate = 'desc';
      } else if (this.sortPRDate === 'desc') {
        this.sortPRDate = 'none';
      }
    },
    sortingPODate() {
      this.sortPRDate = 'none';
      this.sortPOName = 'none';
      this.sortPRNumber = 'none';
      this.sortPONumber = 'none';
      if (this.sortPODate === 'none') {
        this.sortPODate = 'asc';
      } else if (this.sortPODate === 'asc') {
        this.sortPODate = 'desc';
      } else if (this.sortPODate === 'desc') {
        this.sortPODate = 'none';
      }
    },
    sortingPRNumber() {
      this.sortPRDate = 'none';
      this.sortPODate = 'none';
      this.sortPOName = 'none';
      this.sortPONumber = 'none';
      if (this.sortPRNumber === 'none') {
        this.sortPRNumber = 'asc';
      } else if (this.sortPRNumber === 'asc') {
        this.sortPRNumber = 'desc';
      } else if (this.sortPRNumber === 'desc') {
        this.sortPRNumber = 'none';
      }
    },

    sortingPOName() {
      this.sortPRDate = 'none';
      this.sortPODate = 'none';
      this.sortPRNumber = 'none';
      this.sortPONumber = 'none';
      if (this.sortPOName === 'none') {
        this.sortPOName = 'asc';
      } else if (this.sortPOName === 'asc') {
        this.sortPOName = 'desc';
      } else if (this.sortPOName === 'desc') {
        this.sortPOName = 'none';
      }
    },
    sortingPONumber() {
      this.sortPRDate = 'none';
      this.sortPODate = 'none';
      this.sortPRNumber = 'none';
      this.sortPOName = 'none';
      if (this.sortPONumber === 'none') {
        this.sortPONumber = 'asc';
      } else if (this.sortPONumber === 'asc') {
        this.sortPONumber = 'desc';
      } else if (this.sortPONumber === 'desc') {
        this.sortPONumber = 'none';
      }
    },
    filteredItems(dat) {
      const searchQuery = this.body.search.toLowerCase();
      return dat?.filter((item) => item.fullname.toLowerCase().includes(searchQuery));
    },
    toggleAllIds() {
      if (this.allSelected) {
        // Deselect all
        this.selectedIds = [];
      } else {
        // Select all IDs from current page
        this.selectedIds = this.filteredsPO.map((item) => item.id);
      }
      this.allSelected = !this.allSelected;
    },
    sendEmail() {
      // Email validation function
      const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      };

      // Validate `to` and `cc` fields
      const invalidToEmails = this.bodyEmail.to?.filter((email) => !isValidEmail(email));
      const invalidCcEmails = this.bodyEmail.cc?.filter((email) => !isValidEmail(email));

      if (invalidToEmails.length > 0 || invalidCcEmails.length > 0) {
        this.$swal('Error', "Please ensure all emails in 'To' and 'CC' fields are email format.", 'error');
        return;
      }

      if (this.bodyEmail.to.length < 1 || this.bodyEmail.cc < 1) {
        this.$swal('Error', "Please ensure all emails in 'To' and 'CC' fields is not empty.", 'error');
        return;
      }
      this.$swal({
        title: 'Are you sure want to send PO to this email?',
        // text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          this.loadingSave = true;
          this.bodyEmail.id = this.selectedIds;
          this.$store
            .dispatch('budgetMonitor/SEND_EMAIL_PO', this.bodyEmail)
            .then((resp) => {
              axiosIns.get(`${axiosIns.defaults.baseURL}/monitoring/gl_code/${this.type}/${this.opexSelected}`).then((resp) => {
                this.listBudget = resp.data.data;
                this.selectingPO = resp.data.data?.filter((e) => e.id == this.selectedTask);
                this.loadingSave = false;
                this.isLoading = false;
                this.selectedIds = [];
                this.bodyEmail = {
                  to: ['yusak-putra@borneo-indobara.com', 'muhammad.krismansyah@borneo-indobara.com'],
                  cc: ['budget-bib@sinarmasmining.com', `${this.emails}`],
                  id: [],
                };
                this.$bvModal.hide('modal-email');
                this.searchBudget();
                this.$swal
                  .mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                      toast.addEventListener('mouseenter', this.$swal.stopTimer);
                      toast.addEventListener('mouseleave', this.$swal.resumeTimer);
                    },
                  })
                  .fire({
                    icon: 'success',
                    title: 'Success send PO to Email',
                  });
              });
            })
            .catch((err) => {
              this.loadingSave = false;
              this.$swal
                .mixin({
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer);
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer);
                  },
                })
                .fire({
                  icon: 'error',
                  title: `${err.response.data.error}`,
                });
            })
            .catch((err) => {
              this.isLoading = false;
              this.loadingSave = false;
              this.$swal('Error', err.response.data.error, 'error');
            });
        }
      });
    },
    emailForm() {
      this.bodyEmail.cc = ['budget-bib@sinarmasmining.com', `${this.emails}`];
    },
    async searchSES(index, event) {
      if (!event) return;
      const result = event.replace(/^\d+\s*-\s*/, '');

      try {
        const resp = await axiosIns.get(`${axiosIns.defaults.baseURL}/ses-gr-by-vendor/${result}`);
        const sesData = resp.data.data || [];

        const swalMixin = this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', this.$swal.stopTimer);
            toast.addEventListener('mouseleave', this.$swal.resumeTimer);
          },
        });

        if (sesData && sesData.length > 0) {
          swalMixin.fire({
            icon: 'success',
            title: 'Get List SES/GR Number successfully',
          });
          this.formDetailPayment.isFieldDppCalculationDisabled = true;
        } else {
          swalMixin.fire({
            icon: 'error',
            title: 'No SES/GR Number data found',
          });
        }

        // this.actualItem[index].listSes = Array.from(
        //   new Map(sesData.map(i => [i.grses_number, i])).values()
        // );
        // New List SES/GR Number
        this.listSesGrNumber = Array.from(new Map(sesData.map((i) => [i.grses_number, i])).values());
      } catch (error) {
        console.error(`Failed to fetch SES data for vendor ${result}:`, error);
        // this.actualItem[index].listSes = []; // Kosongkan list jika error
        this.listSesGrNumber = [];
      }
    },
    inputDatesAmount(type, data, index) {
      if (!data) return;

      axiosIns
        .get(`${axiosIns.defaults.baseURL}/date-by-ses-gr/${data}`)
        .then((resp) => {
          if (resp.data.data == null) {
            this.resetFormDetailPaymentDetail();
            this.$swal.fire({
              icon: 'error',
              title: 'No date data found',
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });

            this.formDetailPayment.isFieldDppCalculationDisabled = false;
          } else {
            this.formDetailPayment.isFieldDppCalculationDisabled = true;

            if (type === 'opex') {
              // Dates
              this.formDetailPayment.fa_form_date = resp.data.data['FA FROM DATE'];
              this.formDetailPayment.doc_to_fa_date = resp.data.data['DOC TO FA DATE'];
              this.formDetailPayment.payment_date = resp.data.data['PAYMENT DATE'];
              // Amount
              this.formDetailPayment.dpp = resp.data.data?.dpp_amount;
              this.formDetailPayment.wht = resp.data.data?.wht_amount;

              // Calculate DPP
              this.newDppCalculation(resp.data.data?.dpp_amount, resp.data.data?.wht_amount, this.formDetailPayment.vat, 'dpp');
            } else {
              // Dates
              this.formDetailPayment.fa_form_date = resp.data.data['FA FROM DATE'];
              this.formDetailPayment.doc_to_fa_date = resp.data.data['DOC TO FA DATE'];
              this.formDetailPayment.payment_date = resp.data.data['PAYMENT DATE'];
              // Amount
              this.formDetailPayment.dpp = resp.data.data?.dpp_amount;
              this.formDetailPayment.wht = resp.data.data?.wht_amount;

              // Calculate DPP
              this.newDppCalculation(resp.data.data?.dpp_amount, resp.data.data?.wht_amount, this.formDetailPayment.vat, 'dpp');
            }
            this.$swal.fire({
              icon: 'success',
              title: 'Date data loaded successfully',
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        })
        .catch((error) => {
          this.$swal.fire({
            icon: 'error',
            title: 'Error loading date data',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
    searchVendors(search) {
      if (!search) {
        this.filteredVendors = this.vendorList.slice(0, 10);
        return;
      }
      setTimeout(() => {
        this.filteredVendors = this.vendorList?.filter((vendor) => vendor.toLowerCase().includes(search.toLowerCase()));
      }, 300);
    },
    relocateds(s) {
      if (s === 'INT-INT-FROM') {
        return 'OUT';
      } else {
        return 'IN';
      }
    },
    handleSelectedVendor(index, value) {
      this.formDetailPayment.ses_gr_number = '';
      this.listSesGrNumber = [];
      this.searchSES(index, value);
      this.addVendor(value);
      this.resetFormDetailPaymentDetail();
    },
    addVendor(value) {
      if (value) {
        if (!this.filteredVendors.some((item) => item === value)) {
          this.filteredVendors.push(value);
        }
        this.formDetailPayment.vendor_name = value;
      }
    },
    handleSelectedSesGrNumber(type, value, index) {
      const selected = value?.grses_number || value;
      this.inputDatesAmount(type, selected, index);
      this.addSesGrNumber(selected);
      this.resetFormDetailPaymentDetail();
    },
    addSesGrNumber(value) {
      if (value) {
        if (!this.listSesGrNumber.some((item) => item.grses_number === value)) {
          this.listSesGrNumber.push({ grses_number: value });
        }
        this.formDetailPayment.ses_gr_number = value;
      }
    },
    resetFormDetailPaymentDetail() {
      this.formDetailPayment.fa_form_date = null;
      this.formDetailPayment.doc_to_fa_date = null;
      this.formDetailPayment.payment_date = null;

      this.formDetailPayment.dpp = 0;
      this.formDetailPayment.wht = 0;
      this.formDetailPayment.vat = 0;
      this.formDetailPayment.after_tax = 0;
      this.formDetailPayment.net_value = 0;
    },
    async openUcontractPage() {
      await this.$store.dispatch('budgetMonitor/GET_USER_UCONTRACT_DEPARTMENTS');
      const departments = this.$store.getters['budgetMonitor/listUcontractDepartments'].map((item) => item.code);

      if (departments.length > 0 && departments.includes(this.activePlan?.fund_center?.fund_center)) {
        window.open(`${this.uContractUrl}&department=${this.activePlan?.fund_center?.fund_center}`, '_blank');
      } else {
        this.$swal.fire({
          title: 'Error',
          text: `Department ${this.activePlan?.fund_center?.department_name} not assigned to user in Ucontract. Please contact Digitech for further assistance.`,
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    },
    selectTaskRelocate() {
      this.formPlanRelocate.im_category = 'Budget Relocation Statement (BRS)';
      this.resetPlanRelocateFields(['im_number_id', 'im_projects_id', 'im_projects_relocates_id']);
      this.getIM();
    },
    preventModalClose(evt) {
      if (evt.trigger === 'backdrop') {
        evt.preventDefault();
      }
    },
    resetPlanRelocateFields(fields = []) {
      for (const field of fields) {
        this.formPlanRelocate[field] = '';
      }
    },
    selectImRelocate() {
      this.formPlanRelocate.relocation_value = this.selectedImRelocateValue || '0';
    },
    limitTenCharacters(type) {
      if (type == 'prNumber') {
        if (this.formExpanses.prNumber.length > 10) {
          this.formExpanses.prNumber = this.formExpanses.prNumber.slice(0, 10);
        }
      }
      if (type == 'poNumber') {
        if (this.formExpanses.poNumber.length > 10) {
          this.formExpanses.poNumber = this.formExpanses.poNumber.slice(0, 10);
        }
      }
    },
    getMonthName(month) {
      switch (month) {
        case 'jan':
          return 'January';
        case 'feb':
          return 'February';
        case 'mar':
          return 'March';
        case 'apr':
          return 'April';
        case 'may':
          return 'May';
        case 'jun':
          return 'June';
        case 'jul':
          return 'July';
        case 'aug':
          return 'August';
        case 'sep':
          return 'September';
        case 'oct':
          return 'October';
        case 'nov':
          return 'November';
        case 'dec':
          return 'December';
        default:
          return '-';
      }
    },
    handlePageChangeIntToExt(page) {
      this.filterIntToExt.currentPage = page;
    },
    handlePageChangeIntToInt(page) {
      this.filterIntToInt.currentPage = page;
    },
    handlePageChangeExtToInt(page) {
      this.filterExtToInt.currentPage = page;
    },
    resetFilterRelocate(filterName = null) {
      if (filterName == 'IntToExt') {
        this.filterIntToExt = {
          search: '',
          delivery_date: [],
          perPage: 5,
          currentPage: 1,
          totalRow: 0,
        };
      } else if (filterName == 'IntToInt') {
        this.filterIntToInt = {
          search: '',
          delivery_date: [],
          perPage: 5,
          currentPage: 1,
          totalRow: 0,
        };
      } else if (filterName == 'ExtToInt') {
        this.filterExtToInt = {
          search: '',
          delivery_date: [],
          perPage: 5,
          currentPage: 1,
          totalRow: 0,
        };
      } else {
        this.filterIntToExt = {
          search: '',
          delivery_date: [],
          perPage: 5,
          currentPage: 1,
          totalRow: 0,
        };
        this.filterIntToInt = {
          search: '',
          delivery_date: [],
          perPage: 5,
          currentPage: 1,
          totalRow: 0,
        };
        this.filterExtToInt = {
          search: '',
          delivery_date: [],
          perPage: 5,
          currentPage: 1,
          totalRow: 0,
        };
      }
    },
    async openModalDetailBRS(title, data) {
      this.detailBrs = {};
      this.formPlanRelocate.origin_budget_task = data.budget_task_code_to;
      this.formPlanRelocate.im_number_id = data.im_number_id;
      this.formPlanRelocate.im_projects_id = data.im_projects_id;
      this.formPlanRelocate.im_projects_relocates_id = data.im_projects_relocates_id;
      await this.getIM();
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const imData = {
        selectedImRelocate: this.selectedImRelocate,
        selectedImProject: this.listImProjects.find((e) => e.id == data.im_projects_id),
      };
      data.imData = imData;
      data.title = title;
      this.detailBrs = data;
      this.$bvModal.show('modal-detail-brs');
    },
  },
};
</script>

<style>
/* Input vue-select placeholder, remove opacity */
.vs--single.vs--open .vs__selected {
  opacity: 1 !important;
}

.sticky-header-po {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
}

.input-tag {
  background: #a23429 !important;
  color: white !important;
  border: 1px solid #a23429 !important;
  border-radius: 4px !important;
}

.input-tag > .remove {
  color: white !important;
}

/* Mengatur status badge */
.status-box {
  padding: 10px;
  display: inline-block;
  width: 100%;
}

.status-badge {
  color: white;
  padding: 5px 10px;
  border-radius: 15px;
  display: inline-block;
}

.status-on-going {
  background-color: #28a745; /* Green for On Going */
}

.status-closed {
  background-color: #6c757d; /* Gray for Closed */
}

.status-early-termination {
  background-color: #dc3545; /* Red for Early Termination */
}

.status-expired-soon {
  background-color: #ffc107; /* Yellow for Expired Soon */
}

.status-value-warning {
  background-color: #17a2b8; /* Blue for Value Warning */
}

/* Styling untuk file link */
.file-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  flex-direction: column;
}
a {
  margin-left: 10px;
}

a:hover {
  text-decoration: underline;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #e9ecef !important;
}

.table-relocate td:not(.field-action),
.table-pr-po td:not(.field-action) {
  white-space: normal !important;
  word-wrap: break-word !important;
}
.full-width-modal {
  min-width: 95vw !important;
  margin: 2.5% auto;
}
.auto-table {
  table-layout: auto; /* Automatic layout algorithm */
  width: 100%; /* The overall table width can still be set */
  border-collapse: collapse;
}
.auto-table,
.auto-table th,
.auto-table td {
  padding: 8px;
  white-space: nowrap;
}
</style>
